// This file is auto-generated by @hey-api/openapi-ts

export type ClientOptions = {
    baseUrl: string;
};

export type ProfileChangeName = {
    first?: string;
    last?: string;
};

export type ProfileGameStats = {
    games?: number;
    won?: number;
    lost?: number;
    wonPercent?: number;
    percent?: number;
};

export type ProfileGetStatisticsResponse = {
    tournaments?: number;
    stats?: ProfileGameStats;
    longestWinStreak?: ProfileStreak;
    longestLoseStreak?: ProfileStreak;
    currentStreak?: ProfileStreak;
    bestWin?: ProfileMatch;
    worstLoss?: ProfileMatch;
    mostMatches?: ProfileOppStats;
    mostWins?: ProfileOppStats;
    mostWinsPercent?: ProfileOppStats;
    mostLosses?: ProfileOppStats;
    mostLossesPercent?: ProfileOppStats;
    places?: {
        [key: string]: number;
    };
    maxRating?: RatingRating;
    ratingStart?: number;
    ratingEnd?: number;
    numberOpponents?: number;
    firstTournament?: ProfileTourney;
    lastTournament?: ProfileTourney;
    bySize?: {
        [key: string]: ProfileGameStats;
    };
};

export type ProfileListPlayerGamesResponse = {
    games?: Array<SharedGameFull>;
};

export type ProfileListPlayerOpponentsResponse = {
    opponents?: Array<ProfileOpponent>;
};

export type ProfileMatch = {
    id?: string;
    name?: string;
    ratingPlayer?: number;
    rating?: number;
    ratingLast?: number;
    total?: ProfileGameStats;
    playerVs?: ProfileGameStats;
    tourney?: ProfileTourney;
};

export type ProfileOppStats = {
    id?: string;
    name?: string;
    rating?: number;
    total?: ProfileGameStats;
    playerVs?: ProfileGameStats;
    firstGame?: ProfileTourney;
    lastGame?: ProfileTourney;
};

export type ProfileOpponent = {
    id?: string;
    player?: string;
    location?: string;
    rank?: string;
    stats?: ProfileGameStats;
};

export type ProfileProfile = {
    id?: string;
    rank?: string;
    photoUrl?: string;
    email?: string;
    place?: number;
    form?: RatingForm;
    lastUpdate?: string;
};

export type ProfileStreak = {
    games?: number;
    start?: string;
    end?: string;
    win?: boolean;
};

export type ProfileTourney = {
    tid?: string;
    title?: string;
    start?: string;
};

/**
 * `Any` contains an arbitrary serialized protocol buffer message along with a
 * URL that describes the type of the serialized message.
 *
 * Protobuf library provides support to pack/unpack Any values in the form
 * of utility functions or additional generated methods of the Any type.
 *
 * Example 1: Pack and unpack a message in C++.
 *
 * Foo foo = ...;
 * Any any;
 * any.PackFrom(foo);
 * ...
 * if (any.UnpackTo(&foo)) {
 * ...
 * }
 *
 * Example 2: Pack and unpack a message in Java.
 *
 * Foo foo = ...;
 * Any any = Any.pack(foo);
 * ...
 * if (any.is(Foo.class)) {
 * foo = any.unpack(Foo.class);
 * }
 * // or ...
 * if (any.isSameTypeAs(Foo.getDefaultInstance())) {
 * foo = any.unpack(Foo.getDefaultInstance());
 * }
 *
 * Example 3: Pack and unpack a message in Python.
 *
 * foo = Foo(...)
 * any = Any()
 * any.Pack(foo)
 * ...
 * if any.Is(Foo.DESCRIPTOR):
 * any.Unpack(foo)
 * ...
 *
 * Example 4: Pack and unpack a message in Go
 *
 * foo := &pb.Foo{...}
 * any, err := anypb.New(foo)
 * if err != nil {
 * ...
 * }
 * ...
 * foo := &pb.Foo{}
 * if err := any.UnmarshalTo(foo); err != nil {
 * ...
 * }
 *
 * The pack methods provided by protobuf library will by default use
 * 'type.googleapis.com/full.type.name' as the type URL and the unpack
 * methods only use the fully qualified type name after the last '/'
 * in the type URL, for example "foo.bar.com/x/y.z" will yield type
 * name "y.z".
 *
 * JSON
 * ====
 * The JSON representation of an `Any` value uses the regular
 * representation of the deserialized, embedded message, with an
 * additional field `@type` which contains the type URL. Example:
 *
 * package google.profile;
 * message Person {
 * string first_name = 1;
 * string last_name = 2;
 * }
 *
 * {
 * "@type": "type.googleapis.com/google.profile.Person",
 * "firstName": <string>,
 * "lastName": <string>
 * }
 *
 * If the embedded message type is well-known and has a custom JSON
 * representation, that representation will be embedded adding a field
 * `value` which holds the custom JSON in addition to the `@type`
 * field. Example (for message [google.protobuf.Duration][]):
 *
 * {
 * "@type": "type.googleapis.com/google.protobuf.Duration",
 * "value": "1.212s"
 * }
 */
export type ProtobufAny = {
    /**
     * A URL/resource name that uniquely identifies the type of the serialized
     * protocol buffer message. This string must contain at least
     * one "/" character. The last segment of the URL's path must represent
     * the fully qualified name of the type (as in
     * `path/google.protobuf.Duration`). The name should be in a canonical form
     * (e.g., leading "." is not accepted).
     *
     * In practice, teams usually precompile into the binary all types that they
     * expect it to use in the context of Any. However, for URLs which use the
     * scheme `http`, `https`, or no scheme, one can optionally set up a type
     * server that maps type URLs to message definitions as follows:
     *
     * * If no scheme is provided, `https` is assumed.
     * * An HTTP GET on the URL must yield a [google.protobuf.Type][]
     * value in binary format, or produce an error.
     * * Applications are allowed to cache lookup results based on the
     * URL, or have them precompiled into a binary to avoid any
     * lookup. Therefore, binary compatibility needs to be preserved
     * on changes to types. (Use versioned type names to manage
     * breaking changes.)
     *
     * Note: this functionality is not currently available in the official
     * protobuf release, and it is not used for type URLs beginning with
     * type.googleapis.com. As of May 2023, there are no widely used type server
     * implementations and no plans to implement one.
     *
     * Schemes other than `http`, `https` (or the empty scheme) might be
     * used with implementation specific semantics.
     */
    '@type'?: string;
    [key: string]: unknown;
};

export type RatingForm = {
    total?: number;
    win?: number;
    lose?: number;
    rating?: number;
    confirmed?: boolean;
    results?: Array<number>;
};

export type RatingRating = {
    date?: string;
    federation?: string;
    rating?: number;
    tid?: string;
};

export type RpcStatus = {
    code?: number;
    message?: string;
    details?: Array<ProtobufAny>;
};

export type SharedGameFull = {
    id?: string;
    tournament?: string;
    opponentId?: string;
    opponentName?: string;
    opponentNr?: number;
    won?: boolean;
    round?: number;
    handicap?: number;
    rating?: number;
    opponentRating?: number;
    date?: string;
    color?: '' | 'w' | 'b';
    sgfInfo?: SharedSgfInfo;
};

export enum SharedPlayerType {
    PLAYER_TYPE_UNSPECIFIED = 'PLAYER_TYPE_UNSPECIFIED',
    PLAYER_TYPE_ALL = 'PLAYER_TYPE_ALL',
    PLAYER_TYPE_HUMAN = 'PLAYER_TYPE_HUMAN',
    PLAYER_TYPE_BOT = 'PLAYER_TYPE_BOT'
}

export type SharedSgfInfo = {
    has?: boolean;
    count?: number;
    views?: number;
    downloads?: number;
};

export type ArticleServiceUpdateArticleBody = {
    type?: string;
    title?: string;
    preview?: string;
    location?: number;
    category?: string;
    images?: Array<string>;
    tags?: Array<string>;
    status?: string;
    language?: string;
    author?: string;
    content?: string;
    scheduledAt?: string;
    publishedAt?: string;
    createdAt?: string;
    updatedAt?: string;
};

export type ArticleArticle = {
    id?: string;
    type?: string;
    title?: string;
    preview?: string;
    location?: number;
    locationName?: string;
    category?: string;
    images?: Array<string>;
    tags?: Array<string>;
    status?: string;
    language?: string;
    author?: string;
    authorName?: string;
    content?: string;
    scheduledAt?: string;
    publishedAt?: string;
    createdAt?: string;
    updatedAt?: string;
    views?: number;
    roomId?: string;
};

export type ArticleCreateUpdateArticleRequest = {
    id?: string;
    type?: string;
    title?: string;
    preview?: string;
    location?: number;
    category?: string;
    images?: Array<string>;
    tags?: Array<string>;
    status?: string;
    language?: string;
    author?: string;
    content?: string;
    scheduledAt?: string;
    publishedAt?: string;
    createdAt?: string;
    updatedAt?: string;
};

export type ArticleGetArticleTagsResponse = {
    tags?: {
        [key: string]: number;
    };
};

export type ArticleGetReactionsResponse = {
    reactions?: Array<SharedReaction>;
    self?: Array<SharedReactionType>;
};

export type ArticleListArticlesResponse = {
    articles?: Array<ArticleArticle>;
    totalCount?: number;
};

export type ArticlePostReaction = {
    type?: SharedReactionType;
};

export type SharedReaction = {
    type?: SharedReactionType;
    count?: number;
};

export enum SharedReactionType {
    REACTION_TYPE_UNSPECIFIED = 'REACTION_TYPE_UNSPECIFIED',
    REACTION_TYPE_LIKE = 'REACTION_TYPE_LIKE',
    REACTION_TYPE_FIRE = 'REACTION_TYPE_FIRE',
    REACTION_TYPE_LOVE = 'REACTION_TYPE_LOVE',
    REACTION_TYPE_SAD = 'REACTION_TYPE_SAD',
    REACTION_TYPE_SHOCK = 'REACTION_TYPE_SHOCK'
}

export type LocationListLocationsChildrenResponse = {
    children?: Array<number>;
};

export type LocationListLocationsResponse = {
    locations?: Array<LocationShort>;
};

export type LocationShort = {
    id?: number;
    name?: string;
    parent?: string;
};

export type PaymentCastDonationVotesRequest = {
    code?: string;
    votes?: {
        [key: string]: number;
    };
};

export type PaymentCreatePaymentRequest = {
    amount?: SharedAmount;
    type?: PaymentPaymentType;
    description?: string;
    userName?: string;
    userEmail?: string;
    returnUrl?: string;
    eventId?: string;
};

export type PaymentCreatePaymentResponse = {
    redirectUrl?: string;
};

export type PaymentDonation = {
    amount100?: number;
    currency?: SharedCurrency;
    when?: string;
    paymentId?: string;
    userId?: string;
    userName?: string;
    avatar?: string;
    votes?: number;
};

export type PaymentDonationsInfo = {
    donationsTarget100?: number;
    donationsTotalBefore100?: number;
    donationsTotalAfter100?: number;
    donationsCountAfter?: number;
    donationsGraph?: Array<SharedPointString>;
    donationVotes?: {
        [key: string]: number;
    };
};

export type PaymentGetDonationsResponse = {
    total100?: number;
    currentMonth100?: number;
    currentEvent?: Array<PaymentDonation>;
};

export type PaymentGetDonationsTotalsResponse = {
    target100?: number;
    total100?: number;
    count?: number;
};

export type PaymentListDonationVotesResponse = {
    pollId?: string;
    options?: Array<PollPollOption>;
    votes?: {
        [key: string]: number;
    };
};

export type PaymentListDonationsResponse = {
    donations?: Array<PaymentDonation>;
};

export enum PaymentPaymentType {
    PAYMENT_TYPE_UNSPECIFIED = 'PAYMENT_TYPE_UNSPECIFIED',
    PAYMENT_TYPE_DONATION = 'PAYMENT_TYPE_DONATION',
    PAYMENT_TYPE_BROADCAST = 'PAYMENT_TYPE_BROADCAST',
    PAYMENT_TYPE_VOUCHER_CLUB = 'PAYMENT_TYPE_VOUCHER_CLUB',
    PAYMENT_TYPE_COACH_PRODUCT = 'PAYMENT_TYPE_COACH_PRODUCT'
}

export type PaymentVoucherInfo = {
    price?: SharedAmount;
    desc?: string;
    name?: string;
};

export type PollPollOption = {
    id?: string;
    title?: string;
    description?: string;
    index?: number;
};

export type SharedAmount = {
    value?: string;
    currency?: SharedCurrency;
};

export enum SharedCurrency {
    CURRENCY_UNSPECIFIED = 'CURRENCY_UNSPECIFIED',
    CURRENCY_RUB = 'CURRENCY_RUB'
}

export type SharedPointString = {
    x?: string;
    y?: number;
};

export type PlayerPlayer = {
    id?: string;
    name?: string;
    location?: string;
    federation?: 'rgf' | 'egf' | 'spt';
    federations?: Array<'rgf' | 'egf' | 'spt'>;
    rating?: number;
    diff?: number;
    userId?: string;
    lastUpdate?: string;
    rank?: string;
};

export type UserFeedbackRequest = {
    email?: string;
    name?: string;
    message?: string;
    attachments?: Array<string>;
};

export type UserGiveConsentResponse = {
    consentDate?: string;
};

export type UserIdentityRequest = {
    identity?: string;
};

export type UserListUserLoginDetailsResponse = {
    userName?: string;
    loginTypes?: Array<'local' | 'google' | 'yandex' | 'vk'>;
};

export type UserListUsersResponse = {
    users?: Array<UserUser>;
    totalCount?: number;
    active?: number;
    pending?: number;
    deleted?: number;
};

export type UserRoles = {
    roles?: Array<string>;
};

export type UserSetUserRankRequest = {
    rank?: string;
    reject?: boolean;
};

export type UserUpdateUserDataRequest = {
    username?: string;
    password?: string;
    newPassword?: string;
};

export type UserUser = {
    id?: string;
    email?: string;
    userName?: string;
    firstName?: string;
    middleName?: string;
    lastName?: string;
    loginTypes?: Array<'local' | 'google' | 'yandex' | 'vk'>;
    emails?: Array<string>;
    roles?: Array<string>;
    registrationDate?: string;
    lastUpdate?: string;
    consentDate?: string;
    pictureUrl?: string;
    name?: string;
    rank?: string;
    playerId?: string;
    rankRejected?: boolean;
    deleteDate?: string;
    activationCode?: string;
    location?: number;
    birthday?: string;
    firstNameLat?: string;
    middleNameLat?: string;
    lastNameLat?: string;
    city?: string;
    country?: string;
};

export type UserUserInfo = {
    names?: UserUserNames;
    location?: number;
    birthday?: string;
};

export type UserUserNames = {
    firstName?: string;
    middleName?: string;
    lastName?: string;
    firstNameLat?: string;
    middleNameLat?: string;
    lastNameLat?: string;
};

export type GoogleRpcStatus = {
    code?: number;
    message?: string;
    details?: Array<ProtobufAny>;
};

export type RefereeDiscount = {
    type?: RefereeDiscountType;
    value100?: number;
    tags?: Array<string>;
};

export enum RefereeDiscountType {
    DISCOUNT_TYPE_UNSPECIFIED = 'DISCOUNT_TYPE_UNSPECIFIED',
    DISCOUNT_TYPE_ABSOLUTE = 'DISCOUNT_TYPE_ABSOLUTE',
    DISCOUNT_TYPE_PERCENT = 'DISCOUNT_TYPE_PERCENT'
}

export type RefereeEntryFees = {
    fees?: Array<RefereeFee>;
    discounts?: Array<RefereeDiscount>;
    discountsNotSumUp?: boolean;
};

export type RefereeFee = {
    name?: string;
    date?: string;
    amount100?: number;
};

export type RefereeField = {
    name?: string;
    desc?: string;
    type?: RefereeFieldType;
    required?: boolean;
};

export enum RefereeFieldError {
    FIELD_ERROR_UNSPECIFIED = 'FIELD_ERROR_UNSPECIFIED',
    FIELD_ERROR_MISSING = 'FIELD_ERROR_MISSING',
    FIELD_ERROR_INVALID = 'FIELD_ERROR_INVALID'
}

export type RefereeFieldNumber = {
    number?: number;
    error?: RefereeFieldError;
};

export type RefereeFieldText = {
    text?: string;
    error?: RefereeFieldError;
};

export type RefereeFieldTime = {
    time?: string;
    error?: RefereeFieldError;
};

export enum RefereeFieldType {
    FIELD_TYPE_UNSPECIFIED = 'FIELD_TYPE_UNSPECIFIED',
    FIELD_TYPE_PHONE = 'FIELD_TYPE_PHONE',
    FIELD_TYPE_EMAIL = 'FIELD_TYPE_EMAIL',
    FIELD_TYPE_CHECKBOX = 'FIELD_TYPE_CHECKBOX',
    FIELD_TYPE_TEXT = 'FIELD_TYPE_TEXT',
    FIELD_TYPE_NUMBER = 'FIELD_TYPE_NUMBER',
    FIELD_TYPE_DATE = 'FIELD_TYPE_DATE',
    FIELD_TYPE_LOCATION = 'FIELD_TYPE_LOCATION',
    FIELD_TYPE_PLAYER = 'FIELD_TYPE_PLAYER'
}

export type RefereeKeyValue = {
    name?: string;
    value?: string;
};

export type RefereePersonnel = {
    id?: string;
    uid?: string;
    name?: RefereeFieldText;
    role?: RefereeRole;
    category?: string;
    email?: string;
    phone?: string;
    website?: string;
    avatar?: string;
    private?: boolean;
};

export type RefereePrize = {
    name?: string;
    places?: Array<RefereeKeyValue>;
    ageGroup?: number;
};

export type RefereePrizeFund = {
    total100?: number;
    prizes?: Array<RefereePrize>;
    prizesNotSumUp?: boolean;
    prizesOnlyIfPresent?: boolean;
};

export type RefereePrizeInfo = {
    currency?: SharedCurrency;
    entryFees?: RefereeEntryFees;
    prizeFund?: RefereePrizeFund;
    additionalInfo?: Array<string>;
};

export enum RefereeRole {
    ROLE_UNSPECIFIED = 'ROLE_UNSPECIFIED',
    ROLE_DIRECTOR = 'ROLE_DIRECTOR',
    ROLE_SECRETARY = 'ROLE_SECRETARY',
    ROLE_MAIN_REFEREE = 'ROLE_MAIN_REFEREE',
    ROLE_REFEREE = 'ROLE_REFEREE',
    ROLE_ORGANIZER = 'ROLE_ORGANIZER',
    ROLE_PARTNER = 'ROLE_PARTNER'
}

export type RefereeStage = {
    id?: string;
    numRounds?: RefereeFieldNumber;
    system?: SharedSystem;
    ranked?: boolean;
    online?: boolean;
    handicap?: boolean;
    winSpecs?: Array<RefereeWinSpec>;
    timeControl?: SharedTimeSettings;
    invalidData?: boolean;
};

export enum RefereeStatus {
    STATUS_UNSPECIFIED = 'STATUS_UNSPECIFIED',
    STATUS_DRAFT = 'STATUS_DRAFT',
    STATUS_PUBLISHED = 'STATUS_PUBLISHED'
}

export type RefereeTournament = {
    id?: string;
    idExternal?: string;
    status?: RefereeStatus;
    currentPage?: number;
    emptyPages?: Array<number>;
    validPages?: Array<number>;
    isTemplate?: boolean;
    owner?: string;
    version?: number;
    title?: RefereeFieldText;
    titleLat?: string;
    start?: RefereeFieldTime;
    end?: RefereeFieldTime;
    location?: number;
    address?: string;
    addressDesc?: string;
    geoCode?: string;
    startReg?: RefereeFieldTime;
    endReg?: RefereeFieldTime;
    federation?: SharedFederation;
    about?: string;
    conditions?: Array<RefereeKeyValue>;
    category?: SharedCategory;
    type?: SharedType;
    boardSize?: RefereeFieldNumber;
    rules?: SharedRules;
    ageGroup?: number;
    /**
     * Page
     */
    stages?: Array<RefereeStage>;
    /**
     * Page
     */
    registrationFormFields?: Array<RefereeField>;
    description?: RefereeFieldText;
    regulations?: RefereeFieldText;
    /**
     * Page
     */
    personnel?: Array<RefereePersonnel>;
    prize?: RefereePrizeInfo;
    /**
     * Metadata
     */
    createdBy?: string;
    createdAt?: string;
    updatedAt?: string;
    scheduledAt?: string;
    publishedAt?: string;
    invalidVersion?: boolean;
    invalidData?: boolean;
};

export enum RefereeWinSpec {
    WIN_SPEC_UNSPECIFIED = 'WIN_SPEC_UNSPECIFIED',
    WIN_SPEC_POINTS = 'WIN_SPEC_POINTS',
    WIN_SPEC_SOS = 'WIN_SPEC_SOS',
    WIN_SPEC_SODOS = 'WIN_SPEC_SODOS',
    WIN_SPEC_MATCH = 'WIN_SPEC_MATCH'
}

export enum SharedCategory {
    CATEGORY_UNSPECIFIED = 'CATEGORY_UNSPECIFIED',
    CATEGORY_LOCAL = 'CATEGORY_LOCAL',
    CATEGORY_REGIONAL = 'CATEGORY_REGIONAL',
    CATEGORY_FEDERAL = 'CATEGORY_FEDERAL',
    CATEGORY_WORLD = 'CATEGORY_WORLD',
    CATEGORY_ONLINE = 'CATEGORY_ONLINE'
}

export enum SharedFederation {
    FEDERATION_UNSPECIFIED = 'FEDERATION_UNSPECIFIED',
    FEDERATION_SPT = 'FEDERATION_SPT',
    FEDERATION_FGR = 'FEDERATION_FGR',
    FEDERATION_EGF = 'FEDERATION_EGF',
    FEDERATION_AGA = 'FEDERATION_AGA'
}

export type SharedGame = {
    id?: string;
    player1?: string;
    player2?: string;
    player1Id?: string;
    player2Id?: string;
    player1Rating?: number;
    player2Rating?: number;
    round?: number;
    handicap?: number;
    player1Color?: '' | 'w' | 'b';
    player1Won?: boolean;
    sgfInfo?: SharedSgfInfo;
};

export type SharedPointBool = {
    x?: boolean;
    y?: number;
};

export type SharedPointInt = {
    x?: number;
    y?: number;
};

export enum SharedRules {
    RULES_UNSPECIFIED = 'RULES_UNSPECIFIED',
    RULES_JAPANESE = 'RULES_JAPANESE',
    RULES_CHINESE = 'RULES_CHINESE'
}

export type SharedStat = {
    name?: string;
    count?: number;
    percent?: number;
};

export enum SharedSystem {
    SYSTEM_UNSPECIFIED = 'SYSTEM_UNSPECIFIED',
    SYSTEM_MACMAHON = 'SYSTEM_MACMAHON',
    SYSTEM_SWISS = 'SYSTEM_SWISS',
    SYSTEM_ROUND_ROBIN = 'SYSTEM_ROUND_ROBIN',
    SYSTEM_KNOCKOUT = 'SYSTEM_KNOCKOUT',
    SYSTEM_DOUBLE_ELIMINATION = 'SYSTEM_DOUBLE_ELIMINATION',
    SYSTEM_SWISS_TOP_CUT = 'SYSTEM_SWISS_TOP_CUT',
    SYSTEM_LEADER = 'SYSTEM_LEADER',
    SYSTEM_FORS = 'SYSTEM_FORS',
    SYSTEM_LADDER = 'SYSTEM_LADDER',
    SYSTEM_FREE = 'SYSTEM_FREE',
    SYSTEM_OLYMPIC = 'SYSTEM_OLYMPIC'
}

export type SharedTimeSettings = {
    none?: SharedTimeSettingsNone;
    byoyomi?: SharedTimeSettingsByoyomi;
    fischer?: SharedTimeSettingsFischer;
};

export type SharedTimeSettingsByoyomi = {
    mainTimeSec?: number;
    periodTimeSec?: number;
    periodCount?: number;
    disconnectTimeSec?: number;
};

export type SharedTimeSettingsFischer = {
    mainTimeSec?: number;
    timeIncrementSec?: number;
    disconnectTimeSec?: number;
};

export type SharedTimeSettingsNone = {
    [key: string]: unknown;
};

export enum SharedType {
    TYPE_UNSPECIFIED = 'TYPE_UNSPECIFIED',
    TYPE_SINGLE = 'TYPE_SINGLE',
    TYPE_PAIR = 'TYPE_PAIR',
    TYPE_TEAM = 'TYPE_TEAM'
}

export type TournamentAdminTournamentIgnoreResponse = {
    ignored?: boolean;
};

export type TournamentAdminTournamentPinResponse = {
    pinned?: boolean;
};

export type TournamentAdminTournamentProcessResponse = {
    processed?: boolean;
};

export type TournamentAdminTournamentsLocationsResponse = {
    tournaments?: Array<TournamentShort>;
};

export type TournamentGetTournamentPerformanceResponse = {
    title?: string;
    startDate?: string;
    endDate?: string;
    ratingBefore?: number;
    ratingAfter?: number;
    rounds?: Array<TournamentRound>;
};

export type TournamentGetTournamentStatisticsResponse = {
    avg?: number;
    avgTop10?: number;
    games?: number;
    ratingDiff?: number;
    avgPercent?: number;
    avg10Percent?: number;
    avgAge?: number;
    ages?: Array<SharedStat>;
    ageGroups?: Array<SharedStat>;
    ranks?: Array<SharedStat>;
    cities?: Array<SharedStat>;
    countries?: Array<SharedStat>;
    citiesAll?: Array<SharedStat>;
    countriesAll?: Array<SharedStat>;
};

export type TournamentGetTournamentsStatisticsResponse = {
    total?: number;
    tournamentsByYear?: Array<SharedPointInt>;
    tournamentsCurrentYear?: SharedPointInt;
    tournamentsByStrength?: Array<SharedPointInt>;
    tournamentsByBoardSize?: Array<SharedPointInt>;
    tournamentsByTeamSize?: Array<SharedPointInt>;
    tournamentsByParticipation?: Array<SharedPointInt>;
    tournamentsByOnline?: Array<SharedPointBool>;
    tournamentsByRanked?: Array<SharedPointBool>;
    tournamentsByCategory?: Array<SharedPointString>;
    strengthHighest?: number;
    strengthAverage?: number;
    topByStrength?: Array<TournamentStat>;
    topByParticipation?: Array<TournamentStat>;
    participantsTotal?: number;
    participantsAverage?: number;
    gamesTotal?: number;
    gamesAverage?: number;
};

export type TournamentListTournamentGamesResponse = {
    games?: Array<SharedGame>;
};

export type TournamentListTournamentsLocationsResponse = {
    locations?: Array<LocationShort>;
};

export type TournamentListTournamentsResponse = {
    tournaments?: Array<TournamentTournament>;
    totalCount?: number;
};

export type TournamentRound = {
    opponent?: string;
    ratingBefore?: number;
    ratingAfter?: number;
    playerWon?: boolean;
};

export type TournamentShort = {
    id?: string;
    title?: string;
    city?: string;
    start?: string;
    end?: string;
};

export type TournamentStat = {
    id?: string;
    name?: string;
    date?: string;
    value?: number;
};

export type TournamentTournament = {
    id?: string;
    federation?: 'rgf' | 'egf' | 'spt';
    title?: string;
    city?: string;
    category?: 'none' | 'local' | 'regional' | 'federal' | 'world' | 'online';
    description?: string;
    regulations?: string;
    online?: boolean;
    server?: string;
    startDate?: string;
    endDate?: string;
    ranked?: boolean;
    ignored?: boolean;
    pinned?: boolean;
    processed?: boolean;
    handicapped?: boolean;
    timeControl?: string;
    timeClass?: number;
    normClass?: number;
    playerCount?: number;
    teamCount?: number;
    applicationsCount?: number;
    roundCount?: number;
    system?: 'none' | 'mcmahon' | 'free' | 'roundrobin' | 'leader' | 'olympic' | 'fors';
    status?: 'scheduled' | 'processing' | 'active' | 'ended';
    registration?: 'scheduled' | 'processing' | 'active' | 'ended';
    boardSize?: '9' | '13' | '19';
    teamSize?: '1' | '2' | '3';
    location?: number;
    wallList?: Array<TournamentWall>;
    data?: RefereeTournament;
};

export type TournamentWall = {
    id?: string;
    player?: string;
    location?: string;
    position?: number;
    ratingBefore?: number;
    ratingAfter?: number;
    ratingEx?: string;
    mm0?: number;
    results?: string;
    points?: number;
    buchholz?: number;
    berger?: number;
    place?: number;
    isTeam?: boolean;
    team?: string;
    rank?: string;
    ageGroup?: number;
    games?: Array<SharedGame>;
};

/**
 * Message that represents an arbitrary HTTP body. It should only be used for
 * payload formats that can't be represented as JSON, such as raw binary or
 * an HTML page.
 *
 *
 * This message can be used both in streaming and non-streaming API methods in
 * the request as well as the response.
 *
 * It can be used as a top-level request field, which is convenient if one
 * wants to extract parameters from either the URL or HTTP template into the
 * request fields and also want access to the raw HTTP body.
 *
 * Example:
 *
 * message GetResourceRequest {
 * // A unique request id.
 * string request_id = 1;
 *
 * // The raw HTTP body is bound to this field.
 * google.api.HttpBody http_body = 2;
 *
 * }
 *
 * service ResourceService {
 * rpc GetResource(GetResourceRequest)
 * returns (google.api.HttpBody);
 * rpc UpdateResource(google.api.HttpBody)
 * returns (google.protobuf.Empty);
 *
 * }
 *
 * Example with streaming methods:
 *
 * service CaldavService {
 * rpc GetCalendar(stream google.api.HttpBody)
 * returns (stream google.api.HttpBody);
 * rpc UpdateCalendar(stream google.api.HttpBody)
 * returns (stream google.api.HttpBody);
 *
 * }
 *
 * Use of this type only changes how the request and response bodies are
 * handled, all other features will continue to work unchanged.
 */
export type ApiHttpBody = {
    /**
     * The HTTP Content-Type header value specifying the content type of the body.
     */
    contentType?: string;
    /**
     * The HTTP request/response body as raw binary.
     */
    data?: string;
    /**
     * Application specific response metadata. Must be set in the first response
     * for streaming APIs.
     */
    extensions?: Array<ProtobufAny>;
};

export type FileFormatsResponse = {
    formats?: Array<string>;
    maxSize?: number;
};

export type FileGameRecordAccess = {
    allow?: boolean;
};

export type FileGetGamesStatisticsResponse = {
    gamesWithRecords?: number;
    totalRecords?: number;
    totalDownloads?: number;
    totalViews?: number;
    totalPrivate?: number;
    avgRecordsPerGame?: number;
    avgDownloads?: number;
    avgViews?: number;
};

export type FileListFilesResponse = {
    files?: Array<FileMetadata>;
};

export type FileMetadata = {
    id?: string;
    parent?: string;
    filename?: string;
    owner?: string;
    ownerId?: string;
    type?: 'avatar' | 'sgf' | 'feedback';
    uploadedAt?: string;
    downloads?: number;
    views?: number;
    private?: boolean;
    askColor?: boolean;
    allowedUsers?: Array<string>;
};

export type FileSgfDetails = {
    player1?: string;
    player2?: string;
    player1Name?: string;
    player2Name?: string;
    player1Rating?: number;
    player2Rating?: number;
    player1Rank?: string;
    player2Rank?: string;
    tournamentId?: string;
    tournamentTitle?: string;
    tournamentStartDate?: string;
    round?: number;
    player1Color?: string;
    player1Won?: boolean;
    timeControl?: string;
    filename?: string;
    fileId?: string;
    gameId?: string;
    serverId?: string;
    downloads?: number;
    views?: number;
};

export type FileUpdateGameRecord = {
    player1Color?: 'b' | 'w';
};

export type FileUploadFileRequest = {
    filename?: string;
    content?: string;
    metadata?: FileSgfDetails;
    private?: boolean;
    allowedUsers?: Array<string>;
    entityId?: string;
};

export type FileUploadFileResponse = {
    id?: string;
    filename?: string;
};

export type FileUploadGameRecordResponse = {
    gameId?: string;
    fileId?: string;
    private?: boolean;
    askColor?: boolean;
};

export type GameBotSettings = {
    rank?: '15k' | '14k' | '13k' | '12k' | '11k' | '10k' | '9k' | '8k' | '7k' | '6k' | '5k' | '4k' | '3k' | '2k' | '1k' | '1d' | '2d' | '3d' | '4d' | '5d' | '6d' | '7d';
    style?: 'preaz' | 'modern';
    delayMove?: boolean;
};

export type GameChallenge = {
    id?: string;
    proposerId?: string;
    acceptorId?: string;
    createdAt?: string;
    acceptedAt?: string;
    doneAt?: string;
    settings?: GameSettings;
    timeControl?: GameTimeControl;
    gameId?: string;
    fileId?: string;
    botSettings?: GameBotSettings;
    proposer?: string;
    acceptor?: string;
    direct?: boolean;
    proposerLast10?: ProfileGameStats;
    vsProposer?: ProfileGameStats;
    proposerRank?: string;
    acceptorRank?: string;
    proposerAvatar?: string;
    acceptorAvatar?: string;
};

export type GameGame = {
    id?: string;
    player1?: string;
    player2?: string;
    player1Name?: string;
    player2Name?: string;
    player1Rating?: number;
    player2Rating?: number;
    player1Rank?: string;
    player2Rank?: string;
    player1Color?: 'b' | 'w';
    player1Won?: boolean;
    tournamentId?: string;
    tournamentTitle?: string;
    tournamentStartDate?: string;
    views?: number;
    downloads?: number;
    uploadedAt?: string;
    fileId?: string;
    filename?: string;
    result?: string;
    moves?: number;
    settings?: GameSettings;
};

export type GameListChallengesResponse = {
    challenges?: Array<GameChallenge>;
};

export type GameListChatRoomsResponse = {
    global?: string;
};

export type GameListGamesResponse = {
    games?: Array<GameGame>;
    totalCount?: number;
};

export type GamePostChallengeRequest = {
    settings?: GameSettings;
    timeControl?: GameTimeControl;
    botSettings?: GameBotSettings;
    opponent?: string;
};

export type GamePostChallengeResponse = {
    challengeId?: string;
    gameId?: string;
};

export type GameSettings = {
    boardSize?: '9' | '13' | '19';
    rules?: 'chinese' | 'japanese';
    komi?: SharedScore;
    handicap?: number;
    color?: string;
    allowUndo?: boolean;
    botSettings?: GameBotSettings;
    description?: string;
    ranked?: boolean;
};

export type GameStreamChallengesResponse = {
    type?: string;
    data?: string;
};

export type GameTimeControl = {
    type?: 'none' | 'byoyomi' | 'fischer';
    mode?: 'live' | 'correspondence';
    none?: SharedTimeSettingsNone;
    byoyomi?: SharedTimeSettingsByoyomi;
    fischer?: SharedTimeSettingsFischer;
};

export type SharedScore = {
    value?: number;
    unit?: SharedUnit;
};

export enum SharedUnit {
    UNIT_UNSPECIFIED = 'UNIT_UNSPECIFIED',
    UNIT_STONES = 'UNIT_STONES',
    UNIT_POINTS = 'UNIT_POINTS'
}

export type LogEvent = {
    type?: string;
    data?: string;
};

export type LogListNotificationsResponse = {
    notifications?: Array<LogNotification>;
};

export type LogNotification = {
    id?: string;
    userId?: string;
    parentId?: string;
    messageFallback?: string;
    messageData?: {
        [key: string]: string;
    };
    internal?: boolean;
    type?: LogNotifyType;
    game?: LogNotifyGame;
    broadcast?: LogNotifyBroadcast;
    tournament?: LogNotifyTournament;
    payment?: LogNotifyPayment;
    publishedAt?: string;
    readAt?: string;
};

export enum LogNotifyBroadcast {
    NOTIFY_BROADCAST_UNSPECIFIED = 'NOTIFY_BROADCAST_UNSPECIFIED',
    NOTIFY_BROADCAST_START = 'NOTIFY_BROADCAST_START',
    NOTIFY_BROADCAST_END = 'NOTIFY_BROADCAST_END',
    NOTIFY_BROADCAST_INVITE = 'NOTIFY_BROADCAST_INVITE'
}

export enum LogNotifyGame {
    NOTIFY_GAME_UNSPECIFIED = 'NOTIFY_GAME_UNSPECIFIED',
    NOTIFY_GAME_CHALLENGE_DIRECT = 'NOTIFY_GAME_CHALLENGE_DIRECT',
    NOTIFY_GAME_CHALLENGE_DIRECT_RANKED = 'NOTIFY_GAME_CHALLENGE_DIRECT_RANKED',
    NOTIFY_GAME_CHALLENGE_ACCEPT = 'NOTIFY_GAME_CHALLENGE_ACCEPT',
    NOTIFY_GAME_CHALLENGE_REJECT = 'NOTIFY_GAME_CHALLENGE_REJECT'
}

export enum LogNotifyPayment {
    NOTIFY_PAYMENT_UNSPECIFIED = 'NOTIFY_PAYMENT_UNSPECIFIED',
    NOTIFY_PAYMENT_DONATION = 'NOTIFY_PAYMENT_DONATION'
}

export enum LogNotifyTournament {
    NOTIFY_TOURNAMENT_UNSPECIFIED = 'NOTIFY_TOURNAMENT_UNSPECIFIED'
}

export enum LogNotifyType {
    NOTIFY_TYPE_UNSPECIFIED = 'NOTIFY_TYPE_UNSPECIFIED',
    NOTIFY_TYPE_GAME = 'NOTIFY_TYPE_GAME',
    NOTIFY_TYPE_BROADCAST = 'NOTIFY_TYPE_BROADCAST',
    NOTIFY_TYPE_TOURNAMENT = 'NOTIFY_TYPE_TOURNAMENT',
    NOTIFY_TYPE_PAYMENT = 'NOTIFY_TYPE_PAYMENT'
}

export type LogPostLogRequest = {
    message?: string;
};

export type BroadcastBroadcast = {
    id?: string;
    tournament?: BroadcastTournament;
    settings?: BroadcastSettings;
    broadcasterId?: string;
    broadcasterName?: string;
    blackId?: string;
    blackName?: string;
    blackRank?: string;
    whiteId?: string;
    whiteName?: string;
    whiteRank?: string;
    createdAt?: string;
    broadcastId?: string;
    gameId?: string;
    doneAt?: string;
    deletedAt?: string;
    private?: boolean;
    allowed?: boolean;
    allowedUsers?: Array<string>;
};

export type BroadcastBroadcastAccess = {
    allow?: boolean;
};

export enum BroadcastBroadcastSource {
    BROADCAST_SOURCE_UNSPECIFIED = 'BROADCAST_SOURCE_UNSPECIFIED',
    BROADCAST_SOURCE_HUMAN = 'BROADCAST_SOURCE_HUMAN',
    BROADCAST_SOURCE_RECOGNITION = 'BROADCAST_SOURCE_RECOGNITION',
    BROADCAST_SOURCE_EXTERNAL = 'BROADCAST_SOURCE_EXTERNAL'
}

export type BroadcastDemoSettings = {
    private?: boolean;
    publish?: boolean;
};

export type BroadcastListBroadcastsResponse = {
    broadcasts?: Array<BroadcastBroadcast>;
};

export type BroadcastPostBroadcastRequest = {
    black?: GamePlayer;
    white?: GamePlayer;
    settings?: BroadcastSettings;
    tournament?: BroadcastTournamentRequest;
    demo?: BroadcastDemoSettings;
};

export type BroadcastPostBroadcastResponse = {
    id?: string;
    broadcastId?: string;
};

export type BroadcastSettings = {
    boardSize?: '9' | '13' | '19';
    rules?: 'chinese' | 'japanese';
    komi?: SharedScore;
    handicap?: number;
    color?: string;
    description?: string;
    source?: BroadcastBroadcastSource;
};

export type BroadcastTournament = {
    id?: string;
    title?: string;
    round?: number;
    online?: boolean;
    server?: string;
    ranked?: boolean;
    teamSize?: number;
    boardSize?: number;
    system?: string;
    knockout?: boolean;
    federation?: 'rgf' | 'egf' | 'spt';
    location?: number;
};

export type BroadcastTournamentRequest = {
    id?: string;
    title?: string;
    round?: number;
    knockout?: boolean;
};

export type BroadcastUpdateBroadcast = {
    black?: GamePlayer;
    white?: GamePlayer;
    round?: number;
    description?: string;
};

export type ChatGetStreamTokenResponse = {
    token?: string;
    livekitUrl?: string;
};

export type GamePlayer = {
    id?: string;
    name?: string;
    rank?: string;
};

export type ChatAdminCreateSpaceRequest = {
    name?: string;
    /**
     * boolean is_public = 3;
     */
    nameLat?: string;
};

export type ChatAdminRedactRoomMessage = {
    reason?: string;
};

export type ChatAdminSetBanRoomMember = {
    ban?: boolean;
    reason?: string;
};

export type ChatCreateRoomBody = {
    externalId?: string;
    name?: string;
    /**
     * boolean is_public = 4;
     */
    nameLat?: string;
};

export type ChatListRoomMembersResponse = {
    members?: Array<ChatMember>;
};

export type ChatListRoomMessagesResponse = {
    messages?: Array<ChatMessage>;
    nextPage?: string;
};

export type ChatListRoomsResponse = {
    rooms?: Array<ChatRoom>;
};

export type ChatListSpacesResponse = {
    spaces?: Array<ChatSpace>;
};

export type ChatMember = {
    id?: string;
    name?: string;
    avatarUrl?: string;
    isAdmin?: boolean;
};

export type ChatMessage = {
    id?: string;
    userId?: string;
    type?: ChatMessageType;
    message?: string;
    reactions?: Array<ChatReaction>;
    timestamp?: string;
    ageMs?: string;
};

export type ChatMessageBody = {
    message?: string;
    autoJoinPublic?: boolean;
};

export enum ChatMessageType {
    MESSAGE_TYPE_UNSPECIFIED = 'MESSAGE_TYPE_UNSPECIFIED',
    MESSAGE_TYPE_TEXT = 'MESSAGE_TYPE_TEXT',
    MESSAGE_TYPE_JOIN = 'MESSAGE_TYPE_JOIN',
    MESSAGE_TYPE_LEAVE = 'MESSAGE_TYPE_LEAVE'
}

export type ChatReaction = {
    reaction?: string;
    userEvents?: {
        [key: string]: string;
    };
};

export type ChatRoom = {
    id?: string;
    name?: string;
    nameLat?: string;
    topic?: string;
    numMembers?: string;
    members?: Array<ChatMember>;
};

export type ChatRoomEvent = {
    type?: string;
    data?: string;
};

export type ChatSendRoomMessageReaction = {
    reaction?: string;
    autoJoinPublic?: boolean;
};

export type ChatSendRoomMessageResponse = {
    eventId?: string;
};

export type ChatSetArchive = {
    archive?: boolean;
};

export type ChatSpace = {
    id?: string;
    name?: string;
    nameLat?: string;
    rooms?: Array<ChatRoom>;
};

export type RatingListRatingHistoryResponse = {
    history?: Array<RatingRating>;
};

export type ServerHubServiceAcceptChallengeBody = {
    [key: string]: unknown;
};

export type ServerHubServiceCreateChallengeBody = {
    opponentExternalUserId?: string;
    settings?: ServerhubChallengeSettings;
};

export type ServerHubServiceSendGameCommandBody = {
    command?: ServerhubGameCommand;
};

export enum ServerhubCapability {
    CAPABILITY_UNSPECIFIED = 'CAPABILITY_UNSPECIFIED',
    CAPABILITY_PLAYER_SEARCH = 'CAPABILITY_PLAYER_SEARCH',
    CAPABILITY_DIRECT_CHALLENGE = 'CAPABILITY_DIRECT_CHALLENGE',
    CAPABILITY_LIVE_GAME = 'CAPABILITY_LIVE_GAME',
    CAPABILITY_GAME_CHAT = 'CAPABILITY_GAME_CHAT',
    CAPABILITY_GAME_UNDO = 'CAPABILITY_GAME_UNDO',
    CAPABILITY_GAME_SCORING = 'CAPABILITY_GAME_SCORING',
    CAPABILITY_SPECTATING = 'CAPABILITY_SPECTATING',
    CAPABILITY_MATCHMAKING = 'CAPABILITY_MATCHMAKING'
}

export type ServerhubChallenge = {
    providerId?: string;
    externalChallengeId?: string;
    status?: string;
    externalGameId?: string;
    challenger?: ServerhubPlayer;
    challenged?: ServerhubPlayer;
    settings?: ServerhubChallengeSettings;
    outgoing?: boolean;
};

export type ServerhubChallengeSettings = {
    boardWidth?: number;
    boardHeight?: number;
    ranked?: boolean;
    rules?: string;
    timeControl?: string;
    initialTimeSeconds?: number;
    incrementSeconds?: number;
    maximumTimeSeconds?: number;
    timeControlSpeed?: string;
    pauseOnWeekends?: boolean;
    mainTimeSeconds?: number;
    periodTimeSeconds?: number;
    periodCount?: number;
};

export type ServerhubGameCommand = {
    type?: ServerhubGameCommandType;
    vertex?: string;
    vertices?: Array<string>;
    message?: string;
};

export enum ServerhubGameCommandType {
    GAME_COMMAND_TYPE_UNSPECIFIED = 'GAME_COMMAND_TYPE_UNSPECIFIED',
    GAME_COMMAND_TYPE_MOVE = 'GAME_COMMAND_TYPE_MOVE',
    GAME_COMMAND_TYPE_PASS = 'GAME_COMMAND_TYPE_PASS',
    GAME_COMMAND_TYPE_RESIGN = 'GAME_COMMAND_TYPE_RESIGN',
    GAME_COMMAND_TYPE_REQUEST_UNDO = 'GAME_COMMAND_TYPE_REQUEST_UNDO',
    GAME_COMMAND_TYPE_ACCEPT_UNDO = 'GAME_COMMAND_TYPE_ACCEPT_UNDO',
    GAME_COMMAND_TYPE_REJECT_UNDO = 'GAME_COMMAND_TYPE_REJECT_UNDO',
    GAME_COMMAND_TYPE_TOGGLE_DEAD_STONES = 'GAME_COMMAND_TYPE_TOGGLE_DEAD_STONES',
    GAME_COMMAND_TYPE_ACCEPT_DEAD_STONES = 'GAME_COMMAND_TYPE_ACCEPT_DEAD_STONES',
    GAME_COMMAND_TYPE_REJECT_DEAD_STONES = 'GAME_COMMAND_TYPE_REJECT_DEAD_STONES',
    GAME_COMMAND_TYPE_CHAT = 'GAME_COMMAND_TYPE_CHAT',
    GAME_COMMAND_TYPE_CANCEL_UNDO = 'GAME_COMMAND_TYPE_CANCEL_UNDO',
    GAME_COMMAND_TYPE_REQUEST_DRAW = 'GAME_COMMAND_TYPE_REQUEST_DRAW',
    GAME_COMMAND_TYPE_ACCEPT_DRAW = 'GAME_COMMAND_TYPE_ACCEPT_DRAW',
    GAME_COMMAND_TYPE_REJECT_DRAW = 'GAME_COMMAND_TYPE_REJECT_DRAW',
    GAME_COMMAND_TYPE_CANCEL_DRAW = 'GAME_COMMAND_TYPE_CANCEL_DRAW',
    GAME_COMMAND_TYPE_REQUEST_COUNTING = 'GAME_COMMAND_TYPE_REQUEST_COUNTING',
    GAME_COMMAND_TYPE_ACCEPT_COUNTING = 'GAME_COMMAND_TYPE_ACCEPT_COUNTING',
    GAME_COMMAND_TYPE_REJECT_COUNTING = 'GAME_COMMAND_TYPE_REJECT_COUNTING',
    GAME_COMMAND_TYPE_CANCEL_COUNTING = 'GAME_COMMAND_TYPE_CANCEL_COUNTING'
}

export type ServerhubGameEvent = {
    /**
     * POC compatibility envelope for pkg/gameevent JSON. Stable event shapes
     * should eventually become typed protobuf messages.
     */
    type?: string;
    data?: string;
    /**
     * Connector-scoped ordering only; synthetic terminal errors may use zero.
     */
    id?: string;
};

export type ServerhubGameRecordResponse = {
    sgf?: string;
};

export type ServerhubListChallengesResponse = {
    challenges?: Array<ServerhubChallenge>;
};

export type ServerhubListMatchmakingOptionsResponse = {
    ogs?: ServerhubOgsMatchmakingOptions;
    yike?: ServerhubYikeMatchmakingOptions;
};

export type ServerhubListProvidersResponse = {
    providers?: Array<ServerhubProvider>;
};

export enum ServerhubMatchmakingColorPreference {
    MATCHMAKING_COLOR_PREFERENCE_UNSPECIFIED = 'MATCHMAKING_COLOR_PREFERENCE_UNSPECIFIED',
    MATCHMAKING_COLOR_PREFERENCE_BLACK = 'MATCHMAKING_COLOR_PREFERENCE_BLACK',
    MATCHMAKING_COLOR_PREFERENCE_WHITE = 'MATCHMAKING_COLOR_PREFERENCE_WHITE',
    MATCHMAKING_COLOR_PREFERENCE_OPEN = 'MATCHMAKING_COLOR_PREFERENCE_OPEN'
}

export type ServerhubMatchmakingEvent = {
    /**
     * Uses the same temporary type/JSON envelope as GameEvent.
     */
    type?: string;
    data?: string;
    /**
     * Process-local ordering only; synthetic failure events may use zero.
     */
    id?: string;
};

export enum ServerhubMatchmakingPreferenceCondition {
    MATCHMAKING_PREFERENCE_CONDITION_UNSPECIFIED = 'MATCHMAKING_PREFERENCE_CONDITION_UNSPECIFIED',
    MATCHMAKING_PREFERENCE_CONDITION_REQUIRED = 'MATCHMAKING_PREFERENCE_CONDITION_REQUIRED',
    MATCHMAKING_PREFERENCE_CONDITION_PREFERRED = 'MATCHMAKING_PREFERENCE_CONDITION_PREFERRED',
    MATCHMAKING_PREFERENCE_CONDITION_OPEN = 'MATCHMAKING_PREFERENCE_CONDITION_OPEN'
}

export enum ServerhubMatchmakingSpeed {
    MATCHMAKING_SPEED_UNSPECIFIED = 'MATCHMAKING_SPEED_UNSPECIFIED',
    MATCHMAKING_SPEED_BLITZ = 'MATCHMAKING_SPEED_BLITZ',
    MATCHMAKING_SPEED_RAPID = 'MATCHMAKING_SPEED_RAPID',
    MATCHMAKING_SPEED_LIVE = 'MATCHMAKING_SPEED_LIVE',
    MATCHMAKING_SPEED_CORRESPONDENCE = 'MATCHMAKING_SPEED_CORRESPONDENCE'
}

export enum ServerhubMatchmakingTimeControl {
    MATCHMAKING_TIME_CONTROL_UNSPECIFIED = 'MATCHMAKING_TIME_CONTROL_UNSPECIFIED',
    MATCHMAKING_TIME_CONTROL_FISCHER = 'MATCHMAKING_TIME_CONTROL_FISCHER',
    MATCHMAKING_TIME_CONTROL_BYOYOMI = 'MATCHMAKING_TIME_CONTROL_BYOYOMI'
}

export type ServerhubOgsMatchmakingOptions = {
    [key: string]: unknown;
};

export type ServerhubOgsMatchmakingPreferences = {
    /**
     * These three lists are parallel: values at the same index form one exact
     * OGS size/speed/time-control option. This query-friendly representation is
     * used because FindMatch is exposed as an EventSource-compatible GET stream.
     */
    optionBoardSizes?: Array<number>;
    rules?: string;
    rulesCondition?: ServerhubMatchmakingPreferenceCondition;
    handicapEnabled?: boolean;
    handicapCondition?: ServerhubMatchmakingPreferenceCondition;
    lowerRankDifference?: number;
    upperRankDifference?: number;
    optionSpeeds?: Array<ServerhubMatchmakingSpeed>;
    optionTimeControls?: Array<ServerhubMatchmakingTimeControl>;
};

export type ServerhubPlayer = {
    externalUserId?: string;
    username?: string;
    country?: string;
    ranking?: number;
    provisional?: boolean;
    bot?: boolean;
};

export type ServerhubProvider = {
    id?: string;
    name?: string;
    capabilities?: Array<ServerhubCapability>;
    gameSupport?: ServerhubProviderGameSupport;
};

export type ServerhubProviderGameSupport = {
    rules?: Array<string>;
    timeControls?: Array<string>;
    boardSizes?: Array<number>;
};

export type ServerhubSearchPlayersResponse = {
    players?: Array<ServerhubPlayer>;
};

export type ServerhubYikeMatchmakingOptions = {
    roles?: Array<ServerhubYikeMatchmakingRole>;
};

export type ServerhubYikeMatchmakingPreferences = {
    roleCode?: string;
    color?: ServerhubMatchmakingColorPreference;
};

export type ServerhubYikeMatchmakingRole = {
    code?: string;
    margin?: number;
    title?: string;
    description?: string;
    sort?: number;
    speed?: string;
    gameType?: string;
    ranked?: boolean;
    /**
     * Provider-supplied title before best-effort English translation.
     */
    originalTitle?: string;
};

export type ClubClub = {
    id?: string;
    name?: string;
    shortName?: string;
    type?: ClubClubType;
    description?: string;
    logo?: string;
    joinPolicy?: ClubJoinPolicy;
    archived?: boolean;
    createdBy?: string;
    location?: number;
    address?: string;
    schedule?: SharedSchedule;
    voucherEligible?: boolean;
    createdAt?: string;
    updatedAt?: string;
};

export enum ClubClubType {
    CLUB_TYPE_UNSPECIFIED = 'CLUB_TYPE_UNSPECIFIED',
    CLUB_TYPE_ONLINE = 'CLUB_TYPE_ONLINE',
    CLUB_TYPE_OFFLINE = 'CLUB_TYPE_OFFLINE',
    CLUB_TYPE_HYBRID = 'CLUB_TYPE_HYBRID'
}

export type ClubCreateClubRequest = {
    name?: string;
    /**
     * EGF-style club code: three characters, a letter first.
     */
    shortName?: string;
    type?: ClubClubType;
    description?: string;
    logo?: string;
    joinPolicy?: ClubJoinPolicy;
    voucherEligible?: boolean;
    location?: number;
    address?: string;
    schedule?: SharedSchedule;
};

export enum ClubJoinPolicy {
    JOIN_POLICY_UNSPECIFIED = 'JOIN_POLICY_UNSPECIFIED',
    JOIN_POLICY_OPEN = 'JOIN_POLICY_OPEN',
    JOIN_POLICY_BY_APPLICATION = 'JOIN_POLICY_BY_APPLICATION',
    JOIN_POLICY_INVITE_ONLY = 'JOIN_POLICY_INVITE_ONLY'
}

export type ClubListClubsResponse = {
    clubs?: Array<ClubClub>;
};

export type ClubVoucherInfo = {
    desc?: string;
    name?: string;
    redeemUrl?: string;
    qrCodePng?: string;
};

export type SharedFixedSlot = {
    startDateTime?: string;
    endDateTime?: string;
};

export type SharedSchedule = {
    startDate?: TypeDate;
    endDate?: TypeDate;
    fixedSlots?: Array<SharedFixedSlot>;
    weeklySchedule?: Array<SharedWeeklyRule>;
};

export type SharedWeeklyRule = {
    dayOfWeek?: TypeDayOfWeek;
    startTime?: TypeTimeOfDay;
    endTime?: TypeTimeOfDay;
};

/**
 * Represents a whole or partial calendar date, such as a birthday. The time of
 * day and time zone are either specified elsewhere or are insignificant. The
 * date is relative to the Gregorian Calendar. This can represent one of the
 * following:
 *
 * * A full date, with non-zero year, month, and day values.
 * * A month and day, with a zero year (for example, an anniversary).
 * * A year on its own, with a zero month and a zero day.
 * * A year and month, with a zero day (for example, a credit card expiration
 * date).
 *
 * Related types:
 *
 * * [google.type.TimeOfDay][google.type.TimeOfDay]
 * * [google.type.DateTime][google.type.DateTime]
 * * [google.protobuf.Timestamp][google.protobuf.Timestamp]
 */
export type TypeDate = {
    /**
     * Year of the date. Must be from 1 to 9999, or 0 to specify a date without
     * a year.
     */
    year?: number;
    /**
     * Month of a year. Must be from 1 to 12, or 0 to specify a year without a
     * month and day.
     */
    month?: number;
    /**
     * Day of a month. Must be from 1 to 31 and valid for the year and month, or 0
     * to specify a year by itself or a year and month where the day isn't
     * significant.
     */
    day?: number;
};

/**
 * Represents a day of the week.
 *
 * - DAY_OF_WEEK_UNSPECIFIED: The day of the week is unspecified.
 * - MONDAY: Monday
 * - TUESDAY: Tuesday
 * - WEDNESDAY: Wednesday
 * - THURSDAY: Thursday
 * - FRIDAY: Friday
 * - SATURDAY: Saturday
 * - SUNDAY: Sunday
 */
export enum TypeDayOfWeek {
    DAY_OF_WEEK_UNSPECIFIED = 'DAY_OF_WEEK_UNSPECIFIED',
    MONDAY = 'MONDAY',
    TUESDAY = 'TUESDAY',
    WEDNESDAY = 'WEDNESDAY',
    THURSDAY = 'THURSDAY',
    FRIDAY = 'FRIDAY',
    SATURDAY = 'SATURDAY',
    SUNDAY = 'SUNDAY'
}

/**
 * Represents a time of day. The date and time zone are either not significant
 * or are specified elsewhere. An API may choose to allow leap seconds. Related
 * types are [google.type.Date][google.type.Date] and
 * `google.protobuf.Timestamp`.
 */
export type TypeTimeOfDay = {
    /**
     * Hours of a day in 24 hour format. Must be greater than or equal to 0 and
     * typically must be less than or equal to 23. An API may choose to allow the
     * value "24:00:00" for scenarios like business closing time.
     */
    hours?: number;
    /**
     * Minutes of an hour. Must be greater than or equal to 0 and less than or
     * equal to 59.
     */
    minutes?: number;
    /**
     * Seconds of a minute. Must be greater than or equal to 0 and typically must
     * be less than or equal to 59. An API may allow the value 60 if it allows
     * leap-seconds.
     */
    seconds?: number;
    /**
     * Fractions of seconds, in nanoseconds. Must be greater than or equal to 0
     * and less than or equal to 999,999,999.
     */
    nanos?: number;
};

export type PollAddPollOption = {
    title?: {
        [key: string]: string;
    };
    description?: {
        [key: string]: string;
    };
    index?: number;
};

export type PollAddPollOptions = {
    options?: Array<PollAddPollOption>;
};

export type PollCastPollVotes = {
    votes?: {
        [key: string]: number;
    };
    code?: string;
};

export type PollCreatePollRequest = {
    parentId?: string;
    privacy?: PollPollPrivacy;
    type?: PollPollType;
    title?: {
        [key: string]: string;
    };
    description?: {
        [key: string]: string;
    };
    allowMultipleOptions?: boolean;
    votesLimit?: number;
    endsAt?: string;
};

export type PollCreatePollResponse = {
    id?: string;
};

export type PollListPollsResponse = {
    polls?: Array<PollPoll>;
};

export type PollOrderPollOptions = {
    options?: Array<string>;
};

export type PollPoll = {
    id?: string;
    ownerId?: string;
    parentId?: string;
    status?: PollPollStatus;
    privacy?: PollPollPrivacy;
    type?: PollPollType;
    title?: string;
    description?: string;
    allowMultipleOptions?: boolean;
    votesLimit?: number;
    options?: Array<PollPollOption>;
    votes?: {
        [key: string]: number;
    };
    createdAt?: string;
    updatedAt?: string;
    endsAt?: string;
};

export enum PollPollPrivacy {
    POLL_PRIVACY_UNSPECIFIED = 'POLL_PRIVACY_UNSPECIFIED',
    POLL_PRIVACY_INTERNAL = 'POLL_PRIVACY_INTERNAL',
    POLL_PRIVACY_PRIVATE = 'POLL_PRIVACY_PRIVATE',
    POLL_PRIVACY_PUBLIC = 'POLL_PRIVACY_PUBLIC',
    POLL_PRIVACY_ANONYMOUS = 'POLL_PRIVACY_ANONYMOUS'
}

export enum PollPollStatus {
    POLL_STATUS_UNSPECIFIED = 'POLL_STATUS_UNSPECIFIED',
    POLL_STATUS_DRAFT = 'POLL_STATUS_DRAFT',
    POLL_STATUS_ACTIVE = 'POLL_STATUS_ACTIVE',
    POLL_STATUS_ENDED = 'POLL_STATUS_ENDED',
    POLL_STATUS_ARCHIVED = 'POLL_STATUS_ARCHIVED'
}

export enum PollPollType {
    POLL_TYPE_UNSPECIFIED = 'POLL_TYPE_UNSPECIFIED',
    POLL_TYPE_PIE = 'POLL_TYPE_PIE'
}

export type PollUpdatePoll = {
    parentId?: string;
    status?: PollPollStatus;
    privacy?: PollPollPrivacy;
    type?: PollPollType;
    title?: {
        [key: string]: string;
    };
    description?: {
        [key: string]: string;
    };
    allowMultipleOptions?: boolean;
    votesLimit?: number;
    endsAt?: string;
};

export type PollUpdatePollOption = {
    title?: {
        [key: string]: string;
    };
    description?: {
        [key: string]: string;
    };
};

export type RefereeServiceAddTournamentPersonnelBody = {
    version?: number;
    uid?: string;
    role?: RefereeRole;
    category?: string;
    private?: boolean;
    name?: string;
    email?: string;
    phone?: string;
    website?: string;
};

export type RefereeServiceAddTournamentStageBody = {
    version?: number;
    numRounds?: number;
    system?: SharedSystem;
    ranked?: boolean;
    online?: boolean;
    handicap?: boolean;
    winSpecs?: Array<RefereeWinSpec>;
    timeControl?: SharedTimeSettings;
};

export type RefereeServiceCreateParticipantBody = {
    participantId?: string;
    userId?: string;
    playerId?: string;
    lastName?: string;
    firstName?: string;
    middleName?: string;
    birthDate?: TypeDate;
    location?: number;
    rating?: number;
    rank?: string;
    email?: string;
    phone?: string;
    comment?: string;
    customFieldsJson?: string;
    status?: RefereeParticipantStatus;
    requestLink?: boolean;
    consent?: boolean;
};

export type RefereeServiceUpdateParticipantBody = {
    userId?: string;
    playerId?: string;
    lastName?: string;
    firstName?: string;
    middleName?: string;
    birthDate?: TypeDate;
    location?: number;
    rating?: number;
    rank?: string;
    email?: string;
    phone?: string;
    comment?: string;
    customFieldsJson?: string;
    status?: RefereeParticipantStatus;
    requestLink?: boolean;
    consent?: boolean;
};

export type RefereeServiceUpdatePersonnelBody = {
    role?: RefereeRole;
    category?: string;
    private?: boolean;
    name?: string;
    email?: string;
    phone?: string;
    website?: string;
};

export type RefereeServiceUpdatePrizeInfoBody = {
    version?: number;
    prize?: RefereePrizeInfo;
};

export type RefereeServiceUpdateRegistrationFormBody = {
    version?: number;
    fields?: Array<RefereeField>;
};

export type RefereeServiceUpdateStageBody = {
    version?: number;
    numRounds?: number;
    system?: SharedSystem;
    ranked?: boolean;
    online?: boolean;
    handicap?: boolean;
    winSpecs?: Array<RefereeWinSpec>;
    timeControl?: SharedTimeSettings;
};

/**
 * Actual contracts
 */
export type RefereeServiceUpdateTournamentBody = {
    idExternal?: string;
    status?: RefereeStatus;
    currentPage?: number;
    isTemplate?: boolean;
    owner?: string;
    version?: number;
    /**
     * Page
     */
    title?: string;
    titleLat?: string;
    dateRange?: RefereeDateRange;
    dateRangeReg?: RefereeDateRange;
    location?: number;
    address?: string;
    addressDesc?: string;
    geoCode?: string;
    federation?: SharedFederation;
    about?: string;
    conditions?: RefereeConditions;
    category?: SharedCategory;
    type?: SharedType;
    boardSize?: number;
    rules?: SharedRules;
    ageGroup?: number;
    /**
     * Page
     */
    stages?: Array<string>;
    /**
     * Page
     */
    description?: string;
    regulations?: string;
    /**
     * Page
     */
    personnel?: Array<string>;
    /**
     * Metadata
     */
    createdBy?: string;
    createdAt?: string;
    updatedAt?: string;
    scheduledAt?: string;
    publishedAt?: string;
};

export type RefereeConditions = {
    conditions?: Array<RefereeKeyValue>;
};

/**
 * Actual contracts
 */
export type RefereeCreateUpdateTournamentRequest = {
    id?: string;
    idExternal?: string;
    status?: RefereeStatus;
    currentPage?: number;
    isTemplate?: boolean;
    owner?: string;
    version?: number;
    /**
     * Page
     */
    title?: string;
    titleLat?: string;
    dateRange?: RefereeDateRange;
    dateRangeReg?: RefereeDateRange;
    location?: number;
    address?: string;
    addressDesc?: string;
    geoCode?: string;
    federation?: SharedFederation;
    about?: string;
    conditions?: RefereeConditions;
    category?: SharedCategory;
    type?: SharedType;
    boardSize?: number;
    rules?: SharedRules;
    ageGroup?: number;
    /**
     * Page
     */
    stages?: Array<string>;
    /**
     * Page
     */
    description?: string;
    regulations?: string;
    /**
     * Page
     */
    personnel?: Array<string>;
    /**
     * Metadata
     */
    createdBy?: string;
    createdAt?: string;
    updatedAt?: string;
    scheduledAt?: string;
    publishedAt?: string;
};

export type RefereeDateRange = {
    start?: string;
    end?: string;
};

export type RefereeFields = {
    fields?: Array<RefereeField>;
};

export type RefereeGroup = {
    score?: number;
    players?: Array<RefereePlayer>;
};

export type RefereeListTournamentsResponse = {
    tournaments?: Array<RefereeTournament>;
};

export type RefereePair = {
    player1?: RefereePlayer;
    player2?: RefereePlayer;
};

export type RefereeParticipant = {
    id?: string;
    userId?: string;
    playerId?: string;
    lastName?: string;
    firstName?: string;
    middleName?: string;
    birthDate?: TypeDate;
    ageGroup?: number;
    location?: number;
    rating?: number;
    rank?: string;
    email?: string;
    phone?: string;
    comment?: string;
    customFieldsJson?: string;
    status?: RefereeParticipantStatus;
    requestLink?: boolean;
    consent?: boolean;
    createdBy?: string;
    createdAt?: string;
    updatedAt?: string;
};

export enum RefereeParticipantStatus {
    PARTICIPANT_STATUS_UNSPECIFIED = 'PARTICIPANT_STATUS_UNSPECIFIED',
    PARTICIPANT_STATUS_APPLIED = 'PARTICIPANT_STATUS_APPLIED',
    PARTICIPANT_STATUS_APPROVED = 'PARTICIPANT_STATUS_APPROVED',
    PARTICIPANT_STATUS_REJECTED = 'PARTICIPANT_STATUS_REJECTED',
    PARTICIPANT_STATUS_CANCELED = 'PARTICIPANT_STATUS_CANCELED'
}

export type RefereeParticipants = {
    participants?: Array<RefereeParticipant>;
};

export type RefereePlayer = {
    id?: string;
    name?: string;
    rating?: number;
    mmo?: number;
    results?: Array<RefereeResult>;
    upCount?: number;
    downCount?: number;
    points?: number;
    sos?: number;
    sodos?: number;
};

export type RefereeResult = {
    round?: number;
    opponentId?: string;
    opponentName?: string;
    result?: SharedResult;
};

export type RefereeRound = {
    number?: number;
    playersOriginal?: Array<RefereePlayer>;
    pairs?: Array<RefereePair>;
    pairsOriginal?: Array<RefereePair>;
};

/**
 * Temporary
 */
export type RefereeSeedGroupsTestRequest = {
    tournamentId?: string;
    numGroups?: number;
    step?: number;
    ratingBars?: Array<number>;
};

export type RefereeSeedGroupsTestResponse = {
    players?: Array<RefereePlayer>;
    groups?: Array<RefereeGroup>;
    playersOriginal?: Array<RefereePlayer>;
    groupsOriginal?: Array<RefereeGroup>;
};

export type RefereeSeedRoundsTestRequest = {
    tournamentId?: string;
    avoidLeaderRounds?: number;
};

export type RefereeSeedRoundsTestResponse = {
    rounds?: Array<RefereeRound>;
};

export enum SharedResult {
    RESULT_UNSPECIFIED = 'RESULT_UNSPECIFIED',
    RESULT_WIN = 'RESULT_WIN',
    RESULT_LOSS = 'RESULT_LOSS',
    RESULT_DRAW = 'RESULT_DRAW',
    RESULT_WIN_BYE = 'RESULT_WIN_BYE',
    RESULT_LOSS_SKIP = 'RESULT_LOSS_SKIP'
}

export type ServerServiceAiRefereeBody = {
    [key: string]: unknown;
};

export type ServerServiceAcceptDeadStonesBody = {
    deadStones?: unknown;
};

export type ServerServiceAcceptUndoBody = {
    [key: string]: unknown;
};

export type ServerServiceBroadcastBackBody = {
    [key: string]: unknown;
};

export type ServerServiceBroadcastChatBody = {
    nodeId?: number;
    mentions?: Array<string>;
    variation?: Array<ServerMove>;
    message?: string;
    spoiler?: boolean;
};

export type ServerServiceBroadcastCutBody = {
    [key: string]: unknown;
};

export type ServerServiceBroadcastMoveBody = {
    [key: string]: unknown;
};

export type ServerServiceBroadcastPassBody = {
    [key: string]: unknown;
};

export type ServerServiceBroadcastPruneBody = {
    [key: string]: unknown;
};

export type ServerServiceBroadcastResultBody = {
    winner?: SharedColor;
    reason?: SharedWinReason;
    score?: SharedScore;
};

export type ServerServiceBroadcastSetCurrentNodeBody = {
    [key: string]: unknown;
};

export type ServerServiceBroadcastSetNodeMetadataBody = {
    key?: string;
    value?: string;
};

export type ServerServiceBroadcastUndoBody = {
    [key: string]: unknown;
};

export type ServerServiceBroadcastUploadSgfBody = {
    sgf?: string;
    ignoreMetadata?: boolean;
};

export type ServerServiceGameChatBody = {
    moveNr?: number;
    mentions?: Array<string>;
    variation?: Array<ServerMove>;
    message?: string;
    spoiler?: boolean;
};

export type ServerServiceGameMoveBody = {
    [key: string]: unknown;
};

export type ServerServiceGamePassBody = {
    [key: string]: unknown;
};

export type ServerServiceGameResignBody = {
    [key: string]: unknown;
};

export type ServerServiceRejectDeadStonesBody = {
    [key: string]: unknown;
};

export type ServerServiceRejectUndoBody = {
    [key: string]: unknown;
};

export type ServerServiceRequestUndoBody = {
    [key: string]: unknown;
};

export type ServerServiceToggleDeadStonesBody = {
    [key: string]: unknown;
};

/**
 * `NullValue` is a singleton enumeration to represent the null value for the
 * `Value` type union.
 *
 * The JSON representation for `NullValue` is JSON `null`.
 *
 * - NULL_VALUE: Null value.
 */
export enum ProtobufNullValue {
    NULL_VALUE = 'NULL_VALUE'
}

export type ServerBroadcastEvent = {
    type?: string;
    data?: string;
    id?: string;
};

export type ServerGameEvent = {
    type?: string;
    data?: string;
    id?: string;
};

export type ServerMove = {
    r?: number;
    c?: number;
    col?: SharedColor;
};

export type ServerSgfResponse = {
    sgf?: string;
};

export enum SharedColor {
    COLOR_UNSPECIFIED = 'COLOR_UNSPECIFIED',
    COLOR_BLACK = 'COLOR_BLACK',
    COLOR_WHITE = 'COLOR_WHITE'
}

export enum SharedWinReason {
    WIN_REASON_UNSPECIFIED = 'WIN_REASON_UNSPECIFIED',
    WIN_REASON_NONE = 'WIN_REASON_NONE',
    WIN_REASON_RESIGNATION = 'WIN_REASON_RESIGNATION',
    WIN_REASON_COUNTING = 'WIN_REASON_COUNTING',
    WIN_REASON_TIME = 'WIN_REASON_TIME',
    WIN_REASON_FORFEIT = 'WIN_REASON_FORFEIT'
}

export type PlayerGetPlayersStatisticsResponse = {
    total?: number;
    playersByAge?: Array<SharedPointInt>;
    playersByRank?: Array<SharedPointString>;
    playersByYear?: Array<SharedPointInt>;
    playersCurrentYear?: SharedPointInt;
    playersByExp?: Array<SharedPointInt>;
    participantsByYear?: Array<SharedPointInt>;
    participantsCurrentYear?: SharedPointInt;
    newbiesByYear?: Array<SharedPointInt>;
    newbiesByAge?: Array<SharedPointInt>;
    ratingHighest?: number;
    ratingAverage?: number;
    ageGroups?: Array<SharedStat>;
    topByRating?: Array<PlayerStat>;
    topByGold?: Array<PlayerStat>;
    topByPrize?: Array<PlayerStat>;
    topByNrTournaments?: Array<PlayerStat>;
    topByNrOpps?: Array<PlayerStat>;
    topByNrGames?: Array<PlayerStat>;
    topByWinPercent?: Array<PlayerStat>;
    participantsTotal?: number;
    participantsAverage?: number;
    travelers?: number;
};

export type PlayerListPlayerRatingResponse = {
    history?: Array<RatingRating>;
};

export type PlayerListPlayerTournamentsResponse = {
    tournaments?: Array<PlayerTournament>;
};

export type PlayerListPlayersLocationsResponse = {
    locations?: Array<LocationShort>;
};

export type PlayerListPlayersResponse = {
    players?: Array<PlayerPlayer>;
    totalCount?: number;
};

export type PlayerStat = {
    id?: string;
    name?: string;
    value?: number;
};

export type PlayerTournament = {
    id?: string;
    federation?: 'rgf' | 'egf' | 'spt';
    title?: string;
    city?: string;
    category?: 'none' | 'local' | 'regional' | 'federal' | 'world' | 'online';
    startDate?: string;
    endDate?: string;
    playerCount?: number;
    roundCount?: number;
    online?: boolean;
    server?: string;
    ranked?: boolean;
    teamSize?: number;
    rank?: string;
    ratingIn?: number;
    ratingOut?: number;
    place?: number;
    position?: number;
    games?: number;
    won?: number;
    lost?: number;
    strength?: number;
    avgOpponentRating?: number;
};

export type StudyServiceApplyParticipantBody = {
    name?: string;
    email?: string;
    phone?: string;
};

export type StudyServiceUpdateCoachBody = {
    description?: string;
    skills?: Array<string>;
};

export type StudyServiceUpdateProductBody = {
    coachId?: string;
    title?: string;
    summary?: string;
    description?: string;
    unitPrice?: SharedAmount;
    packageSize?: number;
    type?: StudyProductType;
    schedule?: SharedSchedule;
    slotsTotal?: number;
    logo?: string;
};

export type StudyCoach = {
    id?: string;
    playerId?: string;
    name?: string;
    federation?: SharedFederation;
    rating?: number;
    rank?: string;
    avatar?: string;
    description?: string;
    skills?: Array<string>;
    products?: Array<string>;
};

export type StudyCreateUpdateCoachRequest = {
    id?: string;
    description?: string;
    skills?: Array<string>;
};

export type StudyCreateUpdateProductRequest = {
    id?: string;
    coachId?: string;
    title?: string;
    summary?: string;
    description?: string;
    unitPrice?: SharedAmount;
    packageSize?: number;
    type?: StudyProductType;
    schedule?: SharedSchedule;
    slotsTotal?: number;
    logo?: string;
};

export type StudyListCoachesResponse = {
    coaches?: Array<StudyCoach>;
};

export type StudyListProductsResponse = {
    products?: Array<StudyProduct>;
};

export type StudyParticipant = {
    id?: string;
    productId?: string;
    name?: string;
    email?: string;
    phone?: string;
    registeredAt?: string;
    paid?: boolean;
};

export type StudyProduct = {
    id?: string;
    title?: string;
    summary?: string;
    description?: string;
    unitPrice?: SharedAmount;
    packageSize?: number;
    type?: StudyProductType;
    schedule?: SharedSchedule;
    nextSession?: string;
    slotsTotal?: number;
    slotsFree?: number;
    logo?: string;
    coach?: StudyCoach;
    participants?: Array<StudyParticipant>;
};

export enum StudyProductType {
    PRODUCT_TYPE_UNSPECIFIED = 'PRODUCT_TYPE_UNSPECIFIED',
    PRODUCT_TYPE_COURSE = 'PRODUCT_TYPE_COURSE',
    PRODUCT_TYPE_MASTER_CLASS = 'PRODUCT_TYPE_MASTER_CLASS'
}

export type AuthServiceRefreshLinkedAccountCredentialsBody = {
    [key: string]: unknown;
};

export type AuthServiceStartAccountLinkBody = {
    [key: string]: unknown;
};

export type AuthLinkedAccount = {
    federation?: string;
    externalId?: string;
    scopes?: Array<string>;
    credentialStatuses?: Array<AuthLinkedAccountCredentialStatus>;
};

export enum AuthLinkedAccountCredentialKind {
    LINKED_ACCOUNT_CREDENTIAL_KIND_UNSPECIFIED = 'LINKED_ACCOUNT_CREDENTIAL_KIND_UNSPECIFIED',
    LINKED_ACCOUNT_CREDENTIAL_KIND_ACCESS = 'LINKED_ACCOUNT_CREDENTIAL_KIND_ACCESS',
    LINKED_ACCOUNT_CREDENTIAL_KIND_REALTIME = 'LINKED_ACCOUNT_CREDENTIAL_KIND_REALTIME',
    LINKED_ACCOUNT_CREDENTIAL_KIND_USER = 'LINKED_ACCOUNT_CREDENTIAL_KIND_USER',
    LINKED_ACCOUNT_CREDENTIAL_KIND_GAME = 'LINKED_ACCOUNT_CREDENTIAL_KIND_GAME'
}

/**
 * Safe metadata about a stored provider credential. The credential itself is
 * intentionally only available through the internal auth RPC.
 */
export type AuthLinkedAccountCredentialStatus = {
    kind?: AuthLinkedAccountCredentialKind;
    expiresAt?: string;
};

export type AuthListLinkedAccountsResponse = {
    accounts?: Array<AuthLinkedAccount>;
};

export type AuthLoginRequest = {
    username?: string;
    password?: string;
};

export type AuthLoginResponse = {
    pending?: boolean;
    redirectUrl?: string;
    user?: UserUser;
    jwt?: string;
    refresh?: string;
};

export type AuthRegisterRequest = {
    username?: string;
    email?: string;
    password?: string;
};

export type AuthRegisterResponse = {
    id?: string;
};

export type AuthStartAccountLinkResponse = {
    authorizationUrl?: string;
    linked?: boolean;
};

export type ProfileServiceAdminRenameProfileData = {
    body: ProfileChangeName;
    path: {
        id: string;
    };
    query?: {
        lang?: string;
    };
    url: '/admin/profile/rename/{id}';
};

export type ProfileServiceAdminRenameProfileErrors = {
    /**
     * An unexpected error response.
     */
    default: RpcStatus;
};

export type ProfileServiceAdminRenameProfileError = ProfileServiceAdminRenameProfileErrors[keyof ProfileServiceAdminRenameProfileErrors];

export type ProfileServiceAdminRenameProfileResponses = {
    /**
     * A successful response.
     */
    200: {
        [key: string]: unknown;
    };
};

export type ProfileServiceAdminRenameProfileResponse = ProfileServiceAdminRenameProfileResponses[keyof ProfileServiceAdminRenameProfileResponses];

export type ProfileServiceGetProfileData = {
    body?: never;
    path: {
        id: string;
    };
    query?: {
        federation?: 'rgf' | 'egf' | 'spt';
    };
    url: '/profile/{id}';
};

export type ProfileServiceGetProfileErrors = {
    /**
     * An unexpected error response.
     */
    default: RpcStatus;
};

export type ProfileServiceGetProfileError = ProfileServiceGetProfileErrors[keyof ProfileServiceGetProfileErrors];

export type ProfileServiceGetProfileResponses = {
    /**
     * A successful response.
     */
    200: ProfileProfile;
};

export type ProfileServiceGetProfileResponse = ProfileServiceGetProfileResponses[keyof ProfileServiceGetProfileResponses];

export type ProfileServiceListPlayerGamesData = {
    body?: never;
    path: {
        id: string;
    };
    query?: {
        playerType?: 'PLAYER_TYPE_UNSPECIFIED' | 'PLAYER_TYPE_ALL' | 'PLAYER_TYPE_HUMAN' | 'PLAYER_TYPE_BOT';
        federation?: 'rgf' | 'egf' | 'spt';
    };
    url: '/profile/{id}/games';
};

export type ProfileServiceListPlayerGamesErrors = {
    /**
     * An unexpected error response.
     */
    default: RpcStatus;
};

export type ProfileServiceListPlayerGamesError = ProfileServiceListPlayerGamesErrors[keyof ProfileServiceListPlayerGamesErrors];

export type ProfileServiceListPlayerGamesResponses = {
    /**
     * A successful response.
     */
    200: ProfileListPlayerGamesResponse;
};

export type ProfileServiceListPlayerGamesResponse = ProfileServiceListPlayerGamesResponses[keyof ProfileServiceListPlayerGamesResponses];

export type ProfileServiceListPlayerOpponentsData = {
    body?: never;
    path: {
        id: string;
    };
    query?: {
        playerType?: 'PLAYER_TYPE_UNSPECIFIED' | 'PLAYER_TYPE_ALL' | 'PLAYER_TYPE_HUMAN' | 'PLAYER_TYPE_BOT';
        federation?: 'rgf' | 'egf' | 'spt';
    };
    url: '/profile/{id}/opponents';
};

export type ProfileServiceListPlayerOpponentsErrors = {
    /**
     * An unexpected error response.
     */
    default: RpcStatus;
};

export type ProfileServiceListPlayerOpponentsError = ProfileServiceListPlayerOpponentsErrors[keyof ProfileServiceListPlayerOpponentsErrors];

export type ProfileServiceListPlayerOpponentsResponses = {
    /**
     * A successful response.
     */
    200: ProfileListPlayerOpponentsResponse;
};

export type ProfileServiceListPlayerOpponentsResponse = ProfileServiceListPlayerOpponentsResponses[keyof ProfileServiceListPlayerOpponentsResponses];

export type ProfileServiceGetStatisticsData = {
    body?: never;
    path: {
        id: string;
    };
    query?: {
        playerType?: 'PLAYER_TYPE_UNSPECIFIED' | 'PLAYER_TYPE_ALL' | 'PLAYER_TYPE_HUMAN' | 'PLAYER_TYPE_BOT';
        federation?: 'rgf' | 'egf' | 'spt';
    };
    url: '/profile/{id}/statistics';
};

export type ProfileServiceGetStatisticsErrors = {
    /**
     * An unexpected error response.
     */
    default: RpcStatus;
};

export type ProfileServiceGetStatisticsError = ProfileServiceGetStatisticsErrors[keyof ProfileServiceGetStatisticsErrors];

export type ProfileServiceGetStatisticsResponses = {
    /**
     * A successful response.
     */
    200: ProfileGetStatisticsResponse;
};

export type ProfileServiceGetStatisticsResponse = ProfileServiceGetStatisticsResponses[keyof ProfileServiceGetStatisticsResponses];

export type ArticleServiceListArticlesData = {
    body?: never;
    path?: never;
    query?: {
        search?: Array<string>;
        title?: Array<string>;
        content?: Array<string>;
        status?: Array<'draft' | 'scheduled' | 'published' | 'archived'>;
        tags?: Array<string>;
        category?: Array<string>;
        type?: Array<string>;
        language?: Array<'ru' | 'en'>;
        location?: Array<number>;
        sort?: Array<'updated_at' | 'published_at' | 'created_at' | 'scheduled_at'>;
        order?: Array<'asc' | 'desc'>;
        limit?: number;
        offset?: number;
        minPublishedAt?: string;
        maxPublishedAt?: string;
    };
    url: '/articles';
};

export type ArticleServiceListArticlesErrors = {
    /**
     * An unexpected error response.
     */
    default: RpcStatus;
};

export type ArticleServiceListArticlesError = ArticleServiceListArticlesErrors[keyof ArticleServiceListArticlesErrors];

export type ArticleServiceListArticlesResponses = {
    /**
     * A successful response.
     */
    200: ArticleListArticlesResponse;
};

export type ArticleServiceListArticlesResponse = ArticleServiceListArticlesResponses[keyof ArticleServiceListArticlesResponses];

export type ArticleServiceCreateArticleData = {
    body: ArticleCreateUpdateArticleRequest;
    path?: never;
    query?: never;
    url: '/articles';
};

export type ArticleServiceCreateArticleErrors = {
    /**
     * An unexpected error response.
     */
    default: RpcStatus;
};

export type ArticleServiceCreateArticleError = ArticleServiceCreateArticleErrors[keyof ArticleServiceCreateArticleErrors];

export type ArticleServiceCreateArticleResponses = {
    /**
     * A successful response.
     */
    200: ArticleArticle;
};

export type ArticleServiceCreateArticleResponse = ArticleServiceCreateArticleResponses[keyof ArticleServiceCreateArticleResponses];

export type ArticleServiceGetArticleTagsData = {
    body?: never;
    path?: never;
    query?: {
        languages?: Array<string>;
        types?: Array<string>;
    };
    url: '/articles/tags';
};

export type ArticleServiceGetArticleTagsErrors = {
    /**
     * An unexpected error response.
     */
    default: RpcStatus;
};

export type ArticleServiceGetArticleTagsError = ArticleServiceGetArticleTagsErrors[keyof ArticleServiceGetArticleTagsErrors];

export type ArticleServiceGetArticleTagsResponses = {
    /**
     * A successful response.
     */
    200: ArticleGetArticleTagsResponse;
};

export type ArticleServiceGetArticleTagsResponse = ArticleServiceGetArticleTagsResponses[keyof ArticleServiceGetArticleTagsResponses];

export type ArticleServiceDeleteArticleData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/articles/{id}';
};

export type ArticleServiceDeleteArticleErrors = {
    /**
     * An unexpected error response.
     */
    default: RpcStatus;
};

export type ArticleServiceDeleteArticleError = ArticleServiceDeleteArticleErrors[keyof ArticleServiceDeleteArticleErrors];

export type ArticleServiceDeleteArticleResponses = {
    /**
     * A successful response.
     */
    200: {
        [key: string]: unknown;
    };
};

export type ArticleServiceDeleteArticleResponse = ArticleServiceDeleteArticleResponses[keyof ArticleServiceDeleteArticleResponses];

export type ArticleServiceGetArticleData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/articles/{id}';
};

export type ArticleServiceGetArticleErrors = {
    /**
     * An unexpected error response.
     */
    default: RpcStatus;
};

export type ArticleServiceGetArticleError = ArticleServiceGetArticleErrors[keyof ArticleServiceGetArticleErrors];

export type ArticleServiceGetArticleResponses = {
    /**
     * A successful response.
     */
    200: ArticleArticle;
};

export type ArticleServiceGetArticleResponse = ArticleServiceGetArticleResponses[keyof ArticleServiceGetArticleResponses];

export type ArticleServiceUpdateArticleData = {
    body: ArticleServiceUpdateArticleBody;
    path: {
        id: string;
    };
    query?: never;
    url: '/articles/{id}';
};

export type ArticleServiceUpdateArticleErrors = {
    /**
     * An unexpected error response.
     */
    default: RpcStatus;
};

export type ArticleServiceUpdateArticleError = ArticleServiceUpdateArticleErrors[keyof ArticleServiceUpdateArticleErrors];

export type ArticleServiceUpdateArticleResponses = {
    /**
     * A successful response.
     */
    200: {
        [key: string]: unknown;
    };
};

export type ArticleServiceUpdateArticleResponse = ArticleServiceUpdateArticleResponses[keyof ArticleServiceUpdateArticleResponses];

export type ArticleServiceGetReactionsData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/articles/{id}/reactions';
};

export type ArticleServiceGetReactionsErrors = {
    /**
     * An unexpected error response.
     */
    default: RpcStatus;
};

export type ArticleServiceGetReactionsError = ArticleServiceGetReactionsErrors[keyof ArticleServiceGetReactionsErrors];

export type ArticleServiceGetReactionsResponses = {
    /**
     * A successful response.
     */
    200: ArticleGetReactionsResponse;
};

export type ArticleServiceGetReactionsResponse = ArticleServiceGetReactionsResponses[keyof ArticleServiceGetReactionsResponses];

export type ArticleServicePostReactionData = {
    body: ArticlePostReaction;
    path: {
        id: string;
    };
    query?: never;
    url: '/articles/{id}/reactions';
};

export type ArticleServicePostReactionErrors = {
    /**
     * An unexpected error response.
     */
    default: RpcStatus;
};

export type ArticleServicePostReactionError = ArticleServicePostReactionErrors[keyof ArticleServicePostReactionErrors];

export type ArticleServicePostReactionResponses = {
    /**
     * A successful response.
     */
    200: ArticleGetReactionsResponse;
};

export type ArticleServicePostReactionResponse = ArticleServicePostReactionResponses[keyof ArticleServicePostReactionResponses];

export type LocationServiceListLocationsData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/locations';
};

export type LocationServiceListLocationsErrors = {
    /**
     * An unexpected error response.
     */
    default: RpcStatus;
};

export type LocationServiceListLocationsError = LocationServiceListLocationsErrors[keyof LocationServiceListLocationsErrors];

export type LocationServiceListLocationsResponses = {
    /**
     * A successful response.
     */
    200: LocationListLocationsResponse;
};

export type LocationServiceListLocationsResponse = LocationServiceListLocationsResponses[keyof LocationServiceListLocationsResponses];

export type LocationServiceListLocationsChildrenData = {
    body?: never;
    path?: never;
    query?: {
        location?: Array<number>;
    };
    url: '/locations/children';
};

export type LocationServiceListLocationsChildrenErrors = {
    /**
     * An unexpected error response.
     */
    default: RpcStatus;
};

export type LocationServiceListLocationsChildrenError = LocationServiceListLocationsChildrenErrors[keyof LocationServiceListLocationsChildrenErrors];

export type LocationServiceListLocationsChildrenResponses = {
    /**
     * A successful response.
     */
    200: LocationListLocationsChildrenResponse;
};

export type LocationServiceListLocationsChildrenResponse = LocationServiceListLocationsChildrenResponses[keyof LocationServiceListLocationsChildrenResponses];

export type PaymentServiceGetDonationsInfoData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/admin/donations';
};

export type PaymentServiceGetDonationsInfoErrors = {
    /**
     * An unexpected error response.
     */
    default: RpcStatus;
};

export type PaymentServiceGetDonationsInfoError = PaymentServiceGetDonationsInfoErrors[keyof PaymentServiceGetDonationsInfoErrors];

export type PaymentServiceGetDonationsInfoResponses = {
    /**
     * A successful response.
     */
    200: PaymentDonationsInfo;
};

export type PaymentServiceGetDonationsInfoResponse = PaymentServiceGetDonationsInfoResponses[keyof PaymentServiceGetDonationsInfoResponses];

export type PaymentServiceListDonationsData = {
    body?: never;
    path?: never;
    query?: {
        sumUp?: boolean;
    };
    url: '/donations';
};

export type PaymentServiceListDonationsErrors = {
    /**
     * An unexpected error response.
     */
    default: RpcStatus;
};

export type PaymentServiceListDonationsError = PaymentServiceListDonationsErrors[keyof PaymentServiceListDonationsErrors];

export type PaymentServiceListDonationsResponses = {
    /**
     * A successful response.
     */
    200: PaymentListDonationsResponse;
};

export type PaymentServiceListDonationsResponse = PaymentServiceListDonationsResponses[keyof PaymentServiceListDonationsResponses];

export type PaymentServiceListDonationVotesData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/donations/votes';
};

export type PaymentServiceListDonationVotesErrors = {
    /**
     * An unexpected error response.
     */
    default: RpcStatus;
};

export type PaymentServiceListDonationVotesError = PaymentServiceListDonationVotesErrors[keyof PaymentServiceListDonationVotesErrors];

export type PaymentServiceListDonationVotesResponses = {
    /**
     * A successful response.
     */
    200: PaymentListDonationVotesResponse;
};

export type PaymentServiceListDonationVotesResponse = PaymentServiceListDonationVotesResponses[keyof PaymentServiceListDonationVotesResponses];

export type PaymentServiceCastDonationVotesData = {
    body: PaymentCastDonationVotesRequest;
    path?: never;
    query?: never;
    url: '/donations/votes';
};

export type PaymentServiceCastDonationVotesErrors = {
    /**
     * An unexpected error response.
     */
    default: RpcStatus;
};

export type PaymentServiceCastDonationVotesError = PaymentServiceCastDonationVotesErrors[keyof PaymentServiceCastDonationVotesErrors];

export type PaymentServiceCastDonationVotesResponses = {
    /**
     * A successful response.
     */
    200: {
        [key: string]: unknown;
    };
};

export type PaymentServiceCastDonationVotesResponse = PaymentServiceCastDonationVotesResponses[keyof PaymentServiceCastDonationVotesResponses];

export type PaymentServiceGetDonationData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/donations/{id}';
};

export type PaymentServiceGetDonationErrors = {
    /**
     * An unexpected error response.
     */
    default: RpcStatus;
};

export type PaymentServiceGetDonationError = PaymentServiceGetDonationErrors[keyof PaymentServiceGetDonationErrors];

export type PaymentServiceGetDonationResponses = {
    /**
     * A successful response.
     */
    200: PaymentDonation;
};

export type PaymentServiceGetDonationResponse = PaymentServiceGetDonationResponses[keyof PaymentServiceGetDonationResponses];

export type PaymentServiceGetDonationsSelfData = {
    body?: never;
    path?: never;
    query?: {
        eventId?: string;
    };
    url: '/donations:self';
};

export type PaymentServiceGetDonationsSelfErrors = {
    /**
     * An unexpected error response.
     */
    default: RpcStatus;
};

export type PaymentServiceGetDonationsSelfError = PaymentServiceGetDonationsSelfErrors[keyof PaymentServiceGetDonationsSelfErrors];

export type PaymentServiceGetDonationsSelfResponses = {
    /**
     * A successful response.
     */
    200: PaymentGetDonationsResponse;
};

export type PaymentServiceGetDonationsSelfResponse = PaymentServiceGetDonationsSelfResponses[keyof PaymentServiceGetDonationsSelfResponses];

export type PaymentServiceGetDonationsTotalsData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/donations:total';
};

export type PaymentServiceGetDonationsTotalsErrors = {
    /**
     * An unexpected error response.
     */
    default: RpcStatus;
};

export type PaymentServiceGetDonationsTotalsError = PaymentServiceGetDonationsTotalsErrors[keyof PaymentServiceGetDonationsTotalsErrors];

export type PaymentServiceGetDonationsTotalsResponses = {
    /**
     * A successful response.
     */
    200: PaymentGetDonationsTotalsResponse;
};

export type PaymentServiceGetDonationsTotalsResponse = PaymentServiceGetDonationsTotalsResponses[keyof PaymentServiceGetDonationsTotalsResponses];

export type PaymentServiceCreatePaymentData = {
    body: PaymentCreatePaymentRequest;
    path?: never;
    query?: never;
    url: '/payments';
};

export type PaymentServiceCreatePaymentErrors = {
    /**
     * An unexpected error response.
     */
    default: RpcStatus;
};

export type PaymentServiceCreatePaymentError = PaymentServiceCreatePaymentErrors[keyof PaymentServiceCreatePaymentErrors];

export type PaymentServiceCreatePaymentResponses = {
    /**
     * A successful response.
     */
    200: PaymentCreatePaymentResponse;
};

export type PaymentServiceCreatePaymentResponse = PaymentServiceCreatePaymentResponses[keyof PaymentServiceCreatePaymentResponses];

export type PaymentServiceGetVoucherInfoData = {
    body?: never;
    path: {
        code: string;
    };
    query?: never;
    url: '/vouchers/{code}';
};

export type PaymentServiceGetVoucherInfoErrors = {
    /**
     * An unexpected error response.
     */
    default: RpcStatus;
};

export type PaymentServiceGetVoucherInfoError = PaymentServiceGetVoucherInfoErrors[keyof PaymentServiceGetVoucherInfoErrors];

export type PaymentServiceGetVoucherInfoResponses = {
    /**
     * A successful response.
     */
    200: PaymentVoucherInfo;
};

export type PaymentServiceGetVoucherInfoResponse = PaymentServiceGetVoucherInfoResponses[keyof PaymentServiceGetVoucherInfoResponses];

export type UserServiceAdminLinkUserData = {
    body?: never;
    path: {
        id: string;
        pid: string;
    };
    query?: never;
    url: '/admin/user/{id}/link/{pid}';
};

export type UserServiceAdminLinkUserErrors = {
    /**
     * An unexpected error response.
     */
    default: RpcStatus;
};

export type UserServiceAdminLinkUserError = UserServiceAdminLinkUserErrors[keyof UserServiceAdminLinkUserErrors];

export type UserServiceAdminLinkUserResponses = {
    /**
     * A successful response.
     */
    200: {
        [key: string]: unknown;
    };
};

export type UserServiceAdminLinkUserResponse = UserServiceAdminLinkUserResponses[keyof UserServiceAdminLinkUserResponses];

export type UserServiceAdminUpdateRoleData = {
    body: UserRoles;
    path: {
        id: string;
    };
    query?: never;
    url: '/admin/user/{id}/roles';
};

export type UserServiceAdminUpdateRoleErrors = {
    /**
     * An unexpected error response.
     */
    default: RpcStatus;
};

export type UserServiceAdminUpdateRoleError = UserServiceAdminUpdateRoleErrors[keyof UserServiceAdminUpdateRoleErrors];

export type UserServiceAdminUpdateRoleResponses = {
    /**
     * A successful response.
     */
    200: {
        [key: string]: unknown;
    };
};

export type UserServiceAdminUpdateRoleResponse = UserServiceAdminUpdateRoleResponses[keyof UserServiceAdminUpdateRoleResponses];

export type UserServicePostFeedbackData = {
    body: UserFeedbackRequest;
    path?: never;
    query?: never;
    url: '/feedback';
};

export type UserServicePostFeedbackErrors = {
    /**
     * An unexpected error response.
     */
    default: RpcStatus;
};

export type UserServicePostFeedbackError = UserServicePostFeedbackErrors[keyof UserServicePostFeedbackErrors];

export type UserServicePostFeedbackResponses = {
    /**
     * A successful response.
     */
    200: {
        [key: string]: unknown;
    };
};

export type UserServicePostFeedbackResponse = UserServicePostFeedbackResponses[keyof UserServicePostFeedbackResponses];

export type UserServiceListUsersData = {
    body?: never;
    path?: never;
    query?: {
        username?: Array<string>;
        email?: Array<string>;
        role?: Array<string>;
        location?: Array<number>;
        sort?: Array<'username' | 'email' | 'reg_date' | 'last_updated'>;
        order?: Array<'asc' | 'desc'>;
        limit?: number;
        offset?: number;
    };
    url: '/users';
};

export type UserServiceListUsersErrors = {
    /**
     * An unexpected error response.
     */
    default: RpcStatus;
};

export type UserServiceListUsersError = UserServiceListUsersErrors[keyof UserServiceListUsersErrors];

export type UserServiceListUsersResponses = {
    /**
     * A successful response.
     */
    200: UserListUsersResponse;
};

export type UserServiceListUsersResponse = UserServiceListUsersResponses[keyof UserServiceListUsersResponses];

export type UserServiceDeleteAvatarSelfData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/users/avatar:self';
};

export type UserServiceDeleteAvatarSelfErrors = {
    /**
     * An unexpected error response.
     */
    default: RpcStatus;
};

export type UserServiceDeleteAvatarSelfError = UserServiceDeleteAvatarSelfErrors[keyof UserServiceDeleteAvatarSelfErrors];

export type UserServiceDeleteAvatarSelfResponses = {
    /**
     * A successful response.
     */
    200: {
        [key: string]: unknown;
    };
};

export type UserServiceDeleteAvatarSelfResponse = UserServiceDeleteAvatarSelfResponses[keyof UserServiceDeleteAvatarSelfResponses];

export type UserServiceGiveConsentData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/users/consent:self';
};

export type UserServiceGiveConsentErrors = {
    /**
     * An unexpected error response.
     */
    default: RpcStatus;
};

export type UserServiceGiveConsentError = UserServiceGiveConsentErrors[keyof UserServiceGiveConsentErrors];

export type UserServiceGiveConsentResponses = {
    /**
     * A successful response.
     */
    200: UserGiveConsentResponse;
};

export type UserServiceGiveConsentResponse = UserServiceGiveConsentResponses[keyof UserServiceGiveConsentResponses];

export type UserServiceGetUserInfoData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/users/info/{id}';
};

export type UserServiceGetUserInfoErrors = {
    /**
     * An unexpected error response.
     */
    default: RpcStatus;
};

export type UserServiceGetUserInfoError = UserServiceGetUserInfoErrors[keyof UserServiceGetUserInfoErrors];

export type UserServiceGetUserInfoResponses = {
    /**
     * A successful response.
     */
    200: UserUserInfo;
};

export type UserServiceGetUserInfoResponse = UserServiceGetUserInfoResponses[keyof UserServiceGetUserInfoResponses];

export type UserServiceUpdateUserInfoData = {
    body: UserUserInfo;
    path: {
        id: string;
    };
    query?: never;
    url: '/users/info/{id}';
};

export type UserServiceUpdateUserInfoErrors = {
    /**
     * An unexpected error response.
     */
    default: RpcStatus;
};

export type UserServiceUpdateUserInfoError = UserServiceUpdateUserInfoErrors[keyof UserServiceUpdateUserInfoErrors];

export type UserServiceUpdateUserInfoResponses = {
    /**
     * A successful response.
     */
    200: {
        [key: string]: unknown;
    };
};

export type UserServiceUpdateUserInfoResponse = UserServiceUpdateUserInfoResponses[keyof UserServiceUpdateUserInfoResponses];

export type UserServiceGetUserInfoSelfData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/users/info:self';
};

export type UserServiceGetUserInfoSelfErrors = {
    /**
     * An unexpected error response.
     */
    default: RpcStatus;
};

export type UserServiceGetUserInfoSelfError = UserServiceGetUserInfoSelfErrors[keyof UserServiceGetUserInfoSelfErrors];

export type UserServiceGetUserInfoSelfResponses = {
    /**
     * A successful response.
     */
    200: UserUserInfo;
};

export type UserServiceGetUserInfoSelfResponse = UserServiceGetUserInfoSelfResponses[keyof UserServiceGetUserInfoSelfResponses];

export type UserServiceUpdateUserInfoSelfData = {
    body: UserUserInfo;
    path?: never;
    query?: never;
    url: '/users/info:self';
};

export type UserServiceUpdateUserInfoSelfErrors = {
    /**
     * An unexpected error response.
     */
    default: RpcStatus;
};

export type UserServiceUpdateUserInfoSelfError = UserServiceUpdateUserInfoSelfErrors[keyof UserServiceUpdateUserInfoSelfErrors];

export type UserServiceUpdateUserInfoSelfResponses = {
    /**
     * A successful response.
     */
    200: {
        [key: string]: unknown;
    };
};

export type UserServiceUpdateUserInfoSelfResponse = UserServiceUpdateUserInfoSelfResponses[keyof UserServiceUpdateUserInfoSelfResponses];

export type UserServiceUpdatePasswordData = {
    body: UserUpdateUserDataRequest;
    path?: never;
    query?: never;
    url: '/users/password';
};

export type UserServiceUpdatePasswordErrors = {
    /**
     * An unexpected error response.
     */
    default: RpcStatus;
};

export type UserServiceUpdatePasswordError = UserServiceUpdatePasswordErrors[keyof UserServiceUpdatePasswordErrors];

export type UserServiceUpdatePasswordResponses = {
    /**
     * A successful response.
     */
    200: {
        [key: string]: unknown;
    };
};

export type UserServiceUpdatePasswordResponse = UserServiceUpdatePasswordResponses[keyof UserServiceUpdatePasswordResponses];

export type UserServiceCheckPasswordCodeData = {
    body?: never;
    path: {
        code: string;
    };
    query?: never;
    url: '/users/password/{code}';
};

export type UserServiceCheckPasswordCodeErrors = {
    /**
     * An unexpected error response.
     */
    default: RpcStatus;
};

export type UserServiceCheckPasswordCodeError = UserServiceCheckPasswordCodeErrors[keyof UserServiceCheckPasswordCodeErrors];

export type UserServiceCheckPasswordCodeResponses = {
    /**
     * A successful response.
     */
    200: {
        [key: string]: unknown;
    };
};

export type UserServiceCheckPasswordCodeResponse = UserServiceCheckPasswordCodeResponses[keyof UserServiceCheckPasswordCodeResponses];

export type UserServiceActivatePasswordCodeData = {
    body: UserUpdateUserDataRequest;
    path: {
        code: string;
    };
    query?: never;
    url: '/users/password/{code}';
};

export type UserServiceActivatePasswordCodeErrors = {
    /**
     * An unexpected error response.
     */
    default: RpcStatus;
};

export type UserServiceActivatePasswordCodeError = UserServiceActivatePasswordCodeErrors[keyof UserServiceActivatePasswordCodeErrors];

export type UserServiceActivatePasswordCodeResponses = {
    /**
     * A successful response.
     */
    200: {
        [key: string]: unknown;
    };
};

export type UserServiceActivatePasswordCodeResponse = UserServiceActivatePasswordCodeResponses[keyof UserServiceActivatePasswordCodeResponses];

export type UserServiceResetPasswordData = {
    body: UserIdentityRequest;
    path?: never;
    query?: never;
    url: '/users/password:reset';
};

export type UserServiceResetPasswordErrors = {
    /**
     * An unexpected error response.
     */
    default: RpcStatus;
};

export type UserServiceResetPasswordError = UserServiceResetPasswordErrors[keyof UserServiceResetPasswordErrors];

export type UserServiceResetPasswordResponses = {
    /**
     * A successful response.
     */
    200: {
        [key: string]: unknown;
    };
};

export type UserServiceResetPasswordResponse = UserServiceResetPasswordResponses[keyof UserServiceResetPasswordResponses];

export type UserServiceSetUserRankData = {
    body: UserSetUserRankRequest;
    path?: never;
    query?: never;
    url: '/users/rank:self';
};

export type UserServiceSetUserRankErrors = {
    /**
     * An unexpected error response.
     */
    default: RpcStatus;
};

export type UserServiceSetUserRankError = UserServiceSetUserRankErrors[keyof UserServiceSetUserRankErrors];

export type UserServiceSetUserRankResponses = {
    /**
     * A successful response.
     */
    200: {
        [key: string]: unknown;
    };
};

export type UserServiceSetUserRankResponse = UserServiceSetUserRankResponses[keyof UserServiceSetUserRankResponses];

export type UserServiceUpdateUsernameData = {
    body: UserUpdateUserDataRequest;
    path?: never;
    query?: never;
    url: '/users/username';
};

export type UserServiceUpdateUsernameErrors = {
    /**
     * An unexpected error response.
     */
    default: RpcStatus;
};

export type UserServiceUpdateUsernameError = UserServiceUpdateUsernameErrors[keyof UserServiceUpdateUsernameErrors];

export type UserServiceUpdateUsernameResponses = {
    /**
     * A successful response.
     */
    200: {
        [key: string]: unknown;
    };
};

export type UserServiceUpdateUsernameResponse = UserServiceUpdateUsernameResponses[keyof UserServiceUpdateUsernameResponses];

export type UserServiceListUserLoginDetailsData = {
    body?: never;
    path: {
        identity: string;
    };
    query?: never;
    url: '/users/{identity}:login';
};

export type UserServiceListUserLoginDetailsErrors = {
    /**
     * An unexpected error response.
     */
    default: RpcStatus;
};

export type UserServiceListUserLoginDetailsError = UserServiceListUserLoginDetailsErrors[keyof UserServiceListUserLoginDetailsErrors];

export type UserServiceListUserLoginDetailsResponses = {
    /**
     * A successful response.
     */
    200: UserListUserLoginDetailsResponse;
};

export type UserServiceListUserLoginDetailsResponse = UserServiceListUserLoginDetailsResponses[keyof UserServiceListUserLoginDetailsResponses];

export type UserServiceDeleteUserData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/users/{id}';
};

export type UserServiceDeleteUserErrors = {
    /**
     * An unexpected error response.
     */
    default: RpcStatus;
};

export type UserServiceDeleteUserError = UserServiceDeleteUserErrors[keyof UserServiceDeleteUserErrors];

export type UserServiceDeleteUserResponses = {
    /**
     * A successful response.
     */
    200: {
        [key: string]: unknown;
    };
};

export type UserServiceDeleteUserResponse = UserServiceDeleteUserResponses[keyof UserServiceDeleteUserResponses];

export type UserServiceGetUserData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/users/{id}';
};

export type UserServiceGetUserErrors = {
    /**
     * An unexpected error response.
     */
    default: RpcStatus;
};

export type UserServiceGetUserError = UserServiceGetUserErrors[keyof UserServiceGetUserErrors];

export type UserServiceGetUserResponses = {
    /**
     * A successful response.
     */
    200: UserUser;
};

export type UserServiceGetUserResponse = UserServiceGetUserResponses[keyof UserServiceGetUserResponses];

export type UserServiceGetUserPlayerData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/users/{id}:player';
};

export type UserServiceGetUserPlayerErrors = {
    /**
     * An unexpected error response.
     */
    default: RpcStatus;
};

export type UserServiceGetUserPlayerError = UserServiceGetUserPlayerErrors[keyof UserServiceGetUserPlayerErrors];

export type UserServiceGetUserPlayerResponses = {
    /**
     * A successful response.
     */
    200: PlayerPlayer;
};

export type UserServiceGetUserPlayerResponse = UserServiceGetUserPlayerResponses[keyof UserServiceGetUserPlayerResponses];

export type UserServiceListUsersRolesData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/users:roles';
};

export type UserServiceListUsersRolesErrors = {
    /**
     * An unexpected error response.
     */
    default: RpcStatus;
};

export type UserServiceListUsersRolesError = UserServiceListUsersRolesErrors[keyof UserServiceListUsersRolesErrors];

export type UserServiceListUsersRolesResponses = {
    /**
     * A successful response.
     */
    200: UserRoles;
};

export type UserServiceListUsersRolesResponse = UserServiceListUsersRolesResponses[keyof UserServiceListUsersRolesResponses];

export type UserServiceDeleteUserSelfData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/users:self';
};

export type UserServiceDeleteUserSelfErrors = {
    /**
     * An unexpected error response.
     */
    default: RpcStatus;
};

export type UserServiceDeleteUserSelfError = UserServiceDeleteUserSelfErrors[keyof UserServiceDeleteUserSelfErrors];

export type UserServiceDeleteUserSelfResponses = {
    /**
     * A successful response.
     */
    200: {
        [key: string]: unknown;
    };
};

export type UserServiceDeleteUserSelfResponse = UserServiceDeleteUserSelfResponses[keyof UserServiceDeleteUserSelfResponses];

export type UserServiceGetUserSelfData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/users:self';
};

export type UserServiceGetUserSelfErrors = {
    /**
     * An unexpected error response.
     */
    default: RpcStatus;
};

export type UserServiceGetUserSelfError = UserServiceGetUserSelfErrors[keyof UserServiceGetUserSelfErrors];

export type UserServiceGetUserSelfResponses = {
    /**
     * A successful response.
     */
    200: UserUser;
};

export type UserServiceGetUserSelfResponse = UserServiceGetUserSelfResponses[keyof UserServiceGetUserSelfResponses];

export type TournamentServiceAdminTournamentIgnoreData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/admin/tournaments/ignore/{id}';
};

export type TournamentServiceAdminTournamentIgnoreErrors = {
    /**
     * An unexpected error response.
     */
    default: GoogleRpcStatus;
};

export type TournamentServiceAdminTournamentIgnoreError = TournamentServiceAdminTournamentIgnoreErrors[keyof TournamentServiceAdminTournamentIgnoreErrors];

export type TournamentServiceAdminTournamentIgnoreResponses = {
    /**
     * A successful response.
     */
    200: TournamentAdminTournamentIgnoreResponse;
};

export type TournamentServiceAdminTournamentIgnoreResponse = TournamentServiceAdminTournamentIgnoreResponses[keyof TournamentServiceAdminTournamentIgnoreResponses];

export type TournamentServiceAdminTournamentsLocationsData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/admin/tournaments/locations';
};

export type TournamentServiceAdminTournamentsLocationsErrors = {
    /**
     * An unexpected error response.
     */
    default: GoogleRpcStatus;
};

export type TournamentServiceAdminTournamentsLocationsError = TournamentServiceAdminTournamentsLocationsErrors[keyof TournamentServiceAdminTournamentsLocationsErrors];

export type TournamentServiceAdminTournamentsLocationsResponses = {
    /**
     * A successful response.
     */
    200: TournamentAdminTournamentsLocationsResponse;
};

export type TournamentServiceAdminTournamentsLocationsResponse = TournamentServiceAdminTournamentsLocationsResponses[keyof TournamentServiceAdminTournamentsLocationsResponses];

export type TournamentServiceAdminTournamentPinData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/admin/tournaments/pin/{id}';
};

export type TournamentServiceAdminTournamentPinErrors = {
    /**
     * An unexpected error response.
     */
    default: GoogleRpcStatus;
};

export type TournamentServiceAdminTournamentPinError = TournamentServiceAdminTournamentPinErrors[keyof TournamentServiceAdminTournamentPinErrors];

export type TournamentServiceAdminTournamentPinResponses = {
    /**
     * A successful response.
     */
    200: TournamentAdminTournamentPinResponse;
};

export type TournamentServiceAdminTournamentPinResponse = TournamentServiceAdminTournamentPinResponses[keyof TournamentServiceAdminTournamentPinResponses];

export type TournamentServiceAdminTournamentProcessData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/admin/tournaments/process/{id}';
};

export type TournamentServiceAdminTournamentProcessErrors = {
    /**
     * An unexpected error response.
     */
    default: GoogleRpcStatus;
};

export type TournamentServiceAdminTournamentProcessError = TournamentServiceAdminTournamentProcessErrors[keyof TournamentServiceAdminTournamentProcessErrors];

export type TournamentServiceAdminTournamentProcessResponses = {
    /**
     * A successful response.
     */
    200: TournamentAdminTournamentProcessResponse;
};

export type TournamentServiceAdminTournamentProcessResponse = TournamentServiceAdminTournamentProcessResponses[keyof TournamentServiceAdminTournamentProcessResponses];

export type TournamentServiceAdminTournamentLocationData = {
    body?: never;
    path: {
        id: string;
        location: number;
    };
    query?: never;
    url: '/admin/tournaments/{id}/location/{location}';
};

export type TournamentServiceAdminTournamentLocationErrors = {
    /**
     * An unexpected error response.
     */
    default: GoogleRpcStatus;
};

export type TournamentServiceAdminTournamentLocationError = TournamentServiceAdminTournamentLocationErrors[keyof TournamentServiceAdminTournamentLocationErrors];

export type TournamentServiceAdminTournamentLocationResponses = {
    /**
     * A successful response.
     */
    200: {
        [key: string]: unknown;
    };
};

export type TournamentServiceAdminTournamentLocationResponse = TournamentServiceAdminTournamentLocationResponses[keyof TournamentServiceAdminTournamentLocationResponses];

export type TournamentServiceListTournamentsData = {
    body?: never;
    path?: never;
    query?: {
        federation?: 'rgf' | 'egf' | 'spt';
        title?: Array<string>;
        city?: Array<string>;
        location?: Array<number>;
        server?: Array<string>;
        timeControl?: Array<string>;
        timeClass?: Array<'1' | '2' | '3'>;
        normClass?: Array<'1' | '2' | '3' | '4'>;
        rules?: Array<string>;
        online?: boolean;
        ranked?: boolean;
        sort?: Array<'federation' | 'title' | 'server' | 'start_date' | 'end_date' | 'num_registered' | 'num_players' | 'num_rounds' | 'status'>;
        order?: Array<'asc' | 'desc'>;
        limit?: number;
        offset?: number;
        minPlayerCount?: number;
        maxPlayerCount?: number;
        minRoundCount?: number;
        maxRoundCount?: number;
        minStartDate?: string;
        maxStartDate?: string;
        minEndDate?: string;
        maxEndDate?: string;
        status?: Array<'ended' | 'processing' | 'active' | 'scheduled'>;
        showIgnored?: boolean;
        pinnedFirst?: boolean;
    };
    url: '/tournaments';
};

export type TournamentServiceListTournamentsErrors = {
    /**
     * An unexpected error response.
     */
    default: GoogleRpcStatus;
};

export type TournamentServiceListTournamentsError = TournamentServiceListTournamentsErrors[keyof TournamentServiceListTournamentsErrors];

export type TournamentServiceListTournamentsResponses = {
    /**
     * A successful response.
     */
    200: TournamentListTournamentsResponse;
};

export type TournamentServiceListTournamentsResponse = TournamentServiceListTournamentsResponses[keyof TournamentServiceListTournamentsResponses];

export type TournamentServiceGetTournamentData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/tournaments/{id}';
};

export type TournamentServiceGetTournamentErrors = {
    /**
     * An unexpected error response.
     */
    default: GoogleRpcStatus;
};

export type TournamentServiceGetTournamentError = TournamentServiceGetTournamentErrors[keyof TournamentServiceGetTournamentErrors];

export type TournamentServiceGetTournamentResponses = {
    /**
     * A successful response.
     */
    200: TournamentTournament;
};

export type TournamentServiceGetTournamentResponse = TournamentServiceGetTournamentResponses[keyof TournamentServiceGetTournamentResponses];

export type TournamentServiceListTournamentGamesData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/tournaments/{id}/games';
};

export type TournamentServiceListTournamentGamesErrors = {
    /**
     * An unexpected error response.
     */
    default: GoogleRpcStatus;
};

export type TournamentServiceListTournamentGamesError = TournamentServiceListTournamentGamesErrors[keyof TournamentServiceListTournamentGamesErrors];

export type TournamentServiceListTournamentGamesResponses = {
    /**
     * A successful response.
     */
    200: TournamentListTournamentGamesResponse;
};

export type TournamentServiceListTournamentGamesResponse = TournamentServiceListTournamentGamesResponses[keyof TournamentServiceListTournamentGamesResponses];

export type TournamentServiceGetTournamentStatisticsData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/tournaments/{id}/statistics';
};

export type TournamentServiceGetTournamentStatisticsErrors = {
    /**
     * An unexpected error response.
     */
    default: GoogleRpcStatus;
};

export type TournamentServiceGetTournamentStatisticsError = TournamentServiceGetTournamentStatisticsErrors[keyof TournamentServiceGetTournamentStatisticsErrors];

export type TournamentServiceGetTournamentStatisticsResponses = {
    /**
     * A successful response.
     */
    200: TournamentGetTournamentStatisticsResponse;
};

export type TournamentServiceGetTournamentStatisticsResponse = TournamentServiceGetTournamentStatisticsResponses[keyof TournamentServiceGetTournamentStatisticsResponses];

export type TournamentServiceGetTournamentPerformanceData = {
    body?: never;
    path: {
        tid: string;
        pid: string;
    };
    query?: never;
    url: '/tournaments/{tid}/performance/{pid}';
};

export type TournamentServiceGetTournamentPerformanceErrors = {
    /**
     * An unexpected error response.
     */
    default: GoogleRpcStatus;
};

export type TournamentServiceGetTournamentPerformanceError = TournamentServiceGetTournamentPerformanceErrors[keyof TournamentServiceGetTournamentPerformanceErrors];

export type TournamentServiceGetTournamentPerformanceResponses = {
    /**
     * A successful response.
     */
    200: TournamentGetTournamentPerformanceResponse;
};

export type TournamentServiceGetTournamentPerformanceResponse = TournamentServiceGetTournamentPerformanceResponses[keyof TournamentServiceGetTournamentPerformanceResponses];

export type TournamentServiceListTournamentsLocationsData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/tournaments:locations';
};

export type TournamentServiceListTournamentsLocationsErrors = {
    /**
     * An unexpected error response.
     */
    default: GoogleRpcStatus;
};

export type TournamentServiceListTournamentsLocationsError = TournamentServiceListTournamentsLocationsErrors[keyof TournamentServiceListTournamentsLocationsErrors];

export type TournamentServiceListTournamentsLocationsResponses = {
    /**
     * A successful response.
     */
    200: TournamentListTournamentsLocationsResponse;
};

export type TournamentServiceListTournamentsLocationsResponse = TournamentServiceListTournamentsLocationsResponses[keyof TournamentServiceListTournamentsLocationsResponses];

export type TournamentServiceGetTournamentsStatisticsData = {
    body?: never;
    path?: never;
    query?: {
        federation?: 'rgf' | 'egf' | 'spt';
        minYear?: number;
        maxYear?: number;
        minAvgRating?: number;
        maxAvgRating?: number;
        minStrength?: number;
        maxStrength?: number;
        ageGroup?: number;
        location?: Array<number>;
        online?: boolean;
        ranked?: boolean;
        handicap?: boolean;
        category?: 'none' | 'local' | 'regional' | 'federal' | 'world' | 'online';
        boardSize?: '9' | '13' | '19';
        teamSize?: '1' | '2' | '3';
    };
    url: '/tournaments:statistics';
};

export type TournamentServiceGetTournamentsStatisticsErrors = {
    /**
     * An unexpected error response.
     */
    default: GoogleRpcStatus;
};

export type TournamentServiceGetTournamentsStatisticsError = TournamentServiceGetTournamentsStatisticsErrors[keyof TournamentServiceGetTournamentsStatisticsErrors];

export type TournamentServiceGetTournamentsStatisticsResponses = {
    /**
     * A successful response.
     */
    200: TournamentGetTournamentsStatisticsResponse;
};

export type TournamentServiceGetTournamentsStatisticsResponse = TournamentServiceGetTournamentsStatisticsResponses[keyof TournamentServiceGetTournamentsStatisticsResponses];

export type FileServiceUploadAvatarData = {
    body: FileUploadFileRequest;
    path?: never;
    query?: never;
    url: '/files/avatars';
};

export type FileServiceUploadAvatarErrors = {
    /**
     * An unexpected error response.
     */
    default: RpcStatus;
};

export type FileServiceUploadAvatarError = FileServiceUploadAvatarErrors[keyof FileServiceUploadAvatarErrors];

export type FileServiceUploadAvatarResponses = {
    /**
     * A successful response.
     */
    200: FileUploadFileResponse;
};

export type FileServiceUploadAvatarResponse = FileServiceUploadAvatarResponses[keyof FileServiceUploadAvatarResponses];

export type FileServiceListAvatarFormatsData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/files/avatars:formats';
};

export type FileServiceListAvatarFormatsErrors = {
    /**
     * An unexpected error response.
     */
    default: RpcStatus;
};

export type FileServiceListAvatarFormatsError = FileServiceListAvatarFormatsErrors[keyof FileServiceListAvatarFormatsErrors];

export type FileServiceListAvatarFormatsResponses = {
    /**
     * A successful response.
     */
    200: FileFormatsResponse;
};

export type FileServiceListAvatarFormatsResponse = FileServiceListAvatarFormatsResponses[keyof FileServiceListAvatarFormatsResponses];

export type FileServiceUploadAvatarSelfData = {
    body: FileUploadFileRequest;
    path?: never;
    query?: never;
    url: '/files/avatars:self';
};

export type FileServiceUploadAvatarSelfErrors = {
    /**
     * An unexpected error response.
     */
    default: RpcStatus;
};

export type FileServiceUploadAvatarSelfError = FileServiceUploadAvatarSelfErrors[keyof FileServiceUploadAvatarSelfErrors];

export type FileServiceUploadAvatarSelfResponses = {
    /**
     * A successful response.
     */
    200: FileUploadFileResponse;
};

export type FileServiceUploadAvatarSelfResponse = FileServiceUploadAvatarSelfResponses[keyof FileServiceUploadAvatarSelfResponses];

export type FileServiceUploadFeedbackData = {
    body: FileUploadFileRequest;
    path?: never;
    query?: never;
    url: '/files/feedback';
};

export type FileServiceUploadFeedbackErrors = {
    /**
     * An unexpected error response.
     */
    default: RpcStatus;
};

export type FileServiceUploadFeedbackError = FileServiceUploadFeedbackErrors[keyof FileServiceUploadFeedbackErrors];

export type FileServiceUploadFeedbackResponses = {
    /**
     * A successful response.
     */
    200: FileUploadFileResponse;
};

export type FileServiceUploadFeedbackResponse = FileServiceUploadFeedbackResponses[keyof FileServiceUploadFeedbackResponses];

export type FileServiceListFeedbackFormatsData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/files/feedback:formats';
};

export type FileServiceListFeedbackFormatsErrors = {
    /**
     * An unexpected error response.
     */
    default: RpcStatus;
};

export type FileServiceListFeedbackFormatsError = FileServiceListFeedbackFormatsErrors[keyof FileServiceListFeedbackFormatsErrors];

export type FileServiceListFeedbackFormatsResponses = {
    /**
     * A successful response.
     */
    200: FileFormatsResponse;
};

export type FileServiceListFeedbackFormatsResponse = FileServiceListFeedbackFormatsResponses[keyof FileServiceListFeedbackFormatsResponses];

export type FileServiceUploadGameRecordNewData = {
    body: FileUploadFileRequest;
    path?: never;
    query?: never;
    url: '/files/games';
};

export type FileServiceUploadGameRecordNewErrors = {
    /**
     * An unexpected error response.
     */
    default: RpcStatus;
};

export type FileServiceUploadGameRecordNewError = FileServiceUploadGameRecordNewErrors[keyof FileServiceUploadGameRecordNewErrors];

export type FileServiceUploadGameRecordNewResponses = {
    /**
     * A successful response.
     */
    200: FileUploadGameRecordResponse;
};

export type FileServiceUploadGameRecordNewResponse = FileServiceUploadGameRecordNewResponses[keyof FileServiceUploadGameRecordNewResponses];

export type FileServiceListGameRecordsData = {
    body?: never;
    path: {
        id: string;
    };
    query?: {
        view?: boolean;
    };
    url: '/files/games/{id}';
};

export type FileServiceListGameRecordsErrors = {
    /**
     * An unexpected error response.
     */
    default: RpcStatus;
};

export type FileServiceListGameRecordsError = FileServiceListGameRecordsErrors[keyof FileServiceListGameRecordsErrors];

export type FileServiceListGameRecordsResponses = {
    /**
     * A successful response.
     */
    200: FileListFilesResponse;
};

export type FileServiceListGameRecordsResponse = FileServiceListGameRecordsResponses[keyof FileServiceListGameRecordsResponses];

export type FileServiceUpdateGameRecordData = {
    body: FileUpdateGameRecord;
    path: {
        id: string;
    };
    query?: never;
    url: '/files/games/{id}';
};

export type FileServiceUpdateGameRecordErrors = {
    /**
     * An unexpected error response.
     */
    default: RpcStatus;
};

export type FileServiceUpdateGameRecordError = FileServiceUpdateGameRecordErrors[keyof FileServiceUpdateGameRecordErrors];

export type FileServiceUpdateGameRecordResponses = {
    /**
     * A successful response.
     */
    200: {
        [key: string]: unknown;
    };
};

export type FileServiceUpdateGameRecordResponse = FileServiceUpdateGameRecordResponses[keyof FileServiceUpdateGameRecordResponses];

export type FileServiceUploadGameRecordData = {
    body: FileUploadFileRequest;
    path: {
        id: string;
    };
    query?: never;
    url: '/files/games/{id}';
};

export type FileServiceUploadGameRecordErrors = {
    /**
     * An unexpected error response.
     */
    default: RpcStatus;
};

export type FileServiceUploadGameRecordError = FileServiceUploadGameRecordErrors[keyof FileServiceUploadGameRecordErrors];

export type FileServiceUploadGameRecordResponses = {
    /**
     * A successful response.
     */
    200: FileUploadGameRecordResponse;
};

export type FileServiceUploadGameRecordResponse = FileServiceUploadGameRecordResponses[keyof FileServiceUploadGameRecordResponses];

export type FileServiceListGameRecordsSelfData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/files/games:self';
};

export type FileServiceListGameRecordsSelfErrors = {
    /**
     * An unexpected error response.
     */
    default: RpcStatus;
};

export type FileServiceListGameRecordsSelfError = FileServiceListGameRecordsSelfErrors[keyof FileServiceListGameRecordsSelfErrors];

export type FileServiceListGameRecordsSelfResponses = {
    /**
     * A successful response.
     */
    200: FileListFilesResponse;
};

export type FileServiceListGameRecordsSelfResponse = FileServiceListGameRecordsSelfResponses[keyof FileServiceListGameRecordsSelfResponses];

export type FileServiceGetGamesStatisticsData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/files/games:statistics';
};

export type FileServiceGetGamesStatisticsErrors = {
    /**
     * An unexpected error response.
     */
    default: RpcStatus;
};

export type FileServiceGetGamesStatisticsError = FileServiceGetGamesStatisticsErrors[keyof FileServiceGetGamesStatisticsErrors];

export type FileServiceGetGamesStatisticsResponses = {
    /**
     * A successful response.
     */
    200: FileGetGamesStatisticsResponse;
};

export type FileServiceGetGamesStatisticsResponse = FileServiceGetGamesStatisticsResponses[keyof FileServiceGetGamesStatisticsResponses];

export type FileServiceUploadImageData = {
    body: FileUploadFileRequest;
    path?: never;
    query?: never;
    url: '/files/images';
};

export type FileServiceUploadImageErrors = {
    /**
     * An unexpected error response.
     */
    default: RpcStatus;
};

export type FileServiceUploadImageError = FileServiceUploadImageErrors[keyof FileServiceUploadImageErrors];

export type FileServiceUploadImageResponses = {
    /**
     * A successful response.
     */
    200: FileUploadFileResponse;
};

export type FileServiceUploadImageResponse = FileServiceUploadImageResponses[keyof FileServiceUploadImageResponses];

export type FileServiceListImageFormatsData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/files/images:formats';
};

export type FileServiceListImageFormatsErrors = {
    /**
     * An unexpected error response.
     */
    default: RpcStatus;
};

export type FileServiceListImageFormatsError = FileServiceListImageFormatsErrors[keyof FileServiceListImageFormatsErrors];

export type FileServiceListImageFormatsResponses = {
    /**
     * A successful response.
     */
    200: FileFormatsResponse;
};

export type FileServiceListImageFormatsResponse = FileServiceListImageFormatsResponses[keyof FileServiceListImageFormatsResponses];

export type FileServiceGameRecordAccessData = {
    body: FileGameRecordAccess;
    path: {
        gid: string;
        userId: string;
    };
    query?: never;
    url: '/files/{gid}/users/{userId}:access';
};

export type FileServiceGameRecordAccessErrors = {
    /**
     * An unexpected error response.
     */
    default: RpcStatus;
};

export type FileServiceGameRecordAccessError = FileServiceGameRecordAccessErrors[keyof FileServiceGameRecordAccessErrors];

export type FileServiceGameRecordAccessResponses = {
    /**
     * A successful response.
     */
    200: {
        [key: string]: unknown;
    };
};

export type FileServiceGameRecordAccessResponse = FileServiceGameRecordAccessResponses[keyof FileServiceGameRecordAccessResponses];

export type FileServiceDeleteFileData = {
    body?: never;
    path: {
        id: string;
    };
    query?: {
        view?: boolean;
    };
    url: '/files/{id}';
};

export type FileServiceDeleteFileErrors = {
    /**
     * An unexpected error response.
     */
    default: RpcStatus;
};

export type FileServiceDeleteFileError = FileServiceDeleteFileErrors[keyof FileServiceDeleteFileErrors];

export type FileServiceDeleteFileResponses = {
    /**
     * A successful response.
     */
    200: {
        [key: string]: unknown;
    };
};

export type FileServiceDeleteFileResponse = FileServiceDeleteFileResponses[keyof FileServiceDeleteFileResponses];

export type FileServiceGetFileData = {
    body?: never;
    path: {
        id: string;
    };
    query?: {
        view?: boolean;
    };
    url: '/files/{id}';
};

export type FileServiceGetFileErrors = {
    /**
     * An unexpected error response.
     */
    default: RpcStatus;
};

export type FileServiceGetFileError = FileServiceGetFileErrors[keyof FileServiceGetFileErrors];

export type FileServiceGetFileResponses = {
    /**
     * A successful response.
     */
    200: ApiHttpBody;
};

export type FileServiceGetFileResponse = FileServiceGetFileResponses[keyof FileServiceGetFileResponses];

export type FileServiceGetFileDetailsData = {
    body?: never;
    path: {
        id: string;
    };
    query?: {
        view?: boolean;
    };
    url: '/files/{id}:details';
};

export type FileServiceGetFileDetailsErrors = {
    /**
     * An unexpected error response.
     */
    default: RpcStatus;
};

export type FileServiceGetFileDetailsError = FileServiceGetFileDetailsErrors[keyof FileServiceGetFileDetailsErrors];

export type FileServiceGetFileDetailsResponses = {
    /**
     * A successful response.
     */
    200: FileSgfDetails;
};

export type FileServiceGetFileDetailsResponse = FileServiceGetFileDetailsResponses[keyof FileServiceGetFileDetailsResponses];

export type FileServiceListFilesSelfData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/files:self';
};

export type FileServiceListFilesSelfErrors = {
    /**
     * An unexpected error response.
     */
    default: RpcStatus;
};

export type FileServiceListFilesSelfError = FileServiceListFilesSelfErrors[keyof FileServiceListFilesSelfErrors];

export type FileServiceListFilesSelfResponses = {
    /**
     * A successful response.
     */
    200: FileListFilesResponse;
};

export type FileServiceListFilesSelfResponse = FileServiceListFilesSelfResponses[keyof FileServiceListFilesSelfResponses];

export type GameServiceListChallengesData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/challenges';
};

export type GameServiceListChallengesErrors = {
    /**
     * An unexpected error response.
     */
    default: RpcStatus;
};

export type GameServiceListChallengesError = GameServiceListChallengesErrors[keyof GameServiceListChallengesErrors];

export type GameServiceListChallengesResponses = {
    /**
     * A successful response.
     */
    200: GameListChallengesResponse;
};

export type GameServiceListChallengesResponse = GameServiceListChallengesResponses[keyof GameServiceListChallengesResponses];

export type GameServicePostChallengeData = {
    body: GamePostChallengeRequest;
    path?: never;
    query?: never;
    url: '/challenges';
};

export type GameServicePostChallengeErrors = {
    /**
     * An unexpected error response.
     */
    default: RpcStatus;
};

export type GameServicePostChallengeError = GameServicePostChallengeErrors[keyof GameServicePostChallengeErrors];

export type GameServicePostChallengeResponses = {
    /**
     * A successful response.
     */
    200: GamePostChallengeResponse;
};

export type GameServicePostChallengeResponse = GameServicePostChallengeResponses[keyof GameServicePostChallengeResponses];

export type GameServiceStreamChallengesData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/challenges/stream';
};

export type GameServiceStreamChallengesErrors = {
    /**
     * An unexpected error response.
     */
    default: RpcStatus;
};

export type GameServiceStreamChallengesError = GameServiceStreamChallengesErrors[keyof GameServiceStreamChallengesErrors];

export type GameServiceStreamChallengesResponses = {
    /**
     * Stream result of gameStreamChallengesResponse
     *
     * A successful response.(streaming responses)
     */
    200: {
        result?: GameStreamChallengesResponse;
        error?: RpcStatus;
    };
};

export type GameServiceStreamChallengesResponse = GameServiceStreamChallengesResponses[keyof GameServiceStreamChallengesResponses];

export type GameServiceCancelChallengeData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/challenges/{id}';
};

export type GameServiceCancelChallengeErrors = {
    /**
     * An unexpected error response.
     */
    default: RpcStatus;
};

export type GameServiceCancelChallengeError = GameServiceCancelChallengeErrors[keyof GameServiceCancelChallengeErrors];

export type GameServiceCancelChallengeResponses = {
    /**
     * A successful response.
     */
    200: {
        [key: string]: unknown;
    };
};

export type GameServiceCancelChallengeResponse = GameServiceCancelChallengeResponses[keyof GameServiceCancelChallengeResponses];

export type GameServiceGetChallengeData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/challenges/{id}';
};

export type GameServiceGetChallengeErrors = {
    /**
     * An unexpected error response.
     */
    default: RpcStatus;
};

export type GameServiceGetChallengeError = GameServiceGetChallengeErrors[keyof GameServiceGetChallengeErrors];

export type GameServiceGetChallengeResponses = {
    /**
     * A successful response.
     */
    200: GameChallenge;
};

export type GameServiceGetChallengeResponse = GameServiceGetChallengeResponses[keyof GameServiceGetChallengeResponses];

export type GameServiceAcceptChallengeData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/challenges/{id}';
};

export type GameServiceAcceptChallengeErrors = {
    /**
     * An unexpected error response.
     */
    default: RpcStatus;
};

export type GameServiceAcceptChallengeError = GameServiceAcceptChallengeErrors[keyof GameServiceAcceptChallengeErrors];

export type GameServiceAcceptChallengeResponses = {
    /**
     * A successful response.
     */
    200: GamePostChallengeResponse;
};

export type GameServiceAcceptChallengeResponse = GameServiceAcceptChallengeResponses[keyof GameServiceAcceptChallengeResponses];

export type GameServiceListChallengesSelfData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/challenges:self';
};

export type GameServiceListChallengesSelfErrors = {
    /**
     * An unexpected error response.
     */
    default: RpcStatus;
};

export type GameServiceListChallengesSelfError = GameServiceListChallengesSelfErrors[keyof GameServiceListChallengesSelfErrors];

export type GameServiceListChallengesSelfResponses = {
    /**
     * A successful response.
     */
    200: GameListChallengesResponse;
};

export type GameServiceListChallengesSelfResponse = GameServiceListChallengesSelfResponses[keyof GameServiceListChallengesSelfResponses];

export type GameServiceListGamesData = {
    body?: never;
    path?: never;
    query?: {
        player1?: string;
        player2?: string;
    };
    url: '/games';
};

export type GameServiceListGamesErrors = {
    /**
     * An unexpected error response.
     */
    default: RpcStatus;
};

export type GameServiceListGamesError = GameServiceListGamesErrors[keyof GameServiceListGamesErrors];

export type GameServiceListGamesResponses = {
    /**
     * A successful response.
     */
    200: GameListGamesResponse;
};

export type GameServiceListGamesResponse = GameServiceListGamesResponses[keyof GameServiceListGamesResponses];

export type GameServiceListGamesCurrentData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/games:current';
};

export type GameServiceListGamesCurrentErrors = {
    /**
     * An unexpected error response.
     */
    default: RpcStatus;
};

export type GameServiceListGamesCurrentError = GameServiceListGamesCurrentErrors[keyof GameServiceListGamesCurrentErrors];

export type GameServiceListGamesCurrentResponses = {
    /**
     * A successful response.
     */
    200: GameListChallengesResponse;
};

export type GameServiceListGamesCurrentResponse = GameServiceListGamesCurrentResponses[keyof GameServiceListGamesCurrentResponses];

export type GameServiceListGamesSelfData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/games:self';
};

export type GameServiceListGamesSelfErrors = {
    /**
     * An unexpected error response.
     */
    default: RpcStatus;
};

export type GameServiceListGamesSelfError = GameServiceListGamesSelfErrors[keyof GameServiceListGamesSelfErrors];

export type GameServiceListGamesSelfResponses = {
    /**
     * A successful response.
     */
    200: GameListGamesResponse;
};

export type GameServiceListGamesSelfResponse = GameServiceListGamesSelfResponses[keyof GameServiceListGamesSelfResponses];

export type GameServiceListChatRoomsData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/server/chat';
};

export type GameServiceListChatRoomsErrors = {
    /**
     * An unexpected error response.
     */
    default: RpcStatus;
};

export type GameServiceListChatRoomsError = GameServiceListChatRoomsErrors[keyof GameServiceListChatRoomsErrors];

export type GameServiceListChatRoomsResponses = {
    /**
     * A successful response.
     */
    200: GameListChatRoomsResponse;
};

export type GameServiceListChatRoomsResponse = GameServiceListChatRoomsResponses[keyof GameServiceListChatRoomsResponses];

export type LogServicePostLogData = {
    body: LogPostLogRequest;
    path?: never;
    query?: never;
    url: '/logs';
};

export type LogServicePostLogErrors = {
    /**
     * An unexpected error response.
     */
    default: RpcStatus;
};

export type LogServicePostLogError = LogServicePostLogErrors[keyof LogServicePostLogErrors];

export type LogServicePostLogResponses = {
    /**
     * A successful response.
     */
    200: {
        [key: string]: unknown;
    };
};

export type LogServicePostLogResponse = LogServicePostLogResponses[keyof LogServicePostLogResponses];

export type LogServiceListNotificationsData = {
    body?: never;
    path?: never;
    query?: {
        showRead?: boolean;
    };
    url: '/notify';
};

export type LogServiceListNotificationsErrors = {
    /**
     * An unexpected error response.
     */
    default: RpcStatus;
};

export type LogServiceListNotificationsError = LogServiceListNotificationsErrors[keyof LogServiceListNotificationsErrors];

export type LogServiceListNotificationsResponses = {
    /**
     * A successful response.
     */
    200: LogListNotificationsResponse;
};

export type LogServiceListNotificationsResponse = LogServiceListNotificationsResponses[keyof LogServiceListNotificationsResponses];

export type LogServiceStreamNotificationsData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/notify/stream';
};

export type LogServiceStreamNotificationsErrors = {
    /**
     * An unexpected error response.
     */
    default: RpcStatus;
};

export type LogServiceStreamNotificationsError = LogServiceStreamNotificationsErrors[keyof LogServiceStreamNotificationsErrors];

export type LogServiceStreamNotificationsResponses = {
    /**
     * Stream result of logEvent
     *
     * A successful response.(streaming responses)
     */
    200: {
        result?: LogEvent;
        error?: RpcStatus;
    };
};

export type LogServiceStreamNotificationsResponse = LogServiceStreamNotificationsResponses[keyof LogServiceStreamNotificationsResponses];

export type LogServiceDeleteNotifyData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/notify/{id}';
};

export type LogServiceDeleteNotifyErrors = {
    /**
     * An unexpected error response.
     */
    default: RpcStatus;
};

export type LogServiceDeleteNotifyError = LogServiceDeleteNotifyErrors[keyof LogServiceDeleteNotifyErrors];

export type LogServiceDeleteNotifyResponses = {
    /**
     * A successful response.
     */
    200: {
        [key: string]: unknown;
    };
};

export type LogServiceDeleteNotifyResponse = LogServiceDeleteNotifyResponses[keyof LogServiceDeleteNotifyResponses];

export type LogServiceReadNotifyData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/notify/{id}';
};

export type LogServiceReadNotifyErrors = {
    /**
     * An unexpected error response.
     */
    default: RpcStatus;
};

export type LogServiceReadNotifyError = LogServiceReadNotifyErrors[keyof LogServiceReadNotifyErrors];

export type LogServiceReadNotifyResponses = {
    /**
     * A successful response.
     */
    200: {
        [key: string]: unknown;
    };
};

export type LogServiceReadNotifyResponse = LogServiceReadNotifyResponses[keyof LogServiceReadNotifyResponses];

export type BroadcastServiceListBroadcastsData = {
    body?: never;
    path?: never;
    query?: {
        tournament?: boolean;
        private?: boolean;
    };
    url: '/broadcasts';
};

export type BroadcastServiceListBroadcastsErrors = {
    /**
     * An unexpected error response.
     */
    default: RpcStatus;
};

export type BroadcastServiceListBroadcastsError = BroadcastServiceListBroadcastsErrors[keyof BroadcastServiceListBroadcastsErrors];

export type BroadcastServiceListBroadcastsResponses = {
    /**
     * A successful response.
     */
    200: BroadcastListBroadcastsResponse;
};

export type BroadcastServiceListBroadcastsResponse = BroadcastServiceListBroadcastsResponses[keyof BroadcastServiceListBroadcastsResponses];

export type BroadcastServicePostBroadcastData = {
    body: BroadcastPostBroadcastRequest;
    path?: never;
    query?: never;
    url: '/broadcasts';
};

export type BroadcastServicePostBroadcastErrors = {
    /**
     * An unexpected error response.
     */
    default: RpcStatus;
};

export type BroadcastServicePostBroadcastError = BroadcastServicePostBroadcastErrors[keyof BroadcastServicePostBroadcastErrors];

export type BroadcastServicePostBroadcastResponses = {
    /**
     * A successful response.
     */
    200: BroadcastPostBroadcastResponse;
};

export type BroadcastServicePostBroadcastResponse = BroadcastServicePostBroadcastResponses[keyof BroadcastServicePostBroadcastResponses];

export type BroadcastServiceBroadcastAccessData = {
    body: BroadcastBroadcastAccess;
    path: {
        bid: string;
        userId: string;
    };
    query?: never;
    url: '/broadcasts/{bid}/users/{userId}:access';
};

export type BroadcastServiceBroadcastAccessErrors = {
    /**
     * An unexpected error response.
     */
    default: RpcStatus;
};

export type BroadcastServiceBroadcastAccessError = BroadcastServiceBroadcastAccessErrors[keyof BroadcastServiceBroadcastAccessErrors];

export type BroadcastServiceBroadcastAccessResponses = {
    /**
     * A successful response.
     */
    200: {
        [key: string]: unknown;
    };
};

export type BroadcastServiceBroadcastAccessResponse = BroadcastServiceBroadcastAccessResponses[keyof BroadcastServiceBroadcastAccessResponses];

export type BroadcastServiceDeleteBroadcastData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/broadcasts/{id}';
};

export type BroadcastServiceDeleteBroadcastErrors = {
    /**
     * An unexpected error response.
     */
    default: RpcStatus;
};

export type BroadcastServiceDeleteBroadcastError = BroadcastServiceDeleteBroadcastErrors[keyof BroadcastServiceDeleteBroadcastErrors];

export type BroadcastServiceDeleteBroadcastResponses = {
    /**
     * A successful response.
     */
    200: {
        [key: string]: unknown;
    };
};

export type BroadcastServiceDeleteBroadcastResponse = BroadcastServiceDeleteBroadcastResponses[keyof BroadcastServiceDeleteBroadcastResponses];

export type BroadcastServiceGetBroadcastData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/broadcasts/{id}';
};

export type BroadcastServiceGetBroadcastErrors = {
    /**
     * An unexpected error response.
     */
    default: RpcStatus;
};

export type BroadcastServiceGetBroadcastError = BroadcastServiceGetBroadcastErrors[keyof BroadcastServiceGetBroadcastErrors];

export type BroadcastServiceGetBroadcastResponses = {
    /**
     * A successful response.
     */
    200: BroadcastBroadcast;
};

export type BroadcastServiceGetBroadcastResponse = BroadcastServiceGetBroadcastResponses[keyof BroadcastServiceGetBroadcastResponses];

export type BroadcastServiceUpdateBroadcastData = {
    body: BroadcastUpdateBroadcast;
    path: {
        id: string;
    };
    query?: never;
    url: '/broadcasts/{id}';
};

export type BroadcastServiceUpdateBroadcastErrors = {
    /**
     * An unexpected error response.
     */
    default: RpcStatus;
};

export type BroadcastServiceUpdateBroadcastError = BroadcastServiceUpdateBroadcastErrors[keyof BroadcastServiceUpdateBroadcastErrors];

export type BroadcastServiceUpdateBroadcastResponses = {
    /**
     * A successful response.
     */
    200: {
        [key: string]: unknown;
    };
};

export type BroadcastServiceUpdateBroadcastResponse = BroadcastServiceUpdateBroadcastResponses[keyof BroadcastServiceUpdateBroadcastResponses];

export type BroadcastServiceGetCommunicationTokenData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/broadcasts/{id}:connect';
};

export type BroadcastServiceGetCommunicationTokenErrors = {
    /**
     * An unexpected error response.
     */
    default: RpcStatus;
};

export type BroadcastServiceGetCommunicationTokenError = BroadcastServiceGetCommunicationTokenErrors[keyof BroadcastServiceGetCommunicationTokenErrors];

export type BroadcastServiceGetCommunicationTokenResponses = {
    /**
     * A successful response.
     */
    200: ChatGetStreamTokenResponse;
};

export type BroadcastServiceGetCommunicationTokenResponse = BroadcastServiceGetCommunicationTokenResponses[keyof BroadcastServiceGetCommunicationTokenResponses];

export type ChatServiceAdminSetArchiveRoomData = {
    body: ChatSetArchive;
    path: {
        rid: string;
    };
    query?: never;
    url: '/admin/chat/rooms/{rid}:archive';
};

export type ChatServiceAdminSetArchiveRoomErrors = {
    /**
     * An unexpected error response.
     */
    default: RpcStatus;
};

export type ChatServiceAdminSetArchiveRoomError = ChatServiceAdminSetArchiveRoomErrors[keyof ChatServiceAdminSetArchiveRoomErrors];

export type ChatServiceAdminSetArchiveRoomResponses = {
    /**
     * A successful response.
     */
    200: {
        [key: string]: unknown;
    };
};

export type ChatServiceAdminSetArchiveRoomResponse = ChatServiceAdminSetArchiveRoomResponses[keyof ChatServiceAdminSetArchiveRoomResponses];

export type ChatServiceAdminCreateSpaceData = {
    body: ChatAdminCreateSpaceRequest;
    path?: never;
    query?: never;
    url: '/admin/chat/spaces';
};

export type ChatServiceAdminCreateSpaceErrors = {
    /**
     * An unexpected error response.
     */
    default: RpcStatus;
};

export type ChatServiceAdminCreateSpaceError = ChatServiceAdminCreateSpaceErrors[keyof ChatServiceAdminCreateSpaceErrors];

export type ChatServiceAdminCreateSpaceResponses = {
    /**
     * A successful response.
     */
    200: ChatSpace;
};

export type ChatServiceAdminCreateSpaceResponse = ChatServiceAdminCreateSpaceResponses[keyof ChatServiceAdminCreateSpaceResponses];

export type ChatServiceAdminCreateRoomData = {
    body: ChatCreateRoomBody;
    path: {
        sid: string;
    };
    query?: never;
    url: '/admin/chat/spaces/{sid}/rooms';
};

export type ChatServiceAdminCreateRoomErrors = {
    /**
     * An unexpected error response.
     */
    default: RpcStatus;
};

export type ChatServiceAdminCreateRoomError = ChatServiceAdminCreateRoomErrors[keyof ChatServiceAdminCreateRoomErrors];

export type ChatServiceAdminCreateRoomResponses = {
    /**
     * A successful response.
     */
    200: ChatRoom;
};

export type ChatServiceAdminCreateRoomResponse = ChatServiceAdminCreateRoomResponses[keyof ChatServiceAdminCreateRoomResponses];

export type ChatServiceListRoomMembersData = {
    body?: never;
    path: {
        rid: string;
    };
    query?: never;
    url: '/chat/rooms/{rid}/members';
};

export type ChatServiceListRoomMembersErrors = {
    /**
     * An unexpected error response.
     */
    default: RpcStatus;
};

export type ChatServiceListRoomMembersError = ChatServiceListRoomMembersErrors[keyof ChatServiceListRoomMembersErrors];

export type ChatServiceListRoomMembersResponses = {
    /**
     * A successful response.
     */
    200: ChatListRoomMembersResponse;
};

export type ChatServiceListRoomMembersResponse = ChatServiceListRoomMembersResponses[keyof ChatServiceListRoomMembersResponses];

export type ChatServiceAdminSetBanRoomMemberData = {
    body: ChatAdminSetBanRoomMember;
    path: {
        rid: string;
        userId: string;
    };
    query?: never;
    url: '/chat/rooms/{rid}/members/{userId}:ban';
};

export type ChatServiceAdminSetBanRoomMemberErrors = {
    /**
     * An unexpected error response.
     */
    default: RpcStatus;
};

export type ChatServiceAdminSetBanRoomMemberError = ChatServiceAdminSetBanRoomMemberErrors[keyof ChatServiceAdminSetBanRoomMemberErrors];

export type ChatServiceAdminSetBanRoomMemberResponses = {
    /**
     * A successful response.
     */
    200: {
        [key: string]: unknown;
    };
};

export type ChatServiceAdminSetBanRoomMemberResponse = ChatServiceAdminSetBanRoomMemberResponses[keyof ChatServiceAdminSetBanRoomMemberResponses];

export type ChatServiceListRoomMessagesData = {
    body?: never;
    path: {
        rid: string;
    };
    query?: {
        from?: string;
        limit?: number;
    };
    url: '/chat/rooms/{rid}/messages';
};

export type ChatServiceListRoomMessagesErrors = {
    /**
     * An unexpected error response.
     */
    default: RpcStatus;
};

export type ChatServiceListRoomMessagesError = ChatServiceListRoomMessagesErrors[keyof ChatServiceListRoomMessagesErrors];

export type ChatServiceListRoomMessagesResponses = {
    /**
     * A successful response.
     */
    200: ChatListRoomMessagesResponse;
};

export type ChatServiceListRoomMessagesResponse = ChatServiceListRoomMessagesResponses[keyof ChatServiceListRoomMessagesResponses];

export type ChatServiceSendRoomMessageData = {
    body: ChatMessageBody;
    path: {
        rid: string;
    };
    query?: never;
    url: '/chat/rooms/{rid}/messages';
};

export type ChatServiceSendRoomMessageErrors = {
    /**
     * An unexpected error response.
     */
    default: RpcStatus;
};

export type ChatServiceSendRoomMessageError = ChatServiceSendRoomMessageErrors[keyof ChatServiceSendRoomMessageErrors];

export type ChatServiceSendRoomMessageResponses = {
    /**
     * A successful response.
     */
    200: ChatSendRoomMessageResponse;
};

export type ChatServiceSendRoomMessageResponse = ChatServiceSendRoomMessageResponses[keyof ChatServiceSendRoomMessageResponses];

export type ChatServiceSendRoomMessageReactionData = {
    body: ChatSendRoomMessageReaction;
    path: {
        rid: string;
        eventId: string;
    };
    query?: never;
    url: '/chat/rooms/{rid}/messages/{eventId}/reactions';
};

export type ChatServiceSendRoomMessageReactionErrors = {
    /**
     * An unexpected error response.
     */
    default: RpcStatus;
};

export type ChatServiceSendRoomMessageReactionError = ChatServiceSendRoomMessageReactionErrors[keyof ChatServiceSendRoomMessageReactionErrors];

export type ChatServiceSendRoomMessageReactionResponses = {
    /**
     * A successful response.
     */
    200: {
        [key: string]: unknown;
    };
};

export type ChatServiceSendRoomMessageReactionResponse = ChatServiceSendRoomMessageReactionResponses[keyof ChatServiceSendRoomMessageReactionResponses];

export type ChatServiceAdminRedactRoomMessageData = {
    body: ChatAdminRedactRoomMessage;
    path: {
        rid: string;
        eventId: string;
    };
    query?: never;
    url: '/chat/rooms/{rid}/messages/{eventId}:redact';
};

export type ChatServiceAdminRedactRoomMessageErrors = {
    /**
     * An unexpected error response.
     */
    default: RpcStatus;
};

export type ChatServiceAdminRedactRoomMessageError = ChatServiceAdminRedactRoomMessageErrors[keyof ChatServiceAdminRedactRoomMessageErrors];

export type ChatServiceAdminRedactRoomMessageResponses = {
    /**
     * A successful response.
     */
    200: {
        [key: string]: unknown;
    };
};

export type ChatServiceAdminRedactRoomMessageResponse = ChatServiceAdminRedactRoomMessageResponses[keyof ChatServiceAdminRedactRoomMessageResponses];

export type ChatServiceStreamRoomEventsData = {
    body?: never;
    path: {
        rid: string;
    };
    query?: never;
    url: '/chat/rooms/{rid}/stream';
};

export type ChatServiceStreamRoomEventsErrors = {
    /**
     * An unexpected error response.
     */
    default: RpcStatus;
};

export type ChatServiceStreamRoomEventsError = ChatServiceStreamRoomEventsErrors[keyof ChatServiceStreamRoomEventsErrors];

export type ChatServiceStreamRoomEventsResponses = {
    /**
     * Stream result of chatRoomEvent
     *
     * A successful response.(streaming responses)
     */
    200: {
        result?: ChatRoomEvent;
        error?: RpcStatus;
    };
};

export type ChatServiceStreamRoomEventsResponse = ChatServiceStreamRoomEventsResponses[keyof ChatServiceStreamRoomEventsResponses];

export type ChatServiceAdminListSpacesData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/chat/spaces';
};

export type ChatServiceAdminListSpacesErrors = {
    /**
     * An unexpected error response.
     */
    default: RpcStatus;
};

export type ChatServiceAdminListSpacesError = ChatServiceAdminListSpacesErrors[keyof ChatServiceAdminListSpacesErrors];

export type ChatServiceAdminListSpacesResponses = {
    /**
     * A successful response.
     */
    200: ChatListSpacesResponse;
};

export type ChatServiceAdminListSpacesResponse = ChatServiceAdminListSpacesResponses[keyof ChatServiceAdminListSpacesResponses];

export type ChatServiceListSpaceRoomsData = {
    body?: never;
    path: {
        sid: string;
    };
    query?: never;
    url: '/chat/spaces/{sid}/rooms';
};

export type ChatServiceListSpaceRoomsErrors = {
    /**
     * An unexpected error response.
     */
    default: RpcStatus;
};

export type ChatServiceListSpaceRoomsError = ChatServiceListSpaceRoomsErrors[keyof ChatServiceListSpaceRoomsErrors];

export type ChatServiceListSpaceRoomsResponses = {
    /**
     * A successful response.
     */
    200: ChatListRoomsResponse;
};

export type ChatServiceListSpaceRoomsResponse = ChatServiceListSpaceRoomsResponses[keyof ChatServiceListSpaceRoomsResponses];

export type RatingServiceListRatingHistoryData = {
    body?: never;
    path: {
        id: string;
    };
    query?: {
        federation?: 'rgf' | 'egf' | 'spt';
    };
    url: '/rating/{id}';
};

export type RatingServiceListRatingHistoryErrors = {
    /**
     * An unexpected error response.
     */
    default: RpcStatus;
};

export type RatingServiceListRatingHistoryError = RatingServiceListRatingHistoryErrors[keyof RatingServiceListRatingHistoryErrors];

export type RatingServiceListRatingHistoryResponses = {
    /**
     * A successful response.
     */
    200: RatingListRatingHistoryResponse;
};

export type RatingServiceListRatingHistoryResponse = RatingServiceListRatingHistoryResponses[keyof RatingServiceListRatingHistoryResponses];

export type RatingServiceGetFormData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/rating/{id}/form';
};

export type RatingServiceGetFormErrors = {
    /**
     * An unexpected error response.
     */
    default: RpcStatus;
};

export type RatingServiceGetFormError = RatingServiceGetFormErrors[keyof RatingServiceGetFormErrors];

export type RatingServiceGetFormResponses = {
    /**
     * A successful response.
     */
    200: RatingForm;
};

export type RatingServiceGetFormResponse = RatingServiceGetFormResponses[keyof RatingServiceGetFormResponses];

export type ServerHubServiceListProvidersData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/hub/providers';
};

export type ServerHubServiceListProvidersErrors = {
    /**
     * An unexpected error response.
     */
    default: RpcStatus;
};

export type ServerHubServiceListProvidersError = ServerHubServiceListProvidersErrors[keyof ServerHubServiceListProvidersErrors];

export type ServerHubServiceListProvidersResponses = {
    /**
     * A successful response.
     */
    200: ServerhubListProvidersResponse;
};

export type ServerHubServiceListProvidersResponse = ServerHubServiceListProvidersResponses[keyof ServerHubServiceListProvidersResponses];

export type ServerHubServiceListChallengesData = {
    body?: never;
    path: {
        providerId: string;
    };
    query?: never;
    url: '/hub/providers/{providerId}/challenges';
};

export type ServerHubServiceListChallengesErrors = {
    /**
     * An unexpected error response.
     */
    default: RpcStatus;
};

export type ServerHubServiceListChallengesError = ServerHubServiceListChallengesErrors[keyof ServerHubServiceListChallengesErrors];

export type ServerHubServiceListChallengesResponses = {
    /**
     * A successful response.
     */
    200: ServerhubListChallengesResponse;
};

export type ServerHubServiceListChallengesResponse = ServerHubServiceListChallengesResponses[keyof ServerHubServiceListChallengesResponses];

export type ServerHubServiceCreateChallengeData = {
    body: ServerHubServiceCreateChallengeBody;
    path: {
        providerId: string;
    };
    query?: never;
    url: '/hub/providers/{providerId}/challenges';
};

export type ServerHubServiceCreateChallengeErrors = {
    /**
     * An unexpected error response.
     */
    default: RpcStatus;
};

export type ServerHubServiceCreateChallengeError = ServerHubServiceCreateChallengeErrors[keyof ServerHubServiceCreateChallengeErrors];

export type ServerHubServiceCreateChallengeResponses = {
    /**
     * A successful response.
     */
    200: ServerhubChallenge;
};

export type ServerHubServiceCreateChallengeResponse = ServerHubServiceCreateChallengeResponses[keyof ServerHubServiceCreateChallengeResponses];

export type ServerHubServiceCancelChallengeData = {
    body?: never;
    path: {
        providerId: string;
        externalChallengeId: string;
    };
    query?: never;
    url: '/hub/providers/{providerId}/challenges/{externalChallengeId}';
};

export type ServerHubServiceCancelChallengeErrors = {
    /**
     * An unexpected error response.
     */
    default: RpcStatus;
};

export type ServerHubServiceCancelChallengeError = ServerHubServiceCancelChallengeErrors[keyof ServerHubServiceCancelChallengeErrors];

export type ServerHubServiceCancelChallengeResponses = {
    /**
     * A successful response.
     */
    200: {
        [key: string]: unknown;
    };
};

export type ServerHubServiceCancelChallengeResponse = ServerHubServiceCancelChallengeResponses[keyof ServerHubServiceCancelChallengeResponses];

export type ServerHubServiceAcceptChallengeData = {
    body: ServerHubServiceAcceptChallengeBody;
    path: {
        providerId: string;
        externalChallengeId: string;
    };
    query?: never;
    url: '/hub/providers/{providerId}/challenges/{externalChallengeId}/accept';
};

export type ServerHubServiceAcceptChallengeErrors = {
    /**
     * An unexpected error response.
     */
    default: RpcStatus;
};

export type ServerHubServiceAcceptChallengeError = ServerHubServiceAcceptChallengeErrors[keyof ServerHubServiceAcceptChallengeErrors];

export type ServerHubServiceAcceptChallengeResponses = {
    /**
     * A successful response.
     */
    200: ServerhubChallenge;
};

export type ServerHubServiceAcceptChallengeResponse = ServerHubServiceAcceptChallengeResponses[keyof ServerHubServiceAcceptChallengeResponses];

export type ServerHubServiceSendGameCommandData = {
    body: ServerHubServiceSendGameCommandBody;
    path: {
        providerId: string;
        externalGameId: string;
    };
    query?: never;
    url: '/hub/providers/{providerId}/games/{externalGameId}/commands';
};

export type ServerHubServiceSendGameCommandErrors = {
    /**
     * An unexpected error response.
     */
    default: RpcStatus;
};

export type ServerHubServiceSendGameCommandError = ServerHubServiceSendGameCommandErrors[keyof ServerHubServiceSendGameCommandErrors];

export type ServerHubServiceSendGameCommandResponses = {
    /**
     * A successful response.
     */
    200: {
        [key: string]: unknown;
    };
};

export type ServerHubServiceSendGameCommandResponse = ServerHubServiceSendGameCommandResponses[keyof ServerHubServiceSendGameCommandResponses];

export type ServerHubServiceGetGameRecordData = {
    body?: never;
    path: {
        providerId: string;
        externalGameId: string;
    };
    query?: never;
    url: '/hub/providers/{providerId}/games/{externalGameId}/record';
};

export type ServerHubServiceGetGameRecordErrors = {
    /**
     * An unexpected error response.
     */
    default: RpcStatus;
};

export type ServerHubServiceGetGameRecordError = ServerHubServiceGetGameRecordErrors[keyof ServerHubServiceGetGameRecordErrors];

export type ServerHubServiceGetGameRecordResponses = {
    /**
     * A successful response.
     */
    200: ServerhubGameRecordResponse;
};

export type ServerHubServiceGetGameRecordResponse = ServerHubServiceGetGameRecordResponses[keyof ServerHubServiceGetGameRecordResponses];

export type ServerHubServiceStreamGameData = {
    body?: never;
    path: {
        providerId: string;
        externalGameId: string;
    };
    query?: never;
    url: '/hub/providers/{providerId}/games/{externalGameId}/stream';
};

export type ServerHubServiceStreamGameErrors = {
    /**
     * An unexpected error response.
     */
    default: RpcStatus;
};

export type ServerHubServiceStreamGameError = ServerHubServiceStreamGameErrors[keyof ServerHubServiceStreamGameErrors];

export type ServerHubServiceStreamGameResponses = {
    /**
     * Stream result of serverhubGameEvent
     *
     * A successful response.(streaming responses)
     */
    200: {
        result?: ServerhubGameEvent;
        error?: RpcStatus;
    };
};

export type ServerHubServiceStreamGameResponse = ServerHubServiceStreamGameResponses[keyof ServerHubServiceStreamGameResponses];

export type ServerHubServiceFindMatchData = {
    body?: never;
    path: {
        providerId: string;
    };
    query?: {
        /**
         * These three lists are parallel: values at the same index form one exact
         * OGS size/speed/time-control option. This query-friendly representation is
         * used because FindMatch is exposed as an EventSource-compatible GET stream.
         */
        'ogs.optionBoardSizes'?: Array<number>;
        'ogs.rules'?: string;
        'ogs.rulesCondition'?: 'MATCHMAKING_PREFERENCE_CONDITION_UNSPECIFIED' | 'MATCHMAKING_PREFERENCE_CONDITION_REQUIRED' | 'MATCHMAKING_PREFERENCE_CONDITION_PREFERRED' | 'MATCHMAKING_PREFERENCE_CONDITION_OPEN';
        'ogs.handicapEnabled'?: boolean;
        'ogs.handicapCondition'?: 'MATCHMAKING_PREFERENCE_CONDITION_UNSPECIFIED' | 'MATCHMAKING_PREFERENCE_CONDITION_REQUIRED' | 'MATCHMAKING_PREFERENCE_CONDITION_PREFERRED' | 'MATCHMAKING_PREFERENCE_CONDITION_OPEN';
        'ogs.lowerRankDifference'?: number;
        'ogs.upperRankDifference'?: number;
        'ogs.optionSpeeds'?: Array<'MATCHMAKING_SPEED_UNSPECIFIED' | 'MATCHMAKING_SPEED_BLITZ' | 'MATCHMAKING_SPEED_RAPID' | 'MATCHMAKING_SPEED_LIVE' | 'MATCHMAKING_SPEED_CORRESPONDENCE'>;
        'ogs.optionTimeControls'?: Array<'MATCHMAKING_TIME_CONTROL_UNSPECIFIED' | 'MATCHMAKING_TIME_CONTROL_FISCHER' | 'MATCHMAKING_TIME_CONTROL_BYOYOMI'>;
        'yike.roleCode'?: string;
        'yike.color'?: 'MATCHMAKING_COLOR_PREFERENCE_UNSPECIFIED' | 'MATCHMAKING_COLOR_PREFERENCE_BLACK' | 'MATCHMAKING_COLOR_PREFERENCE_WHITE' | 'MATCHMAKING_COLOR_PREFERENCE_OPEN';
    };
    url: '/hub/providers/{providerId}/matchmaking';
};

export type ServerHubServiceFindMatchErrors = {
    /**
     * An unexpected error response.
     */
    default: RpcStatus;
};

export type ServerHubServiceFindMatchError = ServerHubServiceFindMatchErrors[keyof ServerHubServiceFindMatchErrors];

export type ServerHubServiceFindMatchResponses = {
    /**
     * Stream result of serverhubMatchmakingEvent
     *
     * A successful response.(streaming responses)
     */
    200: {
        result?: ServerhubMatchmakingEvent;
        error?: RpcStatus;
    };
};

export type ServerHubServiceFindMatchResponse = ServerHubServiceFindMatchResponses[keyof ServerHubServiceFindMatchResponses];

export type ServerHubServiceListMatchmakingOptionsData = {
    body?: never;
    path: {
        providerId: string;
    };
    query?: never;
    url: '/hub/providers/{providerId}/matchmaking/options';
};

export type ServerHubServiceListMatchmakingOptionsErrors = {
    /**
     * An unexpected error response.
     */
    default: RpcStatus;
};

export type ServerHubServiceListMatchmakingOptionsError = ServerHubServiceListMatchmakingOptionsErrors[keyof ServerHubServiceListMatchmakingOptionsErrors];

export type ServerHubServiceListMatchmakingOptionsResponses = {
    /**
     * A successful response.
     */
    200: ServerhubListMatchmakingOptionsResponse;
};

export type ServerHubServiceListMatchmakingOptionsResponse = ServerHubServiceListMatchmakingOptionsResponses[keyof ServerHubServiceListMatchmakingOptionsResponses];

export type ServerHubServiceSearchPlayersData = {
    body?: never;
    path: {
        providerId: string;
    };
    query?: {
        query?: string;
    };
    url: '/hub/providers/{providerId}/players';
};

export type ServerHubServiceSearchPlayersErrors = {
    /**
     * An unexpected error response.
     */
    default: RpcStatus;
};

export type ServerHubServiceSearchPlayersError = ServerHubServiceSearchPlayersErrors[keyof ServerHubServiceSearchPlayersErrors];

export type ServerHubServiceSearchPlayersResponses = {
    /**
     * A successful response.
     */
    200: ServerhubSearchPlayersResponse;
};

export type ServerHubServiceSearchPlayersResponse = ServerHubServiceSearchPlayersResponses[keyof ServerHubServiceSearchPlayersResponses];

export type ClubServiceListClubsData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/clubs';
};

export type ClubServiceListClubsErrors = {
    /**
     * An unexpected error response.
     */
    default: RpcStatus;
};

export type ClubServiceListClubsError = ClubServiceListClubsErrors[keyof ClubServiceListClubsErrors];

export type ClubServiceListClubsResponses = {
    /**
     * A successful response.
     */
    200: ClubListClubsResponse;
};

export type ClubServiceListClubsResponse = ClubServiceListClubsResponses[keyof ClubServiceListClubsResponses];

export type ClubServiceCreateClubData = {
    body: ClubCreateClubRequest;
    path?: never;
    query?: never;
    url: '/clubs';
};

export type ClubServiceCreateClubErrors = {
    /**
     * An unexpected error response.
     */
    default: RpcStatus;
};

export type ClubServiceCreateClubError = ClubServiceCreateClubErrors[keyof ClubServiceCreateClubErrors];

export type ClubServiceCreateClubResponses = {
    /**
     * A successful response.
     */
    200: ClubClub;
};

export type ClubServiceCreateClubResponse = ClubServiceCreateClubResponses[keyof ClubServiceCreateClubResponses];

export type ClubServiceGetClubVoucherInfoData = {
    body?: never;
    path: {
        code: string;
    };
    query?: never;
    url: '/clubs/vouchers/{code}';
};

export type ClubServiceGetClubVoucherInfoErrors = {
    /**
     * An unexpected error response.
     */
    default: RpcStatus;
};

export type ClubServiceGetClubVoucherInfoError = ClubServiceGetClubVoucherInfoErrors[keyof ClubServiceGetClubVoucherInfoErrors];

export type ClubServiceGetClubVoucherInfoResponses = {
    /**
     * A successful response.
     */
    200: ClubVoucherInfo;
};

export type ClubServiceGetClubVoucherInfoResponse = ClubServiceGetClubVoucherInfoResponses[keyof ClubServiceGetClubVoucherInfoResponses];

export type ClubServiceRedeemClubVoucherData = {
    body?: never;
    path: {
        code: string;
    };
    query?: never;
    url: '/clubs/vouchers/{code}:redeem';
};

export type ClubServiceRedeemClubVoucherErrors = {
    /**
     * An unexpected error response.
     */
    default: RpcStatus;
};

export type ClubServiceRedeemClubVoucherError = ClubServiceRedeemClubVoucherErrors[keyof ClubServiceRedeemClubVoucherErrors];

export type ClubServiceRedeemClubVoucherResponses = {
    /**
     * A successful response.
     */
    200: {
        [key: string]: unknown;
    };
};

export type ClubServiceRedeemClubVoucherResponse = ClubServiceRedeemClubVoucherResponses[keyof ClubServiceRedeemClubVoucherResponses];

export type ClubServiceGetClubData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/clubs/{id}';
};

export type ClubServiceGetClubErrors = {
    /**
     * An unexpected error response.
     */
    default: RpcStatus;
};

export type ClubServiceGetClubError = ClubServiceGetClubErrors[keyof ClubServiceGetClubErrors];

export type ClubServiceGetClubResponses = {
    /**
     * A successful response.
     */
    200: ClubClub;
};

export type ClubServiceGetClubResponse = ClubServiceGetClubResponses[keyof ClubServiceGetClubResponses];

export type PollServiceListPollsData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/polls';
};

export type PollServiceListPollsErrors = {
    /**
     * An unexpected error response.
     */
    default: RpcStatus;
};

export type PollServiceListPollsError = PollServiceListPollsErrors[keyof PollServiceListPollsErrors];

export type PollServiceListPollsResponses = {
    /**
     * A successful response.
     */
    200: PollListPollsResponse;
};

export type PollServiceListPollsResponse = PollServiceListPollsResponses[keyof PollServiceListPollsResponses];

export type PollServiceCreatePollData = {
    body: PollCreatePollRequest;
    path?: never;
    query?: never;
    url: '/polls';
};

export type PollServiceCreatePollErrors = {
    /**
     * An unexpected error response.
     */
    default: RpcStatus;
};

export type PollServiceCreatePollError = PollServiceCreatePollErrors[keyof PollServiceCreatePollErrors];

export type PollServiceCreatePollResponses = {
    /**
     * A successful response.
     */
    200: PollCreatePollResponse;
};

export type PollServiceCreatePollResponse = PollServiceCreatePollResponses[keyof PollServiceCreatePollResponses];

export type PollServiceDeletePollData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/polls/{id}';
};

export type PollServiceDeletePollErrors = {
    /**
     * An unexpected error response.
     */
    default: RpcStatus;
};

export type PollServiceDeletePollError = PollServiceDeletePollErrors[keyof PollServiceDeletePollErrors];

export type PollServiceDeletePollResponses = {
    /**
     * A successful response.
     */
    200: {
        [key: string]: unknown;
    };
};

export type PollServiceDeletePollResponse = PollServiceDeletePollResponses[keyof PollServiceDeletePollResponses];

export type PollServiceGetPollData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/polls/{id}';
};

export type PollServiceGetPollErrors = {
    /**
     * An unexpected error response.
     */
    default: RpcStatus;
};

export type PollServiceGetPollError = PollServiceGetPollErrors[keyof PollServiceGetPollErrors];

export type PollServiceGetPollResponses = {
    /**
     * A successful response.
     */
    200: PollPoll;
};

export type PollServiceGetPollResponse = PollServiceGetPollResponses[keyof PollServiceGetPollResponses];

export type PollServiceUpdatePollData = {
    body: PollUpdatePoll;
    path: {
        id: string;
    };
    query?: never;
    url: '/polls/{id}';
};

export type PollServiceUpdatePollErrors = {
    /**
     * An unexpected error response.
     */
    default: RpcStatus;
};

export type PollServiceUpdatePollError = PollServiceUpdatePollErrors[keyof PollServiceUpdatePollErrors];

export type PollServiceUpdatePollResponses = {
    /**
     * A successful response.
     */
    200: {
        [key: string]: unknown;
    };
};

export type PollServiceUpdatePollResponse = PollServiceUpdatePollResponses[keyof PollServiceUpdatePollResponses];

export type PollServiceCastPollVotesData = {
    body: PollCastPollVotes;
    path: {
        id: string;
    };
    query?: never;
    url: '/polls/{id}';
};

export type PollServiceCastPollVotesErrors = {
    /**
     * An unexpected error response.
     */
    default: RpcStatus;
};

export type PollServiceCastPollVotesError = PollServiceCastPollVotesErrors[keyof PollServiceCastPollVotesErrors];

export type PollServiceCastPollVotesResponses = {
    /**
     * A successful response.
     */
    200: {
        [key: string]: unknown;
    };
};

export type PollServiceCastPollVotesResponse = PollServiceCastPollVotesResponses[keyof PollServiceCastPollVotesResponses];

export type PollServiceOrderPollOptionsData = {
    body: PollOrderPollOptions;
    path: {
        pollId: string;
    };
    query?: never;
    url: '/polls/{pollId}/options';
};

export type PollServiceOrderPollOptionsErrors = {
    /**
     * An unexpected error response.
     */
    default: RpcStatus;
};

export type PollServiceOrderPollOptionsError = PollServiceOrderPollOptionsErrors[keyof PollServiceOrderPollOptionsErrors];

export type PollServiceOrderPollOptionsResponses = {
    /**
     * A successful response.
     */
    200: {
        [key: string]: unknown;
    };
};

export type PollServiceOrderPollOptionsResponse = PollServiceOrderPollOptionsResponses[keyof PollServiceOrderPollOptionsResponses];

export type PollServiceAddPollOptionsData = {
    body: PollAddPollOptions;
    path: {
        pollId: string;
    };
    query?: never;
    url: '/polls/{pollId}/options';
};

export type PollServiceAddPollOptionsErrors = {
    /**
     * An unexpected error response.
     */
    default: RpcStatus;
};

export type PollServiceAddPollOptionsError = PollServiceAddPollOptionsErrors[keyof PollServiceAddPollOptionsErrors];

export type PollServiceAddPollOptionsResponses = {
    /**
     * A successful response.
     */
    200: {
        [key: string]: unknown;
    };
};

export type PollServiceAddPollOptionsResponse = PollServiceAddPollOptionsResponses[keyof PollServiceAddPollOptionsResponses];

export type PollServiceDeletePollOptionData = {
    body?: never;
    path: {
        pollId: string;
        optionId: string;
    };
    query?: never;
    url: '/polls/{pollId}/options/{optionId}';
};

export type PollServiceDeletePollOptionErrors = {
    /**
     * An unexpected error response.
     */
    default: RpcStatus;
};

export type PollServiceDeletePollOptionError = PollServiceDeletePollOptionErrors[keyof PollServiceDeletePollOptionErrors];

export type PollServiceDeletePollOptionResponses = {
    /**
     * A successful response.
     */
    200: {
        [key: string]: unknown;
    };
};

export type PollServiceDeletePollOptionResponse = PollServiceDeletePollOptionResponses[keyof PollServiceDeletePollOptionResponses];

export type PollServiceUpdatePollOptionData = {
    body: PollUpdatePollOption;
    path: {
        pollId: string;
        optionId: string;
    };
    query?: never;
    url: '/polls/{pollId}/options/{optionId}';
};

export type PollServiceUpdatePollOptionErrors = {
    /**
     * An unexpected error response.
     */
    default: RpcStatus;
};

export type PollServiceUpdatePollOptionError = PollServiceUpdatePollOptionErrors[keyof PollServiceUpdatePollOptionErrors];

export type PollServiceUpdatePollOptionResponses = {
    /**
     * A successful response.
     */
    200: {
        [key: string]: unknown;
    };
};

export type PollServiceUpdatePollOptionResponse = PollServiceUpdatePollOptionResponses[keyof PollServiceUpdatePollOptionResponses];

export type RefereeServiceListTournamentsData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/referee';
};

export type RefereeServiceListTournamentsErrors = {
    /**
     * An unexpected error response.
     */
    default: GoogleRpcStatus;
};

export type RefereeServiceListTournamentsError = RefereeServiceListTournamentsErrors[keyof RefereeServiceListTournamentsErrors];

export type RefereeServiceListTournamentsResponses = {
    /**
     * A successful response.
     */
    200: RefereeListTournamentsResponse;
};

export type RefereeServiceListTournamentsResponse = RefereeServiceListTournamentsResponses[keyof RefereeServiceListTournamentsResponses];

export type RefereeServiceCreateTournamentData = {
    body: RefereeCreateUpdateTournamentRequest;
    path?: never;
    query?: never;
    url: '/referee';
};

export type RefereeServiceCreateTournamentErrors = {
    /**
     * An unexpected error response.
     */
    default: GoogleRpcStatus;
};

export type RefereeServiceCreateTournamentError = RefereeServiceCreateTournamentErrors[keyof RefereeServiceCreateTournamentErrors];

export type RefereeServiceCreateTournamentResponses = {
    /**
     * A successful response.
     */
    200: RefereeTournament;
};

export type RefereeServiceCreateTournamentResponse = RefereeServiceCreateTournamentResponses[keyof RefereeServiceCreateTournamentResponses];

export type RefereeServiceRegistrationFormFieldsData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/referee/form/fields';
};

export type RefereeServiceRegistrationFormFieldsErrors = {
    /**
     * An unexpected error response.
     */
    default: GoogleRpcStatus;
};

export type RefereeServiceRegistrationFormFieldsError = RefereeServiceRegistrationFormFieldsErrors[keyof RefereeServiceRegistrationFormFieldsErrors];

export type RefereeServiceRegistrationFormFieldsResponses = {
    /**
     * A successful response.
     */
    200: RefereeFields;
};

export type RefereeServiceRegistrationFormFieldsResponse = RefereeServiceRegistrationFormFieldsResponses[keyof RefereeServiceRegistrationFormFieldsResponses];

export type RefereeServiceSeedGroupsTestData = {
    body: RefereeSeedGroupsTestRequest;
    path?: never;
    query?: never;
    url: '/referee/seed/groups';
};

export type RefereeServiceSeedGroupsTestErrors = {
    /**
     * An unexpected error response.
     */
    default: GoogleRpcStatus;
};

export type RefereeServiceSeedGroupsTestError = RefereeServiceSeedGroupsTestErrors[keyof RefereeServiceSeedGroupsTestErrors];

export type RefereeServiceSeedGroupsTestResponses = {
    /**
     * A successful response.
     */
    200: RefereeSeedGroupsTestResponse;
};

export type RefereeServiceSeedGroupsTestResponse = RefereeServiceSeedGroupsTestResponses[keyof RefereeServiceSeedGroupsTestResponses];

export type RefereeServiceSeedRoundsTestData = {
    body: RefereeSeedRoundsTestRequest;
    path?: never;
    query?: never;
    url: '/referee/seed/rounds';
};

export type RefereeServiceSeedRoundsTestErrors = {
    /**
     * An unexpected error response.
     */
    default: GoogleRpcStatus;
};

export type RefereeServiceSeedRoundsTestError = RefereeServiceSeedRoundsTestErrors[keyof RefereeServiceSeedRoundsTestErrors];

export type RefereeServiceSeedRoundsTestResponses = {
    /**
     * A successful response.
     */
    200: RefereeSeedRoundsTestResponse;
};

export type RefereeServiceSeedRoundsTestResponse = RefereeServiceSeedRoundsTestResponses[keyof RefereeServiceSeedRoundsTestResponses];

export type RefereeServiceDeleteTournamentData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/referee/{id}';
};

export type RefereeServiceDeleteTournamentErrors = {
    /**
     * An unexpected error response.
     */
    default: GoogleRpcStatus;
};

export type RefereeServiceDeleteTournamentError = RefereeServiceDeleteTournamentErrors[keyof RefereeServiceDeleteTournamentErrors];

export type RefereeServiceDeleteTournamentResponses = {
    /**
     * A successful response.
     */
    200: {
        [key: string]: unknown;
    };
};

export type RefereeServiceDeleteTournamentResponse = RefereeServiceDeleteTournamentResponses[keyof RefereeServiceDeleteTournamentResponses];

export type RefereeServiceGetTournamentData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/referee/{id}';
};

export type RefereeServiceGetTournamentErrors = {
    /**
     * An unexpected error response.
     */
    default: GoogleRpcStatus;
};

export type RefereeServiceGetTournamentError = RefereeServiceGetTournamentErrors[keyof RefereeServiceGetTournamentErrors];

export type RefereeServiceGetTournamentResponses = {
    /**
     * A successful response.
     */
    200: RefereeTournament;
};

export type RefereeServiceGetTournamentResponse = RefereeServiceGetTournamentResponses[keyof RefereeServiceGetTournamentResponses];

export type RefereeServiceUpdateTournamentData = {
    body: RefereeServiceUpdateTournamentBody;
    path: {
        id: string;
    };
    query?: never;
    url: '/referee/{id}';
};

export type RefereeServiceUpdateTournamentErrors = {
    /**
     * An unexpected error response.
     */
    default: GoogleRpcStatus;
};

export type RefereeServiceUpdateTournamentError = RefereeServiceUpdateTournamentErrors[keyof RefereeServiceUpdateTournamentErrors];

export type RefereeServiceUpdateTournamentResponses = {
    /**
     * A successful response.
     */
    200: RefereeTournament;
};

export type RefereeServiceUpdateTournamentResponse = RefereeServiceUpdateTournamentResponses[keyof RefereeServiceUpdateTournamentResponses];

export type RefereeServiceUpdateRegistrationFormData = {
    body: RefereeServiceUpdateRegistrationFormBody;
    path: {
        id: string;
    };
    query?: never;
    url: '/referee/{id}/form';
};

export type RefereeServiceUpdateRegistrationFormErrors = {
    /**
     * An unexpected error response.
     */
    default: GoogleRpcStatus;
};

export type RefereeServiceUpdateRegistrationFormError = RefereeServiceUpdateRegistrationFormErrors[keyof RefereeServiceUpdateRegistrationFormErrors];

export type RefereeServiceUpdateRegistrationFormResponses = {
    /**
     * A successful response.
     */
    200: RefereeTournament;
};

export type RefereeServiceUpdateRegistrationFormResponse = RefereeServiceUpdateRegistrationFormResponses[keyof RefereeServiceUpdateRegistrationFormResponses];

export type RefereeServiceListParticipantsData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/referee/{id}/participants';
};

export type RefereeServiceListParticipantsErrors = {
    /**
     * An unexpected error response.
     */
    default: GoogleRpcStatus;
};

export type RefereeServiceListParticipantsError = RefereeServiceListParticipantsErrors[keyof RefereeServiceListParticipantsErrors];

export type RefereeServiceListParticipantsResponses = {
    /**
     * A successful response.
     */
    200: RefereeParticipants;
};

export type RefereeServiceListParticipantsResponse = RefereeServiceListParticipantsResponses[keyof RefereeServiceListParticipantsResponses];

export type RefereeServiceCreateParticipantData = {
    body: RefereeServiceCreateParticipantBody;
    path: {
        id: string;
    };
    query?: never;
    url: '/referee/{id}/participants';
};

export type RefereeServiceCreateParticipantErrors = {
    /**
     * An unexpected error response.
     */
    default: GoogleRpcStatus;
};

export type RefereeServiceCreateParticipantError = RefereeServiceCreateParticipantErrors[keyof RefereeServiceCreateParticipantErrors];

export type RefereeServiceCreateParticipantResponses = {
    /**
     * A successful response.
     */
    200: RefereeParticipant;
};

export type RefereeServiceCreateParticipantResponse = RefereeServiceCreateParticipantResponses[keyof RefereeServiceCreateParticipantResponses];

export type RefereeServiceUpdateParticipantData = {
    body: RefereeServiceUpdateParticipantBody;
    path: {
        id: string;
        participantId: string;
    };
    query?: never;
    url: '/referee/{id}/participants/{participantId}';
};

export type RefereeServiceUpdateParticipantErrors = {
    /**
     * An unexpected error response.
     */
    default: GoogleRpcStatus;
};

export type RefereeServiceUpdateParticipantError = RefereeServiceUpdateParticipantErrors[keyof RefereeServiceUpdateParticipantErrors];

export type RefereeServiceUpdateParticipantResponses = {
    /**
     * A successful response.
     */
    200: RefereeParticipant;
};

export type RefereeServiceUpdateParticipantResponse = RefereeServiceUpdateParticipantResponses[keyof RefereeServiceUpdateParticipantResponses];

export type RefereeServiceAddTournamentPersonnelData = {
    body: RefereeServiceAddTournamentPersonnelBody;
    path: {
        id: string;
    };
    query?: never;
    url: '/referee/{id}/personnel';
};

export type RefereeServiceAddTournamentPersonnelErrors = {
    /**
     * An unexpected error response.
     */
    default: GoogleRpcStatus;
};

export type RefereeServiceAddTournamentPersonnelError = RefereeServiceAddTournamentPersonnelErrors[keyof RefereeServiceAddTournamentPersonnelErrors];

export type RefereeServiceAddTournamentPersonnelResponses = {
    /**
     * A successful response.
     */
    200: RefereeTournament;
};

export type RefereeServiceAddTournamentPersonnelResponse = RefereeServiceAddTournamentPersonnelResponses[keyof RefereeServiceAddTournamentPersonnelResponses];

export type RefereeServiceDeletePersonnelData = {
    body?: never;
    path: {
        id: string;
        personnelId: string;
    };
    query?: never;
    url: '/referee/{id}/personnel/{personnelId}';
};

export type RefereeServiceDeletePersonnelErrors = {
    /**
     * An unexpected error response.
     */
    default: GoogleRpcStatus;
};

export type RefereeServiceDeletePersonnelError = RefereeServiceDeletePersonnelErrors[keyof RefereeServiceDeletePersonnelErrors];

export type RefereeServiceDeletePersonnelResponses = {
    /**
     * A successful response.
     */
    200: RefereeTournament;
};

export type RefereeServiceDeletePersonnelResponse = RefereeServiceDeletePersonnelResponses[keyof RefereeServiceDeletePersonnelResponses];

export type RefereeServiceUpdatePersonnelData = {
    body: RefereeServiceUpdatePersonnelBody;
    path: {
        id: string;
        personnelId: string;
    };
    query?: never;
    url: '/referee/{id}/personnel/{personnelId}';
};

export type RefereeServiceUpdatePersonnelErrors = {
    /**
     * An unexpected error response.
     */
    default: GoogleRpcStatus;
};

export type RefereeServiceUpdatePersonnelError = RefereeServiceUpdatePersonnelErrors[keyof RefereeServiceUpdatePersonnelErrors];

export type RefereeServiceUpdatePersonnelResponses = {
    /**
     * A successful response.
     */
    200: RefereeTournament;
};

export type RefereeServiceUpdatePersonnelResponse = RefereeServiceUpdatePersonnelResponses[keyof RefereeServiceUpdatePersonnelResponses];

export type RefereeServiceUpdatePrizeInfoData = {
    body: RefereeServiceUpdatePrizeInfoBody;
    path: {
        id: string;
    };
    query?: never;
    url: '/referee/{id}/prize';
};

export type RefereeServiceUpdatePrizeInfoErrors = {
    /**
     * An unexpected error response.
     */
    default: GoogleRpcStatus;
};

export type RefereeServiceUpdatePrizeInfoError = RefereeServiceUpdatePrizeInfoErrors[keyof RefereeServiceUpdatePrizeInfoErrors];

export type RefereeServiceUpdatePrizeInfoResponses = {
    /**
     * A successful response.
     */
    200: RefereeTournament;
};

export type RefereeServiceUpdatePrizeInfoResponse = RefereeServiceUpdatePrizeInfoResponses[keyof RefereeServiceUpdatePrizeInfoResponses];

export type RefereeServiceAddTournamentStageData = {
    body: RefereeServiceAddTournamentStageBody;
    path: {
        id: string;
    };
    query?: never;
    url: '/referee/{id}/stages';
};

export type RefereeServiceAddTournamentStageErrors = {
    /**
     * An unexpected error response.
     */
    default: GoogleRpcStatus;
};

export type RefereeServiceAddTournamentStageError = RefereeServiceAddTournamentStageErrors[keyof RefereeServiceAddTournamentStageErrors];

export type RefereeServiceAddTournamentStageResponses = {
    /**
     * A successful response.
     */
    200: RefereeTournament;
};

export type RefereeServiceAddTournamentStageResponse = RefereeServiceAddTournamentStageResponses[keyof RefereeServiceAddTournamentStageResponses];

export type RefereeServiceDeleteStageData = {
    body?: never;
    path: {
        id: string;
        stageId: string;
    };
    query?: {
        version?: number;
    };
    url: '/referee/{id}/stages/{stageId}';
};

export type RefereeServiceDeleteStageErrors = {
    /**
     * An unexpected error response.
     */
    default: GoogleRpcStatus;
};

export type RefereeServiceDeleteStageError = RefereeServiceDeleteStageErrors[keyof RefereeServiceDeleteStageErrors];

export type RefereeServiceDeleteStageResponses = {
    /**
     * A successful response.
     */
    200: RefereeTournament;
};

export type RefereeServiceDeleteStageResponse = RefereeServiceDeleteStageResponses[keyof RefereeServiceDeleteStageResponses];

export type RefereeServiceUpdateStageData = {
    body: RefereeServiceUpdateStageBody;
    path: {
        id: string;
        stageId: string;
    };
    query?: never;
    url: '/referee/{id}/stages/{stageId}';
};

export type RefereeServiceUpdateStageErrors = {
    /**
     * An unexpected error response.
     */
    default: GoogleRpcStatus;
};

export type RefereeServiceUpdateStageError = RefereeServiceUpdateStageErrors[keyof RefereeServiceUpdateStageErrors];

export type RefereeServiceUpdateStageResponses = {
    /**
     * A successful response.
     */
    200: RefereeTournament;
};

export type RefereeServiceUpdateStageResponse = RefereeServiceUpdateStageResponses[keyof RefereeServiceUpdateStageResponses];

export type ServerServiceBroadcastBackData = {
    body: ServerServiceBroadcastBackBody;
    path: {
        id: string;
    };
    query?: never;
    url: '/broadcast/{id}/back';
};

export type ServerServiceBroadcastBackErrors = {
    /**
     * An unexpected error response.
     */
    default: RpcStatus;
};

export type ServerServiceBroadcastBackError = ServerServiceBroadcastBackErrors[keyof ServerServiceBroadcastBackErrors];

export type ServerServiceBroadcastBackResponses = {
    /**
     * A successful response.
     */
    200: {
        [key: string]: unknown;
    };
};

export type ServerServiceBroadcastBackResponse = ServerServiceBroadcastBackResponses[keyof ServerServiceBroadcastBackResponses];

export type ServerServiceBroadcastChatData = {
    body: ServerServiceBroadcastChatBody;
    path: {
        id: string;
    };
    query?: never;
    url: '/broadcast/{id}/chat';
};

export type ServerServiceBroadcastChatErrors = {
    /**
     * An unexpected error response.
     */
    default: RpcStatus;
};

export type ServerServiceBroadcastChatError = ServerServiceBroadcastChatErrors[keyof ServerServiceBroadcastChatErrors];

export type ServerServiceBroadcastChatResponses = {
    /**
     * A successful response.
     */
    200: {
        [key: string]: unknown;
    };
};

export type ServerServiceBroadcastChatResponse = ServerServiceBroadcastChatResponses[keyof ServerServiceBroadcastChatResponses];

export type ServerServiceBroadcastCutData = {
    body: ServerServiceBroadcastCutBody;
    path: {
        id: string;
    };
    query?: never;
    url: '/broadcast/{id}/cut';
};

export type ServerServiceBroadcastCutErrors = {
    /**
     * An unexpected error response.
     */
    default: RpcStatus;
};

export type ServerServiceBroadcastCutError = ServerServiceBroadcastCutErrors[keyof ServerServiceBroadcastCutErrors];

export type ServerServiceBroadcastCutResponses = {
    /**
     * A successful response.
     */
    200: {
        [key: string]: unknown;
    };
};

export type ServerServiceBroadcastCutResponse = ServerServiceBroadcastCutResponses[keyof ServerServiceBroadcastCutResponses];

export type ServerServiceBroadcastMoveData = {
    body: ServerServiceBroadcastMoveBody;
    path: {
        id: string;
        move: string;
    };
    query?: never;
    url: '/broadcast/{id}/move/{move}';
};

export type ServerServiceBroadcastMoveErrors = {
    /**
     * An unexpected error response.
     */
    default: RpcStatus;
};

export type ServerServiceBroadcastMoveError = ServerServiceBroadcastMoveErrors[keyof ServerServiceBroadcastMoveErrors];

export type ServerServiceBroadcastMoveResponses = {
    /**
     * A successful response.
     */
    200: {
        [key: string]: unknown;
    };
};

export type ServerServiceBroadcastMoveResponse = ServerServiceBroadcastMoveResponses[keyof ServerServiceBroadcastMoveResponses];

export type ServerServiceBroadcastPassData = {
    body: ServerServiceBroadcastPassBody;
    path: {
        id: string;
        color: string;
    };
    query?: never;
    url: '/broadcast/{id}/pass/{color}';
};

export type ServerServiceBroadcastPassErrors = {
    /**
     * An unexpected error response.
     */
    default: RpcStatus;
};

export type ServerServiceBroadcastPassError = ServerServiceBroadcastPassErrors[keyof ServerServiceBroadcastPassErrors];

export type ServerServiceBroadcastPassResponses = {
    /**
     * A successful response.
     */
    200: {
        [key: string]: unknown;
    };
};

export type ServerServiceBroadcastPassResponse = ServerServiceBroadcastPassResponses[keyof ServerServiceBroadcastPassResponses];

export type ServerServiceBroadcastPruneData = {
    body: ServerServiceBroadcastPruneBody;
    path: {
        id: string;
    };
    query?: never;
    url: '/broadcast/{id}/prune';
};

export type ServerServiceBroadcastPruneErrors = {
    /**
     * An unexpected error response.
     */
    default: RpcStatus;
};

export type ServerServiceBroadcastPruneError = ServerServiceBroadcastPruneErrors[keyof ServerServiceBroadcastPruneErrors];

export type ServerServiceBroadcastPruneResponses = {
    /**
     * A successful response.
     */
    200: {
        [key: string]: unknown;
    };
};

export type ServerServiceBroadcastPruneResponse = ServerServiceBroadcastPruneResponses[keyof ServerServiceBroadcastPruneResponses];

export type ServerServiceBroadcastResultData = {
    body: ServerServiceBroadcastResultBody;
    path: {
        id: string;
    };
    query?: never;
    url: '/broadcast/{id}/result';
};

export type ServerServiceBroadcastResultErrors = {
    /**
     * An unexpected error response.
     */
    default: RpcStatus;
};

export type ServerServiceBroadcastResultError = ServerServiceBroadcastResultErrors[keyof ServerServiceBroadcastResultErrors];

export type ServerServiceBroadcastResultResponses = {
    /**
     * A successful response.
     */
    200: {
        [key: string]: unknown;
    };
};

export type ServerServiceBroadcastResultResponse = ServerServiceBroadcastResultResponses[keyof ServerServiceBroadcastResultResponses];

export type ServerServiceBroadcastSetCurrentNodeData = {
    body: ServerServiceBroadcastSetCurrentNodeBody;
    path: {
        id: string;
        nodeId: number;
    };
    query?: never;
    url: '/broadcast/{id}/set_current_node/{nodeId}';
};

export type ServerServiceBroadcastSetCurrentNodeErrors = {
    /**
     * An unexpected error response.
     */
    default: RpcStatus;
};

export type ServerServiceBroadcastSetCurrentNodeError = ServerServiceBroadcastSetCurrentNodeErrors[keyof ServerServiceBroadcastSetCurrentNodeErrors];

export type ServerServiceBroadcastSetCurrentNodeResponses = {
    /**
     * A successful response.
     */
    200: {
        [key: string]: unknown;
    };
};

export type ServerServiceBroadcastSetCurrentNodeResponse = ServerServiceBroadcastSetCurrentNodeResponses[keyof ServerServiceBroadcastSetCurrentNodeResponses];

export type ServerServiceBroadcastSetNodeMetadataData = {
    body: ServerServiceBroadcastSetNodeMetadataBody;
    path: {
        id: string;
        nodeId: number;
    };
    query?: never;
    url: '/broadcast/{id}/set_node_metadata/{nodeId}';
};

export type ServerServiceBroadcastSetNodeMetadataErrors = {
    /**
     * An unexpected error response.
     */
    default: RpcStatus;
};

export type ServerServiceBroadcastSetNodeMetadataError = ServerServiceBroadcastSetNodeMetadataErrors[keyof ServerServiceBroadcastSetNodeMetadataErrors];

export type ServerServiceBroadcastSetNodeMetadataResponses = {
    /**
     * A successful response.
     */
    200: {
        [key: string]: unknown;
    };
};

export type ServerServiceBroadcastSetNodeMetadataResponse = ServerServiceBroadcastSetNodeMetadataResponses[keyof ServerServiceBroadcastSetNodeMetadataResponses];

export type ServerServiceBroadcastSgfData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/broadcast/{id}/sgf';
};

export type ServerServiceBroadcastSgfErrors = {
    /**
     * An unexpected error response.
     */
    default: RpcStatus;
};

export type ServerServiceBroadcastSgfError = ServerServiceBroadcastSgfErrors[keyof ServerServiceBroadcastSgfErrors];

export type ServerServiceBroadcastSgfResponses = {
    /**
     * A successful response.
     */
    200: ServerSgfResponse;
};

export type ServerServiceBroadcastSgfResponse = ServerServiceBroadcastSgfResponses[keyof ServerServiceBroadcastSgfResponses];

export type ServerServiceBroadcastUploadSgfData = {
    body: ServerServiceBroadcastUploadSgfBody;
    path: {
        id: string;
    };
    query?: never;
    url: '/broadcast/{id}/sgf';
};

export type ServerServiceBroadcastUploadSgfErrors = {
    /**
     * An unexpected error response.
     */
    default: RpcStatus;
};

export type ServerServiceBroadcastUploadSgfError = ServerServiceBroadcastUploadSgfErrors[keyof ServerServiceBroadcastUploadSgfErrors];

export type ServerServiceBroadcastUploadSgfResponses = {
    /**
     * A successful response.
     */
    200: {
        [key: string]: unknown;
    };
};

export type ServerServiceBroadcastUploadSgfResponse = ServerServiceBroadcastUploadSgfResponses[keyof ServerServiceBroadcastUploadSgfResponses];

export type ServerServiceBroadcastUndoData = {
    body: ServerServiceBroadcastUndoBody;
    path: {
        id: string;
    };
    query?: never;
    url: '/broadcast/{id}/undo';
};

export type ServerServiceBroadcastUndoErrors = {
    /**
     * An unexpected error response.
     */
    default: RpcStatus;
};

export type ServerServiceBroadcastUndoError = ServerServiceBroadcastUndoErrors[keyof ServerServiceBroadcastUndoErrors];

export type ServerServiceBroadcastUndoResponses = {
    /**
     * A successful response.
     */
    200: {
        [key: string]: unknown;
    };
};

export type ServerServiceBroadcastUndoResponse = ServerServiceBroadcastUndoResponses[keyof ServerServiceBroadcastUndoResponses];

export type ServerServiceAcceptDeadStonesData = {
    body: ServerServiceAcceptDeadStonesBody;
    path: {
        id: string;
    };
    query?: never;
    url: '/game/{id}/accept_dead_stones';
};

export type ServerServiceAcceptDeadStonesErrors = {
    /**
     * An unexpected error response.
     */
    default: RpcStatus;
};

export type ServerServiceAcceptDeadStonesError = ServerServiceAcceptDeadStonesErrors[keyof ServerServiceAcceptDeadStonesErrors];

export type ServerServiceAcceptDeadStonesResponses = {
    /**
     * A successful response.
     */
    200: {
        [key: string]: unknown;
    };
};

export type ServerServiceAcceptDeadStonesResponse = ServerServiceAcceptDeadStonesResponses[keyof ServerServiceAcceptDeadStonesResponses];

export type ServerServiceAcceptUndoData = {
    body: ServerServiceAcceptUndoBody;
    path: {
        id: string;
    };
    query?: never;
    url: '/game/{id}/accept_undo';
};

export type ServerServiceAcceptUndoErrors = {
    /**
     * An unexpected error response.
     */
    default: RpcStatus;
};

export type ServerServiceAcceptUndoError = ServerServiceAcceptUndoErrors[keyof ServerServiceAcceptUndoErrors];

export type ServerServiceAcceptUndoResponses = {
    /**
     * A successful response.
     */
    200: {
        [key: string]: unknown;
    };
};

export type ServerServiceAcceptUndoResponse = ServerServiceAcceptUndoResponses[keyof ServerServiceAcceptUndoResponses];

export type ServerServiceAiRefereeData = {
    body: ServerServiceAiRefereeBody;
    path: {
        id: string;
    };
    query?: never;
    url: '/game/{id}/ai_referee';
};

export type ServerServiceAiRefereeErrors = {
    /**
     * An unexpected error response.
     */
    default: RpcStatus;
};

export type ServerServiceAiRefereeError = ServerServiceAiRefereeErrors[keyof ServerServiceAiRefereeErrors];

export type ServerServiceAiRefereeResponses = {
    /**
     * A successful response.
     */
    200: {
        [key: string]: unknown;
    };
};

export type ServerServiceAiRefereeResponse = ServerServiceAiRefereeResponses[keyof ServerServiceAiRefereeResponses];

export type ServerServiceGameChatData = {
    body: ServerServiceGameChatBody;
    path: {
        id: string;
    };
    query?: never;
    url: '/game/{id}/chat';
};

export type ServerServiceGameChatErrors = {
    /**
     * An unexpected error response.
     */
    default: RpcStatus;
};

export type ServerServiceGameChatError = ServerServiceGameChatErrors[keyof ServerServiceGameChatErrors];

export type ServerServiceGameChatResponses = {
    /**
     * A successful response.
     */
    200: {
        [key: string]: unknown;
    };
};

export type ServerServiceGameChatResponse = ServerServiceGameChatResponses[keyof ServerServiceGameChatResponses];

export type ServerServiceGameMoveData = {
    body: ServerServiceGameMoveBody;
    path: {
        id: string;
        move: string;
    };
    query?: never;
    url: '/game/{id}/move/{move}';
};

export type ServerServiceGameMoveErrors = {
    /**
     * An unexpected error response.
     */
    default: RpcStatus;
};

export type ServerServiceGameMoveError = ServerServiceGameMoveErrors[keyof ServerServiceGameMoveErrors];

export type ServerServiceGameMoveResponses = {
    /**
     * A successful response.
     */
    200: {
        [key: string]: unknown;
    };
};

export type ServerServiceGameMoveResponse = ServerServiceGameMoveResponses[keyof ServerServiceGameMoveResponses];

export type ServerServiceGamePassData = {
    body: ServerServiceGamePassBody;
    path: {
        id: string;
    };
    query?: never;
    url: '/game/{id}/pass';
};

export type ServerServiceGamePassErrors = {
    /**
     * An unexpected error response.
     */
    default: RpcStatus;
};

export type ServerServiceGamePassError = ServerServiceGamePassErrors[keyof ServerServiceGamePassErrors];

export type ServerServiceGamePassResponses = {
    /**
     * A successful response.
     */
    200: {
        [key: string]: unknown;
    };
};

export type ServerServiceGamePassResponse = ServerServiceGamePassResponses[keyof ServerServiceGamePassResponses];

export type ServerServiceRejectDeadStonesData = {
    body: ServerServiceRejectDeadStonesBody;
    path: {
        id: string;
    };
    query?: never;
    url: '/game/{id}/reject_dead_stones';
};

export type ServerServiceRejectDeadStonesErrors = {
    /**
     * An unexpected error response.
     */
    default: RpcStatus;
};

export type ServerServiceRejectDeadStonesError = ServerServiceRejectDeadStonesErrors[keyof ServerServiceRejectDeadStonesErrors];

export type ServerServiceRejectDeadStonesResponses = {
    /**
     * A successful response.
     */
    200: {
        [key: string]: unknown;
    };
};

export type ServerServiceRejectDeadStonesResponse = ServerServiceRejectDeadStonesResponses[keyof ServerServiceRejectDeadStonesResponses];

export type ServerServiceRejectUndoData = {
    body: ServerServiceRejectUndoBody;
    path: {
        id: string;
    };
    query?: never;
    url: '/game/{id}/reject_undo';
};

export type ServerServiceRejectUndoErrors = {
    /**
     * An unexpected error response.
     */
    default: RpcStatus;
};

export type ServerServiceRejectUndoError = ServerServiceRejectUndoErrors[keyof ServerServiceRejectUndoErrors];

export type ServerServiceRejectUndoResponses = {
    /**
     * A successful response.
     */
    200: {
        [key: string]: unknown;
    };
};

export type ServerServiceRejectUndoResponse = ServerServiceRejectUndoResponses[keyof ServerServiceRejectUndoResponses];

export type ServerServiceRequestUndoData = {
    body: ServerServiceRequestUndoBody;
    path: {
        id: string;
    };
    query?: never;
    url: '/game/{id}/request_undo';
};

export type ServerServiceRequestUndoErrors = {
    /**
     * An unexpected error response.
     */
    default: RpcStatus;
};

export type ServerServiceRequestUndoError = ServerServiceRequestUndoErrors[keyof ServerServiceRequestUndoErrors];

export type ServerServiceRequestUndoResponses = {
    /**
     * A successful response.
     */
    200: {
        [key: string]: unknown;
    };
};

export type ServerServiceRequestUndoResponse = ServerServiceRequestUndoResponses[keyof ServerServiceRequestUndoResponses];

export type ServerServiceGameResignData = {
    body: ServerServiceGameResignBody;
    path: {
        id: string;
    };
    query?: never;
    url: '/game/{id}/resign';
};

export type ServerServiceGameResignErrors = {
    /**
     * An unexpected error response.
     */
    default: RpcStatus;
};

export type ServerServiceGameResignError = ServerServiceGameResignErrors[keyof ServerServiceGameResignErrors];

export type ServerServiceGameResignResponses = {
    /**
     * A successful response.
     */
    200: {
        [key: string]: unknown;
    };
};

export type ServerServiceGameResignResponse = ServerServiceGameResignResponses[keyof ServerServiceGameResignResponses];

export type ServerServiceGameSgfData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/game/{id}/sgf';
};

export type ServerServiceGameSgfErrors = {
    /**
     * An unexpected error response.
     */
    default: RpcStatus;
};

export type ServerServiceGameSgfError = ServerServiceGameSgfErrors[keyof ServerServiceGameSgfErrors];

export type ServerServiceGameSgfResponses = {
    /**
     * A successful response.
     */
    200: ServerSgfResponse;
};

export type ServerServiceGameSgfResponse = ServerServiceGameSgfResponses[keyof ServerServiceGameSgfResponses];

export type ServerServiceToggleDeadStonesData = {
    body: ServerServiceToggleDeadStonesBody;
    path: {
        id: string;
        move: string;
    };
    query?: never;
    url: '/game/{id}/toggle_dead_stones/{move}';
};

export type ServerServiceToggleDeadStonesErrors = {
    /**
     * An unexpected error response.
     */
    default: RpcStatus;
};

export type ServerServiceToggleDeadStonesError = ServerServiceToggleDeadStonesErrors[keyof ServerServiceToggleDeadStonesErrors];

export type ServerServiceToggleDeadStonesResponses = {
    /**
     * A successful response.
     */
    200: {
        [key: string]: unknown;
    };
};

export type ServerServiceToggleDeadStonesResponse = ServerServiceToggleDeadStonesResponses[keyof ServerServiceToggleDeadStonesResponses];

export type ServerServiceStreamBroadcastData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/stream/broadcast/{id}';
};

export type ServerServiceStreamBroadcastErrors = {
    /**
     * An unexpected error response.
     */
    default: RpcStatus;
};

export type ServerServiceStreamBroadcastError = ServerServiceStreamBroadcastErrors[keyof ServerServiceStreamBroadcastErrors];

export type ServerServiceStreamBroadcastResponses = {
    /**
     * Stream result of serverBroadcastEvent
     *
     * A successful response.(streaming responses)
     */
    200: {
        result?: ServerBroadcastEvent;
        error?: RpcStatus;
    };
};

export type ServerServiceStreamBroadcastResponse = ServerServiceStreamBroadcastResponses[keyof ServerServiceStreamBroadcastResponses];

export type ServerServiceStreamGameData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/stream/game/{id}';
};

export type ServerServiceStreamGameErrors = {
    /**
     * An unexpected error response.
     */
    default: RpcStatus;
};

export type ServerServiceStreamGameError = ServerServiceStreamGameErrors[keyof ServerServiceStreamGameErrors];

export type ServerServiceStreamGameResponses = {
    /**
     * Stream result of serverGameEvent
     *
     * A successful response.(streaming responses)
     */
    200: {
        result?: ServerGameEvent;
        error?: RpcStatus;
    };
};

export type ServerServiceStreamGameResponse = ServerServiceStreamGameResponses[keyof ServerServiceStreamGameResponses];

export type PlayerServiceListPlayersData = {
    body?: never;
    path?: never;
    query?: {
        name?: Array<string>;
        rating?: Array<number>;
        location?: Array<number>;
        sort?: Array<'name' | 'rating' | 'last_update'>;
        order?: Array<'asc' | 'desc'>;
        limit?: number;
        offset?: number;
        minRating?: number;
        maxRating?: number;
    };
    url: '/players';
};

export type PlayerServiceListPlayersErrors = {
    /**
     * An unexpected error response.
     */
    default: RpcStatus;
};

export type PlayerServiceListPlayersError = PlayerServiceListPlayersErrors[keyof PlayerServiceListPlayersErrors];

export type PlayerServiceListPlayersResponses = {
    /**
     * A successful response.
     */
    200: PlayerListPlayersResponse;
};

export type PlayerServiceListPlayersResponse = PlayerServiceListPlayersResponses[keyof PlayerServiceListPlayersResponses];

export type PlayerServiceGetPlayerData = {
    body?: never;
    path: {
        id: string;
    };
    query?: {
        federation?: 'rgf' | 'egf' | 'spt';
    };
    url: '/players/{id}';
};

export type PlayerServiceGetPlayerErrors = {
    /**
     * An unexpected error response.
     */
    default: RpcStatus;
};

export type PlayerServiceGetPlayerError = PlayerServiceGetPlayerErrors[keyof PlayerServiceGetPlayerErrors];

export type PlayerServiceGetPlayerResponses = {
    /**
     * A successful response.
     */
    200: PlayerPlayer;
};

export type PlayerServiceGetPlayerResponse = PlayerServiceGetPlayerResponses[keyof PlayerServiceGetPlayerResponses];

export type PlayerServiceListPlayerRatingData = {
    body?: never;
    path: {
        id: string;
    };
    query?: {
        federation?: 'rgf' | 'egf' | 'spt';
    };
    url: '/players/{id}/rating';
};

export type PlayerServiceListPlayerRatingErrors = {
    /**
     * An unexpected error response.
     */
    default: RpcStatus;
};

export type PlayerServiceListPlayerRatingError = PlayerServiceListPlayerRatingErrors[keyof PlayerServiceListPlayerRatingErrors];

export type PlayerServiceListPlayerRatingResponses = {
    /**
     * A successful response.
     */
    200: PlayerListPlayerRatingResponse;
};

export type PlayerServiceListPlayerRatingResponse = PlayerServiceListPlayerRatingResponses[keyof PlayerServiceListPlayerRatingResponses];

export type PlayerServiceListPlayerTournamentsData = {
    body?: never;
    path: {
        id: string;
    };
    query?: {
        federation?: 'rgf' | 'egf' | 'spt';
    };
    url: '/players/{id}/tournaments';
};

export type PlayerServiceListPlayerTournamentsErrors = {
    /**
     * An unexpected error response.
     */
    default: RpcStatus;
};

export type PlayerServiceListPlayerTournamentsError = PlayerServiceListPlayerTournamentsErrors[keyof PlayerServiceListPlayerTournamentsErrors];

export type PlayerServiceListPlayerTournamentsResponses = {
    /**
     * A successful response.
     */
    200: PlayerListPlayerTournamentsResponse;
};

export type PlayerServiceListPlayerTournamentsResponse = PlayerServiceListPlayerTournamentsResponses[keyof PlayerServiceListPlayerTournamentsResponses];

export type PlayerServiceListPlayersLocationsData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/players:locations';
};

export type PlayerServiceListPlayersLocationsErrors = {
    /**
     * An unexpected error response.
     */
    default: RpcStatus;
};

export type PlayerServiceListPlayersLocationsError = PlayerServiceListPlayersLocationsErrors[keyof PlayerServiceListPlayersLocationsErrors];

export type PlayerServiceListPlayersLocationsResponses = {
    /**
     * A successful response.
     */
    200: PlayerListPlayersLocationsResponse;
};

export type PlayerServiceListPlayersLocationsResponse = PlayerServiceListPlayersLocationsResponses[keyof PlayerServiceListPlayersLocationsResponses];

export type PlayerServiceGetPlayersStatisticsData = {
    body?: never;
    path?: never;
    query?: {
        federation?: 'rgf' | 'egf' | 'spt';
        minYear?: number;
        maxYear?: number;
        minRating?: number;
        maxRating?: number;
        minExp?: number;
        maxExp?: number;
        ageGroup?: number;
        location?: Array<number>;
    };
    url: '/players:statistics';
};

export type PlayerServiceGetPlayersStatisticsErrors = {
    /**
     * An unexpected error response.
     */
    default: RpcStatus;
};

export type PlayerServiceGetPlayersStatisticsError = PlayerServiceGetPlayersStatisticsErrors[keyof PlayerServiceGetPlayersStatisticsErrors];

export type PlayerServiceGetPlayersStatisticsResponses = {
    /**
     * A successful response.
     */
    200: PlayerGetPlayersStatisticsResponse;
};

export type PlayerServiceGetPlayersStatisticsResponse = PlayerServiceGetPlayersStatisticsResponses[keyof PlayerServiceGetPlayersStatisticsResponses];

export type StudyServiceListCoachesData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/coaches';
};

export type StudyServiceListCoachesErrors = {
    /**
     * An unexpected error response.
     */
    default: RpcStatus;
};

export type StudyServiceListCoachesError = StudyServiceListCoachesErrors[keyof StudyServiceListCoachesErrors];

export type StudyServiceListCoachesResponses = {
    /**
     * A successful response.
     */
    200: StudyListCoachesResponse;
};

export type StudyServiceListCoachesResponse = StudyServiceListCoachesResponses[keyof StudyServiceListCoachesResponses];

export type StudyServiceCreateCoachData = {
    body: StudyCreateUpdateCoachRequest;
    path?: never;
    query?: never;
    url: '/coaches';
};

export type StudyServiceCreateCoachErrors = {
    /**
     * An unexpected error response.
     */
    default: RpcStatus;
};

export type StudyServiceCreateCoachError = StudyServiceCreateCoachErrors[keyof StudyServiceCreateCoachErrors];

export type StudyServiceCreateCoachResponses = {
    /**
     * A successful response.
     */
    200: StudyCoach;
};

export type StudyServiceCreateCoachResponse = StudyServiceCreateCoachResponses[keyof StudyServiceCreateCoachResponses];

export type StudyServiceDeleteCoachData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/coaches/{id}';
};

export type StudyServiceDeleteCoachErrors = {
    /**
     * An unexpected error response.
     */
    default: RpcStatus;
};

export type StudyServiceDeleteCoachError = StudyServiceDeleteCoachErrors[keyof StudyServiceDeleteCoachErrors];

export type StudyServiceDeleteCoachResponses = {
    /**
     * A successful response.
     */
    200: {
        [key: string]: unknown;
    };
};

export type StudyServiceDeleteCoachResponse = StudyServiceDeleteCoachResponses[keyof StudyServiceDeleteCoachResponses];

export type StudyServiceGetCoachData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/coaches/{id}';
};

export type StudyServiceGetCoachErrors = {
    /**
     * An unexpected error response.
     */
    default: RpcStatus;
};

export type StudyServiceGetCoachError = StudyServiceGetCoachErrors[keyof StudyServiceGetCoachErrors];

export type StudyServiceGetCoachResponses = {
    /**
     * A successful response.
     */
    200: StudyCoach;
};

export type StudyServiceGetCoachResponse = StudyServiceGetCoachResponses[keyof StudyServiceGetCoachResponses];

export type StudyServiceUpdateCoachData = {
    body: StudyServiceUpdateCoachBody;
    path: {
        id: string;
    };
    query?: never;
    url: '/coaches/{id}';
};

export type StudyServiceUpdateCoachErrors = {
    /**
     * An unexpected error response.
     */
    default: RpcStatus;
};

export type StudyServiceUpdateCoachError = StudyServiceUpdateCoachErrors[keyof StudyServiceUpdateCoachErrors];

export type StudyServiceUpdateCoachResponses = {
    /**
     * A successful response.
     */
    200: StudyCoach;
};

export type StudyServiceUpdateCoachResponse = StudyServiceUpdateCoachResponses[keyof StudyServiceUpdateCoachResponses];

export type StudyServiceListProductsData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/products';
};

export type StudyServiceListProductsErrors = {
    /**
     * An unexpected error response.
     */
    default: RpcStatus;
};

export type StudyServiceListProductsError = StudyServiceListProductsErrors[keyof StudyServiceListProductsErrors];

export type StudyServiceListProductsResponses = {
    /**
     * A successful response.
     */
    200: StudyListProductsResponse;
};

export type StudyServiceListProductsResponse = StudyServiceListProductsResponses[keyof StudyServiceListProductsResponses];

export type StudyServiceCreateProductData = {
    body: StudyCreateUpdateProductRequest;
    path?: never;
    query?: never;
    url: '/products';
};

export type StudyServiceCreateProductErrors = {
    /**
     * An unexpected error response.
     */
    default: RpcStatus;
};

export type StudyServiceCreateProductError = StudyServiceCreateProductErrors[keyof StudyServiceCreateProductErrors];

export type StudyServiceCreateProductResponses = {
    /**
     * A successful response.
     */
    200: StudyProduct;
};

export type StudyServiceCreateProductResponse = StudyServiceCreateProductResponses[keyof StudyServiceCreateProductResponses];

export type StudyServiceRemoveParticipantData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/products/participants/{id}';
};

export type StudyServiceRemoveParticipantErrors = {
    /**
     * An unexpected error response.
     */
    default: RpcStatus;
};

export type StudyServiceRemoveParticipantError = StudyServiceRemoveParticipantErrors[keyof StudyServiceRemoveParticipantErrors];

export type StudyServiceRemoveParticipantResponses = {
    /**
     * A successful response.
     */
    200: {
        [key: string]: unknown;
    };
};

export type StudyServiceRemoveParticipantResponse = StudyServiceRemoveParticipantResponses[keyof StudyServiceRemoveParticipantResponses];

export type StudyServiceDeleteProductData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/products/{id}';
};

export type StudyServiceDeleteProductErrors = {
    /**
     * An unexpected error response.
     */
    default: RpcStatus;
};

export type StudyServiceDeleteProductError = StudyServiceDeleteProductErrors[keyof StudyServiceDeleteProductErrors];

export type StudyServiceDeleteProductResponses = {
    /**
     * A successful response.
     */
    200: {
        [key: string]: unknown;
    };
};

export type StudyServiceDeleteProductResponse = StudyServiceDeleteProductResponses[keyof StudyServiceDeleteProductResponses];

export type StudyServiceGetProductData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/products/{id}';
};

export type StudyServiceGetProductErrors = {
    /**
     * An unexpected error response.
     */
    default: RpcStatus;
};

export type StudyServiceGetProductError = StudyServiceGetProductErrors[keyof StudyServiceGetProductErrors];

export type StudyServiceGetProductResponses = {
    /**
     * A successful response.
     */
    200: StudyProduct;
};

export type StudyServiceGetProductResponse = StudyServiceGetProductResponses[keyof StudyServiceGetProductResponses];

export type StudyServiceUpdateProductData = {
    body: StudyServiceUpdateProductBody;
    path: {
        id: string;
    };
    query?: never;
    url: '/products/{id}';
};

export type StudyServiceUpdateProductErrors = {
    /**
     * An unexpected error response.
     */
    default: RpcStatus;
};

export type StudyServiceUpdateProductError = StudyServiceUpdateProductErrors[keyof StudyServiceUpdateProductErrors];

export type StudyServiceUpdateProductResponses = {
    /**
     * A successful response.
     */
    200: StudyProduct;
};

export type StudyServiceUpdateProductResponse = StudyServiceUpdateProductResponses[keyof StudyServiceUpdateProductResponses];

export type StudyServiceApplyParticipantData = {
    body: StudyServiceApplyParticipantBody;
    path: {
        id: string;
    };
    query?: never;
    url: '/products/{id}/apply';
};

export type StudyServiceApplyParticipantErrors = {
    /**
     * An unexpected error response.
     */
    default: RpcStatus;
};

export type StudyServiceApplyParticipantError = StudyServiceApplyParticipantErrors[keyof StudyServiceApplyParticipantErrors];

export type StudyServiceApplyParticipantResponses = {
    /**
     * A successful response.
     */
    200: StudyParticipant;
};

export type StudyServiceApplyParticipantResponse = StudyServiceApplyParticipantResponses[keyof StudyServiceApplyParticipantResponses];

export type AuthServiceActivateData = {
    body?: never;
    path: {
        code: string;
    };
    query?: never;
    url: '/activate/{code}';
};

export type AuthServiceActivateErrors = {
    /**
     * An unexpected error response.
     */
    default: RpcStatus;
};

export type AuthServiceActivateError = AuthServiceActivateErrors[keyof AuthServiceActivateErrors];

export type AuthServiceActivateResponses = {
    /**
     * A successful response.
     */
    200: {
        [key: string]: unknown;
    };
};

export type AuthServiceActivateResponse = AuthServiceActivateResponses[keyof AuthServiceActivateResponses];

export type AuthServiceListLinkedAccountsData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/auth/links';
};

export type AuthServiceListLinkedAccountsErrors = {
    /**
     * An unexpected error response.
     */
    default: RpcStatus;
};

export type AuthServiceListLinkedAccountsError = AuthServiceListLinkedAccountsErrors[keyof AuthServiceListLinkedAccountsErrors];

export type AuthServiceListLinkedAccountsResponses = {
    /**
     * A successful response.
     */
    200: AuthListLinkedAccountsResponse;
};

export type AuthServiceListLinkedAccountsResponse = AuthServiceListLinkedAccountsResponses[keyof AuthServiceListLinkedAccountsResponses];

export type AuthServiceCompleteAccountLinkData = {
    body?: never;
    path?: never;
    query?: {
        state?: string;
        code?: string;
        error?: string;
        errorDescription?: string;
    };
    url: '/auth/links/oauth/callback';
};

export type AuthServiceCompleteAccountLinkErrors = {
    /**
     * An unexpected error response.
     */
    default: RpcStatus;
};

export type AuthServiceCompleteAccountLinkError = AuthServiceCompleteAccountLinkErrors[keyof AuthServiceCompleteAccountLinkErrors];

export type AuthServiceCompleteAccountLinkResponses = {
    /**
     * A successful response.
     */
    200: {
        [key: string]: unknown;
    };
};

export type AuthServiceCompleteAccountLinkResponse = AuthServiceCompleteAccountLinkResponses[keyof AuthServiceCompleteAccountLinkResponses];

export type AuthServiceUnlinkAccountData = {
    body?: never;
    path: {
        federation: string;
    };
    query?: never;
    url: '/auth/links/{federation}';
};

export type AuthServiceUnlinkAccountErrors = {
    /**
     * An unexpected error response.
     */
    default: RpcStatus;
};

export type AuthServiceUnlinkAccountError = AuthServiceUnlinkAccountErrors[keyof AuthServiceUnlinkAccountErrors];

export type AuthServiceUnlinkAccountResponses = {
    /**
     * A successful response.
     */
    200: {
        [key: string]: unknown;
    };
};

export type AuthServiceUnlinkAccountResponse = AuthServiceUnlinkAccountResponses[keyof AuthServiceUnlinkAccountResponses];

export type AuthServiceGetLinkedAccountData = {
    body?: never;
    path: {
        federation: string;
    };
    query?: never;
    url: '/auth/links/{federation}';
};

export type AuthServiceGetLinkedAccountErrors = {
    /**
     * An unexpected error response.
     */
    default: RpcStatus;
};

export type AuthServiceGetLinkedAccountError = AuthServiceGetLinkedAccountErrors[keyof AuthServiceGetLinkedAccountErrors];

export type AuthServiceGetLinkedAccountResponses = {
    /**
     * A successful response.
     */
    200: AuthLinkedAccount;
};

export type AuthServiceGetLinkedAccountResponse = AuthServiceGetLinkedAccountResponses[keyof AuthServiceGetLinkedAccountResponses];

export type AuthServiceStartAccountLinkData = {
    body: AuthServiceStartAccountLinkBody;
    path: {
        federation: string;
    };
    query?: never;
    url: '/auth/links/{federation}';
};

export type AuthServiceStartAccountLinkErrors = {
    /**
     * An unexpected error response.
     */
    default: RpcStatus;
};

export type AuthServiceStartAccountLinkError = AuthServiceStartAccountLinkErrors[keyof AuthServiceStartAccountLinkErrors];

export type AuthServiceStartAccountLinkResponses = {
    /**
     * A successful response.
     */
    200: AuthStartAccountLinkResponse;
};

export type AuthServiceStartAccountLinkResponse = AuthServiceStartAccountLinkResponses[keyof AuthServiceStartAccountLinkResponses];

export type AuthServiceRefreshLinkedAccountCredentialsData = {
    body: AuthServiceRefreshLinkedAccountCredentialsBody;
    path: {
        federation: string;
    };
    query?: never;
    url: '/auth/links/{federation}/refresh';
};

export type AuthServiceRefreshLinkedAccountCredentialsErrors = {
    /**
     * An unexpected error response.
     */
    default: RpcStatus;
};

export type AuthServiceRefreshLinkedAccountCredentialsError = AuthServiceRefreshLinkedAccountCredentialsErrors[keyof AuthServiceRefreshLinkedAccountCredentialsErrors];

export type AuthServiceRefreshLinkedAccountCredentialsResponses = {
    /**
     * A successful response.
     */
    200: {
        [key: string]: unknown;
    };
};

export type AuthServiceRefreshLinkedAccountCredentialsResponse = AuthServiceRefreshLinkedAccountCredentialsResponses[keyof AuthServiceRefreshLinkedAccountCredentialsResponses];

export type AuthServiceAuthUnlinkData = {
    body?: never;
    path: {
        provider: string;
    };
    query?: never;
    url: '/auth/{provider}';
};

export type AuthServiceAuthUnlinkErrors = {
    /**
     * An unexpected error response.
     */
    default: RpcStatus;
};

export type AuthServiceAuthUnlinkError = AuthServiceAuthUnlinkErrors[keyof AuthServiceAuthUnlinkErrors];

export type AuthServiceAuthUnlinkResponses = {
    /**
     * A successful response.
     */
    200: {
        [key: string]: unknown;
    };
};

export type AuthServiceAuthUnlinkResponse = AuthServiceAuthUnlinkResponses[keyof AuthServiceAuthUnlinkResponses];

export type AuthServiceAuthData = {
    body?: never;
    path: {
        provider: string;
    };
    query?: {
        state?: string;
    };
    url: '/auth/{provider}';
};

export type AuthServiceAuthErrors = {
    /**
     * An unexpected error response.
     */
    default: RpcStatus;
};

export type AuthServiceAuthError = AuthServiceAuthErrors[keyof AuthServiceAuthErrors];

export type AuthServiceAuthResponses = {
    /**
     * A successful response.
     */
    200: {
        [key: string]: unknown;
    };
};

export type AuthServiceAuthResponse = AuthServiceAuthResponses[keyof AuthServiceAuthResponses];

export type AuthServiceLoginData = {
    body: AuthLoginRequest;
    path?: never;
    query?: never;
    url: '/login';
};

export type AuthServiceLoginErrors = {
    /**
     * An unexpected error response.
     */
    default: RpcStatus;
};

export type AuthServiceLoginError = AuthServiceLoginErrors[keyof AuthServiceLoginErrors];

export type AuthServiceLoginResponses = {
    /**
     * A successful response.
     */
    200: AuthLoginResponse;
};

export type AuthServiceLoginResponse = AuthServiceLoginResponses[keyof AuthServiceLoginResponses];

export type AuthServiceLogoutData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/logout';
};

export type AuthServiceLogoutErrors = {
    /**
     * An unexpected error response.
     */
    default: RpcStatus;
};

export type AuthServiceLogoutError = AuthServiceLogoutErrors[keyof AuthServiceLogoutErrors];

export type AuthServiceLogoutResponses = {
    /**
     * A successful response.
     */
    200: {
        [key: string]: unknown;
    };
};

export type AuthServiceLogoutResponse = AuthServiceLogoutResponses[keyof AuthServiceLogoutResponses];

export type AuthServiceRegisterData = {
    body: AuthRegisterRequest;
    path?: never;
    query?: never;
    url: '/register';
};

export type AuthServiceRegisterErrors = {
    /**
     * An unexpected error response.
     */
    default: RpcStatus;
};

export type AuthServiceRegisterError = AuthServiceRegisterErrors[keyof AuthServiceRegisterErrors];

export type AuthServiceRegisterResponses = {
    /**
     * A successful response.
     */
    200: AuthRegisterResponse;
};

export type AuthServiceRegisterResponse = AuthServiceRegisterResponses[keyof AuthServiceRegisterResponses];
